import { ICustomDate, IResizableImage } from './';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  DateTime: { input: Date; output: Date; }
  DateTimeFromTz: { input: Date; output: Date; }
  DateTimeToTz: { input: ICustomDate; output: ICustomDate; }
  EnumLabel: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Mixed: { input: any; output: any; }
  ResizableImage: { input: IResizableImage; output: IResizableImage; }
  Time: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export const enum AccountWithoutRegistrationRequiredFieldsEnum {
  /** EMAIL */
  Email = 'EMAIL',
  /** EMAIL_AND_PHONE */
  EmailAndPhone = 'EMAIL_AND_PHONE',
  /** PHONE */
  Phone = 'PHONE'
};

export type Activity = {
  readonly __typename?: 'Activity';
  readonly batch_uuid?: Maybe<Scalars['String']['output']>;
  readonly causer?: Maybe<Causer>;
  readonly created_at?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly description: Scalars['String']['output'];
  readonly event?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly log_name: Scalars['String']['output'];
  readonly properties?: Maybe<Scalars['JSON']['output']>;
  readonly updated_at?: Maybe<Scalars['DateTimeToTz']['output']>;
};

export type Appointment = {
  readonly __typename?: 'Appointment';
  readonly agenda_description?: Maybe<Scalars['String']['output']>;
  readonly agenda_title?: Maybe<Scalars['String']['output']>;
  readonly appointment_audios?: Maybe<ReadonlyArray<Maybe<AppointmentAudio>>>;
  readonly appointment_request?: Maybe<AppointmentRequest>;
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly dial_in?: Maybe<Scalars['String']['output']>;
  readonly dial_in_meeting_id?: Maybe<Scalars['String']['output']>;
  readonly document_submissions?: Maybe<ReadonlyArray<Maybe<DocumentSubmission>>>;
  readonly documents?: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly duration: Scalars['Int']['output'];
  readonly ended_at?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly filtered_vitals?: Maybe<ReadonlyArray<Maybe<Vital>>>;
  readonly history?: Maybe<ReadonlyArray<Maybe<AppointmentHistory>>>;
  readonly host?: Maybe<User>;
  readonly host_participant: Participant;
  readonly id: Scalars['ID']['output'];
  readonly invoices?: Maybe<ReadonlyArray<Invoice>>;
  readonly join_app_url?: Maybe<Scalars['String']['output']>;
  readonly join_url?: Maybe<Scalars['String']['output']>;
  readonly meeting_type: AppointmentMeetingTypeEnum;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly notes?: Maybe<ReadonlyArray<Maybe<Note>>>;
  readonly participants?: Maybe<ReadonlyArray<Participant>>;
  readonly planned_end_time?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly price?: Maybe<Scalars['Int']['output']>;
  readonly redox_id?: Maybe<Scalars['String']['output']>;
  readonly redox_sending_status?: Maybe<RedoxSendingStatus>;
  readonly report_content_json?: Maybe<Scalars['String']['output']>;
  readonly service?: Maybe<Service>;
  readonly start_app_url?: Maybe<Scalars['String']['output']>;
  readonly start_time: Scalars['DateTimeToTz']['output'];
  readonly start_url?: Maybe<Scalars['String']['output']>;
  readonly started_at?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly status: AppointmentStatusEnum;
  readonly video_type?: Maybe<AppointmentVideoTypeEnum>;
  readonly vitals?: Maybe<ReadonlyArray<Maybe<Vital>>>;
  readonly vitals_media?: Maybe<ReadonlyArray<Maybe<AppointmentMedia>>>;
  /** @deprecated vitals_screenshots is deprecated. Use vitals_media instead. */
  readonly vitals_screenshots?: Maybe<ReadonlyArray<Maybe<AppointmentScreenshot>>>;
  readonly zak?: Maybe<Scalars['String']['output']>;
  readonly zoom_id?: Maybe<Scalars['String']['output']>;
  readonly zoom_password?: Maybe<Scalars['String']['output']>;
  /** @deprecated zoom_start_app_url is deprecated. Use start_app_url instead. */
  readonly zoom_start_app_url?: Maybe<Scalars['String']['output']>;
  /** @deprecated zoom_start_url is deprecated. Use start_url instead. */
  readonly zoom_start_url?: Maybe<Scalars['String']['output']>;
};

export type AppointmentAudio = {
  readonly __typename?: 'AppointmentAudio';
  readonly appointment?: Maybe<Appointment>;
  readonly archive_id?: Maybe<Scalars['String']['output']>;
  readonly audio_url?: Maybe<Scalars['String']['output']>;
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly id: Scalars['ID']['output'];
  readonly status?: Maybe<AppointmentAudioStatusEnum>;
  readonly transcript?: Maybe<Transcript>;
};

/** A paginated list of AppointmentAudio items. */
export type AppointmentAudioPaginator = {
  readonly __typename?: 'AppointmentAudioPaginator';
  /** A list of AppointmentAudio items. */
  readonly data: ReadonlyArray<AppointmentAudio>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export const enum AppointmentAudioStatusEnum {
  /** AVAILABLE */
  Available = 'AVAILABLE',
  /** EXPIRED */
  Expired = 'EXPIRED',
  /** FAILED */
  Failed = 'FAILED',
  /** PAUSED */
  Paused = 'PAUSED',
  /** PREPROCESSING */
  Preprocessing = 'PREPROCESSING',
  /** STARTED */
  Started = 'STARTED',
  /** STOPPED */
  Stopped = 'STOPPED',
  /** UPLOADED */
  Uploaded = 'UPLOADED'
};

/** A paginated list of Appointment edges. */
export type AppointmentConnection = {
  readonly __typename?: 'AppointmentConnection';
  /** A list of Appointment edges. */
  readonly edges: ReadonlyArray<AppointmentEdge>;
  /** Pagination information about the list of edges. */
  readonly pageInfo: PageInfo;
};

/** An edge that contains a node of type Appointment and a cursor. */
export type AppointmentEdge = {
  readonly __typename?: 'AppointmentEdge';
  /** A unique cursor that can be used for pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The Appointment node. */
  readonly node: Appointment;
};

export type AppointmentHistory = {
  readonly __typename?: 'AppointmentHistory';
  readonly causer?: Maybe<Causer>;
  readonly created_at?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly description: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly log_name: AppointmentHistoryActivityEnum;
  readonly properties?: Maybe<Scalars['JSON']['output']>;
  readonly updated_at?: Maybe<Scalars['DateTimeToTz']['output']>;
};

export const enum AppointmentHistoryActivityEnum {
  /** APPOINTMENT_CANCELLED */
  AppointmentCancelled = 'APPOINTMENT_CANCELLED',
  /** APPOINTMENT_CREATED */
  AppointmentCreated = 'APPOINTMENT_CREATED',
  /** APPOINTMENT_DOCUMENT_ADDED */
  AppointmentDocumentAdded = 'APPOINTMENT_DOCUMENT_ADDED',
  /** APPOINTMENT_DOCUMENT_DOWNLOADED */
  AppointmentDocumentDownloaded = 'APPOINTMENT_DOCUMENT_DOWNLOADED',
  /** APPOINTMENT_DOCUMENT_FILLED */
  AppointmentDocumentFilled = 'APPOINTMENT_DOCUMENT_FILLED',
  /** APPOINTMENT_DOCUMENT_REMOVED */
  AppointmentDocumentRemoved = 'APPOINTMENT_DOCUMENT_REMOVED',
  /** APPOINTMENT_DOCUMENT_SIGNED */
  AppointmentDocumentSigned = 'APPOINTMENT_DOCUMENT_SIGNED',
  /** APPOINTMENT_ENDED */
  AppointmentEnded = 'APPOINTMENT_ENDED',
  /** APPOINTMENT_INVITE_EMAIL */
  AppointmentInviteEmail = 'APPOINTMENT_INVITE_EMAIL',
  /** APPOINTMENT_INVITE_TEXT */
  AppointmentInviteText = 'APPOINTMENT_INVITE_TEXT',
  /** APPOINTMENT_PARTICIPANT_ATTACHED */
  AppointmentParticipantAttached = 'APPOINTMENT_PARTICIPANT_ATTACHED',
  /** APPOINTMENT_PARTICIPANT_DETACHED */
  AppointmentParticipantDetached = 'APPOINTMENT_PARTICIPANT_DETACHED',
  /** APPOINTMENT_PARTICIPANT_JOINED */
  AppointmentParticipantJoined = 'APPOINTMENT_PARTICIPANT_JOINED',
  /** APPOINTMENT_PARTICIPANT_JOINED_BEFORE_HOST */
  AppointmentParticipantJoinedBeforeHost = 'APPOINTMENT_PARTICIPANT_JOINED_BEFORE_HOST',
  /** APPOINTMENT_PARTICIPANT_LEFT */
  AppointmentParticipantLeft = 'APPOINTMENT_PARTICIPANT_LEFT',
  /** APPOINTMENT_PARTICIPANT_REJOINED */
  AppointmentParticipantRejoined = 'APPOINTMENT_PARTICIPANT_REJOINED',
  /** APPOINTMENT_REMINDER_EMAIL */
  AppointmentReminderEmail = 'APPOINTMENT_REMINDER_EMAIL',
  /** APPOINTMENT_REMINDER_TEXT */
  AppointmentReminderText = 'APPOINTMENT_REMINDER_TEXT',
  /** APPOINTMENT_REQUEST_APPROVED */
  AppointmentRequestApproved = 'APPOINTMENT_REQUEST_APPROVED',
  /** APPOINTMENT_REQUEST_CREATED */
  AppointmentRequestCreated = 'APPOINTMENT_REQUEST_CREATED',
  /** APPOINTMENT_RESCHEDULED */
  AppointmentRescheduled = 'APPOINTMENT_RESCHEDULED',
  /** APPOINTMENT_STARTED */
  AppointmentStarted = 'APPOINTMENT_STARTED',
  /** APPOINTMENT_UPDATED */
  AppointmentUpdated = 'APPOINTMENT_UPDATED',
  /** DOCUMENT_UPDATED */
  DocumentUpdated = 'DOCUMENT_UPDATED',
  /** NOTIFICATION_EMAIL */
  NotificationEmail = 'NOTIFICATION_EMAIL',
  /** NOTIFICATION_SMS */
  NotificationSms = 'NOTIFICATION_SMS',
  /** PARTICIPANT_APPOINTMENT_JOIN */
  ParticipantAppointmentJoin = 'PARTICIPANT_APPOINTMENT_JOIN',
  /** PARTICIPANT_APPOINTMENT_JOIN_BEFORE_HOST */
  ParticipantAppointmentJoinBeforeHost = 'PARTICIPANT_APPOINTMENT_JOIN_BEFORE_HOST',
  /** PARTICIPANT_APPOINTMENT_LEFT */
  ParticipantAppointmentLeft = 'PARTICIPANT_APPOINTMENT_LEFT',
  /** PARTICIPANT_APPOINTMENT_REJOINED */
  ParticipantAppointmentRejoined = 'PARTICIPANT_APPOINTMENT_REJOINED',
  /** PARTICIPANT_DOCUMENT_ATTACHED */
  ParticipantDocumentAttached = 'PARTICIPANT_DOCUMENT_ATTACHED',
  /** PARTICIPANT_DOCUMENT_FILLED */
  ParticipantDocumentFilled = 'PARTICIPANT_DOCUMENT_FILLED',
  /** PARTICIPANT_INVITE_EMAIL */
  ParticipantInviteEmail = 'PARTICIPANT_INVITE_EMAIL',
  /** PARTICIPANT_INVITE_TEXT */
  ParticipantInviteText = 'PARTICIPANT_INVITE_TEXT',
  /** PARTICIPANT_REMINDER_EMAIL */
  ParticipantReminderEmail = 'PARTICIPANT_REMINDER_EMAIL',
  /** PARTICIPANT_REMINDER_TEXT */
  ParticipantReminderText = 'PARTICIPANT_REMINDER_TEXT',
  /** PARTICIPANT_RSVP_ACCEPTED */
  ParticipantRsvpAccepted = 'PARTICIPANT_RSVP_ACCEPTED',
  /** PARTICIPANT_RSVP_DECLINED */
  ParticipantRsvpDeclined = 'PARTICIPANT_RSVP_DECLINED',
  /** PATIENT_VIEWED_DOCUMENT */
  PatientViewedDocument = 'PATIENT_VIEWED_DOCUMENT',
  /** USER_VIEWED_DOCUMENT */
  UserViewedDocument = 'USER_VIEWED_DOCUMENT'
};

export type AppointmentMedia = {
  readonly __typename?: 'AppointmentMedia';
  readonly appointment: Appointment;
  readonly created_at?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly device?: Maybe<Scalars['String']['output']>;
  readonly download_url?: Maybe<Scalars['String']['output']>;
  readonly file_type?: Maybe<AppointmentScreenshotTypeEnum>;
  readonly id: Scalars['ID']['output'];
  readonly url?: Maybe<Scalars['ResizableImage']['output']>;
  readonly user?: Maybe<User>;
};

export const enum AppointmentMeetingTypeEnum {
  /** CHAT */
  Chat = 'CHAT',
  /** INPERSON */
  Inperson = 'INPERSON',
  /** VIDEO */
  Video = 'VIDEO'
};

/** A paginated list of Appointment items. */
export type AppointmentPaginator = {
  readonly __typename?: 'AppointmentPaginator';
  /** A list of Appointment items. */
  readonly data: ReadonlyArray<Appointment>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export type AppointmentReminderInput = {
  readonly appointment_id: Scalars['ID']['input'];
  readonly participants_ids: ReadonlyArray<Scalars['ID']['input']>;
};

export type AppointmentRequest = {
  readonly __typename?: 'AppointmentRequest';
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly host?: Maybe<User>;
  readonly id: Scalars['ID']['output'];
  readonly location?: Maybe<Location>;
  readonly message?: Maybe<Scalars['String']['output']>;
  readonly owner: User;
  readonly planned_end_time?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly service?: Maybe<Service>;
  readonly start_time?: Maybe<Scalars['DateTimeToTz']['output']>;
};

export type AppointmentScreenshot = {
  readonly __typename?: 'AppointmentScreenshot';
  readonly appointment: Appointment;
  readonly created_at?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly device?: Maybe<Scalars['String']['output']>;
  readonly file_type?: Maybe<AppointmentScreenshotTypeEnum>;
  readonly id: Scalars['ID']['output'];
  readonly url?: Maybe<Scalars['ResizableImage']['output']>;
  readonly user?: Maybe<User>;
};

export const enum AppointmentScreenshotTypeEnum {
  /** ECG_IMAGE */
  EcgImage = 'ECG_IMAGE',
  /** SCREENSHOT */
  Screenshot = 'SCREENSHOT'
};

export const enum AppointmentStatusEnum {
  /** BOOKED */
  Booked = 'BOOKED',
  /** CANCELLED */
  Cancelled = 'CANCELLED',
  /** CHECKEDIN */
  Checkedin = 'CHECKEDIN',
  /** COMPLETED */
  Completed = 'COMPLETED',
  /** FAILED */
  Failed = 'FAILED',
  /** NOSHOW */
  Noshow = 'NOSHOW',
  /** PENDING */
  Pending = 'PENDING',
  /** PROPOSED */
  Proposed = 'PROPOSED'
};

export const enum AppointmentVideoTypeEnum {
  /** OPENTOK */
  Opentok = 'OPENTOK',
  /** TWILIO */
  Twilio = 'TWILIO',
  /** ZOOM */
  Zoom = 'ZOOM'
};

export type AuthResponse = {
  readonly __typename?: 'AuthResponse';
  readonly AccessToken: Scalars['String']['output'];
  readonly ExpiresIn: Scalars['Int']['output'];
  readonly IdToken: Scalars['String']['output'];
  readonly RefreshToken: Scalars['String']['output'];
  readonly TokenType: Scalars['String']['output'];
  /** UUID for getClaimByUid mutation, stored 2 minutes */
  readonly Uid?: Maybe<Scalars['String']['output']>;
};

export type AvailabilitySlot = {
  readonly __typename?: 'AvailabilitySlot';
  readonly available: Scalars['Boolean']['output'];
  readonly is_appointment: Scalars['Boolean']['output'];
  readonly outside_working_hours: Scalars['Boolean']['output'];
  readonly time: Scalars['DateTimeToTz']['output'];
};

export type BiometricMeasurement = {
  readonly __typename?: 'BiometricMeasurement';
  readonly created_at?: Maybe<Scalars['DateTime']['output']>;
  readonly display_name: Scalars['String']['output'];
  readonly formatted_value?: Maybe<Scalars['String']['output']>;
  readonly green_ranges?: Maybe<Scalars['JSON']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly measurement_id: Scalars['String']['output'];
  readonly number_format: Scalars['String']['output'];
  readonly raw_value?: Maybe<Scalars['Float']['output']>;
  readonly red_ranges?: Maybe<Scalars['JSON']['output']>;
  readonly results_group: Scalars['String']['output'];
  readonly results_group_sort: Scalars['Int']['output'];
  readonly scan: BiometricScan;
  readonly yellow_ranges?: Maybe<Scalars['JSON']['output']>;
};

export type BiometricScan = {
  readonly __typename?: 'BiometricScan';
  readonly additional_info?: Maybe<Scalars['JSON']['output']>;
  readonly appointment_id?: Maybe<Scalars['Int']['output']>;
  readonly created_at?: Maybe<Scalars['DateTime']['output']>;
  readonly device_model?: Maybe<Scalars['String']['output']>;
  readonly environment_data?: Maybe<Scalars['JSON']['output']>;
  readonly guest_uuid?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly measurements: ReadonlyArray<BiometricMeasurement>;
  readonly scanned_at: Scalars['DateTime']['output'];
  readonly user?: Maybe<User>;
};

export type Causer = Participant | User;

export type ChangeEmailInput = {
  readonly email: Scalars['String']['input'];
};

export type ChangePasswordInput = {
  readonly password: Scalars['String']['input'];
  readonly password_confirmation: Scalars['String']['input'];
};

export type ChangeTemporaryPasswordInput = {
  readonly password: Scalars['String']['input'];
  readonly password_confirmation: Scalars['String']['input'];
  readonly session: Scalars['String']['input'];
  readonly username: Scalars['String']['input'];
};

export type Chat = {
  readonly __typename?: 'Chat';
  readonly appointment?: Maybe<Appointment>;
  readonly causer?: Maybe<User>;
  readonly chat_archived: Scalars['Boolean']['output'];
  readonly chat_users: ReadonlyArray<Maybe<ChatUser>>;
  readonly id: Scalars['ID']['output'];
  readonly last_activity_at: Scalars['DateTimeToTz']['output'];
  readonly last_message?: Maybe<ChatMessage>;
  readonly type: ChatTypeEnum;
  readonly users: ReadonlyArray<Maybe<User>>;
};

export type ChatFile = {
  readonly __typename?: 'ChatFile';
  readonly filename: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly message: ChatMessage;
  readonly mimetype: Scalars['String']['output'];
  readonly path: Scalars['String']['output'];
  readonly size: Scalars['Int']['output'];
};

export type ChatFileInput = {
  readonly file: Scalars['Upload']['input'];
  readonly filename: Scalars['String']['input'];
};

export type ChatMessage = {
  readonly __typename?: 'ChatMessage';
  readonly chat: Chat;
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly files?: Maybe<ReadonlyArray<Maybe<ChatFile>>>;
  readonly id: Scalars['ID']['output'];
  readonly message: Scalars['String']['output'];
  readonly user: User;
};

export type ChatMessageInput = {
  readonly chat_id: Scalars['ID']['input'];
  readonly files?: InputMaybe<ReadonlyArray<InputMaybe<ChatFileInput>>>;
  readonly message: Scalars['String']['input'];
};

/** A paginated list of ChatMessage items. */
export type ChatMessagePaginator = {
  readonly __typename?: 'ChatMessagePaginator';
  /** A list of ChatMessage items. */
  readonly data: ReadonlyArray<ChatMessage>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export type ChatSubscriptionEvent = {
  readonly __typename?: 'ChatSubscriptionEvent';
  readonly item?: Maybe<ChatSubscriptionItem>;
  readonly type: ChatSubscriptionType;
  readonly unread: Scalars['Int']['output'];
};

export type ChatSubscriptionItem = Chat | ChatMessage;

export const enum ChatSubscriptionType {
  ChatCreated = 'CHAT_CREATED',
  MessageCreated = 'MESSAGE_CREATED',
  MessageSeen = 'MESSAGE_SEEN'
};

export const enum ChatTypeEnum {
  /** DM */
  Dm = 'DM',
  /** GROUP */
  Group = 'GROUP'
};

export type ChatUser = {
  readonly __typename?: 'ChatUser';
  readonly chat: Chat;
  readonly id: Scalars['ID']['output'];
  readonly last_read_message?: Maybe<ChatMessage>;
  readonly messages?: Maybe<ReadonlyArray<Maybe<ChatMessage>>>;
  readonly unread_messages_count: Scalars['Int']['output'];
  readonly user: User;
};

export type ConnectPermissionsMorphMany = {
  readonly ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

export type CreateAppointmentInput = {
  readonly agenda_description?: InputMaybe<Scalars['String']['input']>;
  readonly agenda_title?: InputMaybe<Scalars['String']['input']>;
  readonly documents_ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly host_id?: InputMaybe<Scalars['ID']['input']>;
  readonly meeting_type: AppointmentMeetingTypeEnum;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly participants?: InputMaybe<ReadonlyArray<ParticipantInput>>;
  readonly price?: InputMaybe<Scalars['Int']['input']>;
  readonly service_id?: InputMaybe<Scalars['ID']['input']>;
  readonly start_time: Scalars['DateTimeFromTz']['input'];
};

export type CreateAppointmentRequestInput = {
  readonly host_id?: InputMaybe<Scalars['ID']['input']>;
  readonly is_on_demand_request?: InputMaybe<Scalars['Boolean']['input']>;
  readonly location_slug?: InputMaybe<Scalars['String']['input']>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly service_id: Scalars['ID']['input'];
  readonly start_time?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
};

export type CreateBiometricScanInput = {
  readonly additional_info?: InputMaybe<Scalars['JSON']['input']>;
  readonly appointment_id?: InputMaybe<Scalars['Int']['input']>;
  readonly device_model?: InputMaybe<Scalars['String']['input']>;
  readonly environment_data?: InputMaybe<Scalars['JSON']['input']>;
  readonly guest_uuid?: InputMaybe<Scalars['String']['input']>;
  readonly measurements: ReadonlyArray<MeasurementInput>;
  readonly scanned_at: Scalars['DateTime']['input'];
};

export type CreateChatInput = {
  readonly appointment_id?: InputMaybe<Scalars['ID']['input']>;
  readonly user_ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
};

export type CreatePatientInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly avatar?: InputMaybe<Scalars['Upload']['input']>;
  readonly birth_date?: InputMaybe<Scalars['Date']['input']>;
  readonly default_notification_channel: NotificationChannelsEnum;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly is_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly password?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly sex?: InputMaybe<SexEnum>;
  readonly sms?: InputMaybe<Scalars['String']['input']>;
  readonly timezone: Scalars['String']['input'];
  readonly username?: InputMaybe<Scalars['String']['input']>;
  readonly zip?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePatientWithoutContactInput = {
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly password?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly sms_contact_consent_accepted?: InputMaybe<Scalars['Boolean']['input']>;
  readonly timezone: Scalars['String']['input'];
};

export type CreateSlotInput = {
  readonly available?: InputMaybe<Scalars['Boolean']['input']>;
  readonly ending_on?: InputMaybe<Scalars['DateTime']['input']>;
  readonly from: Scalars['Time']['input'];
  readonly starting_on?: InputMaybe<Scalars['DateTime']['input']>;
  readonly to: Scalars['Time']['input'];
  readonly weekday: WeekdayEnum;
};

export type CreateSlotsInput = {
  readonly slots: ReadonlyArray<InputMaybe<CreateSlotInput>>;
  readonly user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUserInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly avatar?: InputMaybe<Scalars['Upload']['input']>;
  readonly birth_date?: InputMaybe<Scalars['Date']['input']>;
  readonly default_notification_channel: NotificationChannelsEnum;
  readonly email: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
  readonly permissions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly roles?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly sex?: InputMaybe<SexEnum>;
  readonly sms?: InputMaybe<Scalars['String']['input']>;
  readonly timezone: Scalars['String']['input'];
  readonly username?: InputMaybe<Scalars['String']['input']>;
  readonly zip?: InputMaybe<Scalars['String']['input']>;
};

export type Document = {
  readonly __typename?: 'Document';
  readonly can_be_viewed_by_everybody: Scalars['Boolean']['output'];
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly document_packets?: Maybe<ReadonlyArray<Maybe<DocumentPacket>>>;
  readonly fields: Scalars['JSON']['output'];
  readonly id: Scalars['ID']['output'];
  readonly is_enabled: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly requirement: RequirementType;
  readonly signature_type: SignatureType;
  readonly updated_at: Scalars['DateTimeToTz']['output'];
};

export type DocumentInput = {
  readonly can_be_viewed_by_everybody?: InputMaybe<Scalars['Boolean']['input']>;
  readonly document_packets_ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly fields?: InputMaybe<Scalars['JSON']['input']>;
  readonly is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name: Scalars['String']['input'];
  readonly requirement?: InputMaybe<RequirementType>;
  readonly signature_type?: InputMaybe<SignatureType>;
};

export type DocumentPacket = {
  readonly __typename?: 'DocumentPacket';
  readonly documents?: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type DocumentPacketInput = {
  readonly document_ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly name: Scalars['String']['input'];
};

/** A paginated list of DocumentPacket items. */
export type DocumentPacketPaginator = {
  readonly __typename?: 'DocumentPacketPaginator';
  /** A list of DocumentPacket items. */
  readonly data: ReadonlyArray<DocumentPacket>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

/** A paginated list of Document items. */
export type DocumentPaginator = {
  readonly __typename?: 'DocumentPaginator';
  /** A list of Document items. */
  readonly data: ReadonlyArray<Document>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export type DocumentSubmission = {
  readonly __typename?: 'DocumentSubmission';
  readonly appointment: Appointment;
  readonly document: Document;
  readonly fields: Scalars['JSON']['output'];
  readonly id: Scalars['ID']['output'];
  readonly participant: Participant;
  readonly results: Scalars['JSON']['output'];
  readonly signatures?: Maybe<ReadonlyArray<Signature>>;
  readonly signed_by_current_user: Scalars['Boolean']['output'];
  readonly status: DocumentSubmissionStatusEnum;
  readonly submitted_at: Scalars['DateTimeToTz']['output'];
};

export type DocumentSubmissionInput = {
  readonly appointment_id: Scalars['ID']['input'];
  readonly document_ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
  readonly participant_id: Scalars['ID']['input'];
};

export const enum DocumentSubmissionOrgSort {
  AppointmentId = 'APPOINTMENT_ID',
  DocumentName = 'DOCUMENT_NAME',
  ParticipantName = 'PARTICIPANT_NAME',
  SubmittedAt = 'SUBMITTED_AT'
};

/** A paginated list of DocumentSubmission items. */
export type DocumentSubmissionPaginator = {
  readonly __typename?: 'DocumentSubmissionPaginator';
  /** A list of DocumentSubmission items. */
  readonly data: ReadonlyArray<DocumentSubmission>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export const enum DocumentSubmissionStatusEnum {
  /** PENDING */
  Pending = 'PENDING',
  /** SUBMITTED */
  Submitted = 'SUBMITTED'
};

export type Export = {
  readonly __typename?: 'Export';
  readonly name: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
  readonly userId: Scalars['Int']['output'];
};

export type IdentityProvider = {
  readonly __typename?: 'IdentityProvider';
  readonly name: Scalars['String']['output'];
  readonly url: Scalars['String']['output'];
};

export type Invoice = {
  readonly __typename?: 'Invoice';
  readonly amount?: Maybe<Scalars['Int']['output']>;
  readonly data?: Maybe<Scalars['JSON']['output']>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly participant?: Maybe<Participant>;
  readonly status?: Maybe<InvoiceStatusEnum>;
  readonly transactions?: Maybe<ReadonlyArray<InvoiceTransaction>>;
};

/** A paginated list of Invoice items. */
export type InvoicePaginator = {
  readonly __typename?: 'InvoicePaginator';
  /** A list of Invoice items. */
  readonly data: ReadonlyArray<Invoice>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export const enum InvoiceStatusEnum {
  Paid = 'PAID',
  Pending = 'PENDING',
  Refunded = 'REFUNDED'
};

export type InvoiceTransaction = {
  readonly __typename?: 'InvoiceTransaction';
  readonly data?: Maybe<InvoiceTransactionData>;
  readonly id?: Maybe<Scalars['ID']['output']>;
  readonly type?: Maybe<InvoiceTransactionEnums>;
};

export type InvoiceTransactionData = {
  readonly __typename?: 'InvoiceTransactionData';
  readonly created_at?: Maybe<Scalars['DateTime']['output']>;
  readonly last4?: Maybe<Scalars['String']['output']>;
  readonly receipt_url?: Maybe<Scalars['String']['output']>;
};

export const enum InvoiceTransactionEnums {
  StripIntentCreated = 'STRIP_INTENT_CREATED',
  StripPaymentFailed = 'STRIP_PAYMENT_FAILED',
  StripPaymentRefunded = 'STRIP_PAYMENT_REFUNDED',
  StripPaymentSucceed = 'STRIP_PAYMENT_SUCCEED'
};

export type Location = {
  readonly __typename?: 'Location';
  readonly group?: Maybe<LocationGroup>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly pivot?: Maybe<UserLocationPivot>;
  readonly slug: Scalars['String']['output'];
};

export type LocationGroup = {
  readonly __typename?: 'LocationGroup';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export type LoginReports = {
  readonly __typename?: 'LoginReports';
  readonly action: Scalars['String']['output'];
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ip?: Maybe<Scalars['String']['output']>;
  readonly loginDateTime: Scalars['DateTimeToTz']['output'];
  readonly userName: Scalars['String']['output'];
};

/** A paginated list of LoginReports items. */
export type LoginReportsPaginator = {
  readonly __typename?: 'LoginReportsPaginator';
  /** A list of LoginReports items. */
  readonly data: ReadonlyArray<LoginReports>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export type LoginResponse = AuthResponse | NewPasswordRequired;

export type MeasurementInput = {
  readonly displayName: Scalars['String']['input'];
  readonly formattedValue: Scalars['String']['input'];
  readonly greenRanges?: InputMaybe<Scalars['JSON']['input']>;
  readonly id: Scalars['String']['input'];
  readonly numberFormat: Scalars['String']['input'];
  readonly rawValue: Scalars['Float']['input'];
  readonly redRanges?: InputMaybe<Scalars['JSON']['input']>;
  readonly resultsGroup: Scalars['String']['input'];
  readonly resultsGroupSort: Scalars['Int']['input'];
  readonly yellowRanges?: InputMaybe<Scalars['JSON']['input']>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly acceptAppointmentRequest?: Maybe<Appointment>;
  readonly archiveChat?: Maybe<Chat>;
  readonly cancelAppointment: Appointment;
  readonly changeParticipantStatus?: Maybe<Scalars['Boolean']['output']>;
  readonly changePassword?: Maybe<Scalars['Boolean']['output']>;
  readonly changeTemporaryPassword?: Maybe<AuthResponse>;
  readonly completeMeeting?: Maybe<Scalars['Boolean']['output']>;
  readonly completeRoom?: Maybe<Scalars['Boolean']['output']>;
  readonly createAppointment?: Maybe<Appointment>;
  readonly createAppointmentRequest?: Maybe<AppointmentRequest>;
  readonly createBiometricScan?: Maybe<BiometricScan>;
  readonly createChat: Chat;
  readonly createDocument?: Maybe<Document>;
  readonly createDocumentPacket?: Maybe<DocumentPacket>;
  readonly createNote?: Maybe<Note>;
  readonly createNoteTemplate?: Maybe<NoteTemplate>;
  readonly createPatient?: Maybe<Patient>;
  readonly createPatientWithoutContact?: Maybe<LoginResponse>;
  readonly createService?: Maybe<Service>;
  readonly createServiceGroup?: Maybe<ServiceGroup>;
  readonly createSlot?: Maybe<Slot>;
  readonly createSlots?: Maybe<ReadonlyArray<Maybe<Slot>>>;
  readonly createUser?: Maybe<User>;
  readonly customAuth?: Maybe<AuthResponse>;
  readonly declineAppointmentRequest?: Maybe<Scalars['Boolean']['output']>;
  readonly deleteChat?: Maybe<Chat>;
  readonly deleteDocument?: Maybe<Document>;
  readonly deleteDocumentPacket?: Maybe<DocumentPacket>;
  readonly deleteDocumentSubmission?: Maybe<Scalars['ID']['output']>;
  readonly deleteNote?: Maybe<Scalars['ID']['output']>;
  readonly deleteNoteTemplate?: Maybe<Scalars['ID']['output']>;
  readonly deletePatient?: Maybe<Scalars['Boolean']['output']>;
  readonly deleteScreenshot?: Maybe<Scalars['ID']['output']>;
  readonly deleteService?: Maybe<Scalars['Boolean']['output']>;
  readonly deleteServiceGroup?: Maybe<Scalars['Boolean']['output']>;
  readonly deleteSlot?: Maybe<Scalars['Boolean']['output']>;
  readonly deleteUser?: Maybe<Scalars['Boolean']['output']>;
  readonly duplicateAppointment?: Maybe<Appointment>;
  readonly exchangeCodeForToken?: Maybe<AuthResponse>;
  readonly exchangeUid?: Maybe<Scalars['String']['output']>;
  readonly fillDocumentSubmission?: Maybe<DocumentSubmission>;
  readonly forgotPassword?: Maybe<Scalars['Boolean']['output']>;
  readonly generateDocumentPDF?: Maybe<Scalars['String']['output']>;
  readonly generateNoticePDF?: Maybe<Scalars['String']['output']>;
  readonly generateOpentokToken?: Maybe<OpentokToken>;
  readonly generateTwilioToken?: Maybe<TwilioToken>;
  readonly getClaimByUid?: Maybe<AuthResponse>;
  readonly hideAppointment: Appointment;
  readonly login?: Maybe<LoginResponse>;
  readonly logout?: Maybe<Scalars['Boolean']['output']>;
  readonly nylasAuth?: Maybe<NylasAuthResponse>;
  readonly participantRsvp?: Maybe<Participant>;
  readonly refresh?: Maybe<AuthResponse>;
  readonly remind?: Maybe<Scalars['Boolean']['output']>;
  readonly reset?: Maybe<Scalars['Boolean']['output']>;
  readonly sendChatMessage: ChatMessage;
  readonly setMessageAsSeen?: Maybe<ChatUser>;
  readonly showAppointment?: Maybe<Scalars['Boolean']['output']>;
  readonly startRecording?: Maybe<Scalars['Boolean']['output']>;
  readonly stopRecording?: Maybe<Scalars['Boolean']['output']>;
  readonly submitDocument?: Maybe<DocumentSubmission>;
  readonly syncDocumentSubmissions?: Maybe<ReadonlyArray<Maybe<DocumentSubmission>>>;
  readonly unArchiveChat?: Maybe<Chat>;
  readonly updateAppointment?: Maybe<Appointment>;
  readonly updateDocument?: Maybe<Document>;
  readonly updateDocumentPacket?: Maybe<DocumentPacket>;
  readonly updateNote?: Maybe<Note>;
  readonly updateNoteTemplate?: Maybe<NoteTemplate>;
  readonly updateOrganization?: Maybe<Organization>;
  readonly updatePatient?: Maybe<Patient>;
  readonly updateScansAvailable?: Maybe<User>;
  readonly updateService?: Maybe<Service>;
  readonly updateServiceGroup?: Maybe<ServiceGroup>;
  readonly updateUser?: Maybe<User>;
  readonly updateUserSettings?: Maybe<UserSettings>;
  readonly visitSummaryReport?: Maybe<Scalars['String']['output']>;
};


export type MutationAcceptAppointmentRequestArgs = {
  host?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationArchiveChatArgs = {
  chat_id: Scalars['ID']['input'];
};


export type MutationCancelAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeParticipantStatusArgs = {
  input: ParticipantStatusInput;
};


export type MutationChangePasswordArgs = {
  input: ChangePasswordInput;
};


export type MutationChangeTemporaryPasswordArgs = {
  input: ChangeTemporaryPasswordInput;
};


export type MutationCompleteMeetingArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type MutationCompleteRoomArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type MutationCreateAppointmentArgs = {
  input: CreateAppointmentInput;
};


export type MutationCreateAppointmentRequestArgs = {
  input: CreateAppointmentRequestInput;
};


export type MutationCreateBiometricScanArgs = {
  input: CreateBiometricScanInput;
};


export type MutationCreateChatArgs = {
  input?: InputMaybe<CreateChatInput>;
};


export type MutationCreateDocumentArgs = {
  input?: InputMaybe<DocumentInput>;
};


export type MutationCreateDocumentPacketArgs = {
  input?: InputMaybe<DocumentPacketInput>;
};


export type MutationCreateNoteArgs = {
  input?: InputMaybe<NoteInput>;
};


export type MutationCreateNoteTemplateArgs = {
  input?: InputMaybe<NoteTemplateInput>;
};


export type MutationCreatePatientArgs = {
  input: CreatePatientInput;
};


export type MutationCreatePatientWithoutContactArgs = {
  input: CreatePatientWithoutContactInput;
};


export type MutationCreateServiceArgs = {
  input?: InputMaybe<ServiceInput>;
};


export type MutationCreateServiceGroupArgs = {
  input?: InputMaybe<ServiceGroupInput>;
};


export type MutationCreateSlotArgs = {
  input: CreateSlotInput;
};


export type MutationCreateSlotsArgs = {
  input: CreateSlotsInput;
};


export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


export type MutationCustomAuthArgs = {
  token: Scalars['String']['input'];
};


export type MutationDeclineAppointmentRequestArgs = {
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteChatArgs = {
  chat_id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentPacketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteDocumentSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePatientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteScreenshotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteServiceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteServiceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSlotArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateAppointmentArgs = {
  id: Scalars['ID']['input'];
  start_time: Scalars['DateTimeFromTz']['input'];
};


export type MutationExchangeCodeForTokenArgs = {
  code: Scalars['String']['input'];
  forMedcart?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExchangeUidArgs = {
  uid: Scalars['String']['input'];
};


export type MutationFillDocumentSubmissionArgs = {
  id: Scalars['ID']['input'];
  results: Scalars['JSON']['input'];
};


export type MutationForgotPasswordArgs = {
  username: Scalars['String']['input'];
};


export type MutationGenerateDocumentPdfArgs = {
  id: Scalars['ID']['input'];
};


export type MutationGenerateNoticePdfArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  note_id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationGenerateOpentokTokenArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type MutationGenerateTwilioTokenArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type MutationGetClaimByUidArgs = {
  uid: Scalars['String']['input'];
};


export type MutationHideAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationNylasAuthArgs = {
  email: Scalars['String']['input'];
};


export type MutationParticipantRsvpArgs = {
  appointment_id: Scalars['ID']['input'];
  rsvp: RsvpTypesEnum;
};


export type MutationRefreshArgs = {
  input: RefreshTokenInput;
};


export type MutationRemindArgs = {
  input: AppointmentReminderInput;
};


export type MutationResetArgs = {
  input: ResetPasswordInput;
};


export type MutationSendChatMessageArgs = {
  input?: InputMaybe<ChatMessageInput>;
};


export type MutationSetMessageAsSeenArgs = {
  message_id: Scalars['ID']['input'];
};


export type MutationShowAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartRecordingArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type MutationStopRecordingArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type MutationSubmitDocumentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<SignDocumentSubmissionInput>;
};


export type MutationSyncDocumentSubmissionsArgs = {
  input?: InputMaybe<DocumentSubmissionInput>;
};


export type MutationUnArchiveChatArgs = {
  chat_id: Scalars['ID']['input'];
};


export type MutationUpdateAppointmentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAppointmentInput;
};


export type MutationUpdateDocumentArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DocumentInput>;
};


export type MutationUpdateDocumentPacketArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<DocumentPacketInput>;
};


export type MutationUpdateNoteArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<NoteInput>;
};


export type MutationUpdateNoteTemplateArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<NoteTemplateInput>;
};


export type MutationUpdateOrganizationArgs = {
  input: OrganizationInput;
};


export type MutationUpdatePatientArgs = {
  input: UpdatePatientInput;
};


export type MutationUpdateScansAvailableArgs = {
  input: UpdateScansAvailableInput;
};


export type MutationUpdateServiceArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ServiceInput>;
};


export type MutationUpdateServiceGroupArgs = {
  id: Scalars['ID']['input'];
  input?: InputMaybe<ServiceGroupInput>;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpdateUserSettingsArgs = {
  input: UserSettingsInput;
};


export type MutationVisitSummaryReportArgs = {
  appointment_id: Scalars['ID']['input'];
};

export type NewPasswordRequired = {
  readonly __typename?: 'NewPasswordRequired';
  readonly Session: Scalars['String']['output'];
};

export type Note = {
  readonly __typename?: 'Note';
  readonly appointment?: Maybe<Appointment>;
  readonly content: Scalars['String']['output'];
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly id: Scalars['ID']['output'];
  readonly owner_id?: Maybe<Scalars['String']['output']>;
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly users: ReadonlyArray<Maybe<User>>;
};

export type NoteInput = {
  readonly appointment_id?: InputMaybe<Scalars['ID']['input']>;
  readonly content: Scalars['String']['input'];
  readonly owner_id?: InputMaybe<Scalars['ID']['input']>;
  readonly title?: InputMaybe<Scalars['String']['input']>;
  readonly users_ids: ReadonlyArray<InputMaybe<Scalars['ID']['input']>>;
};

/** A paginated list of Note items. */
export type NotePaginator = {
  readonly __typename?: 'NotePaginator';
  /** A list of Note items. */
  readonly data: ReadonlyArray<Note>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export type NoteTemplate = {
  readonly __typename?: 'NoteTemplate';
  readonly content: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly owner: User;
};

export type NoteTemplateInput = {
  readonly content: Scalars['String']['input'];
  readonly name: Scalars['String']['input'];
};

export type NotesExportInput = {
  readonly appointment_id?: InputMaybe<Scalars['ID']['input']>;
  readonly extension?: InputMaybe<Scalars['String']['input']>;
  readonly note_id?: InputMaybe<Scalars['ID']['input']>;
  readonly user_id?: InputMaybe<Scalars['ID']['input']>;
};

export const enum NotificationChannelsEnum {
  /** MAIL */
  Mail = 'MAIL',
  /** NONE */
  None = 'NONE',
  /** SMS */
  Sms = 'SMS'
};

export type NylasAuthResponse = {
  readonly __typename?: 'NylasAuthResponse';
  readonly redirect_url: Scalars['String']['output'];
};

export type OpentokToken = {
  readonly __typename?: 'OpentokToken';
  readonly channels?: Maybe<ReadonlyArray<Scalars['String']['output']>>;
  readonly cipher_key?: Maybe<Scalars['String']['output']>;
  readonly sid?: Maybe<Scalars['String']['output']>;
  readonly subscribe_key?: Maybe<Scalars['String']['output']>;
  readonly token?: Maybe<Scalars['String']['output']>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  readonly column: Scalars['String']['input'];
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export const enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
};

/** Aggregate functions when ordering by a relation that may specify a column. */
export const enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Amount of items. */
  Count = 'COUNT',
  /** Maximum. */
  Max = 'MAX',
  /** Minimum. */
  Min = 'MIN',
  /** Sum. */
  Sum = 'SUM'
};

export const enum OrderSc {
  Asc = 'ASC',
  Desc = 'DESC'
};

export type Organization = {
  readonly __typename?: 'Organization';
  readonly account_registration_required: Scalars['Boolean']['output'];
  readonly account_without_registration_required_fields?: Maybe<AccountWithoutRegistrationRequiredFieldsEnum>;
  readonly app_env?: Maybe<Scalars['String']['output']>;
  readonly appointment_video_type?: Maybe<AppointmentVideoTypeEnum>;
  readonly biometric_scans_available?: Maybe<Scalars['Int']['output']>;
  readonly booking_description?: Maybe<Scalars['String']['output']>;
  readonly booking_message?: Maybe<Scalars['String']['output']>;
  readonly booking_page_proposed_timeslot_duration?: Maybe<Scalars['Int']['output']>;
  readonly booking_sms_consent_helper_text?: Maybe<Scalars['String']['output']>;
  readonly booking_sms_consent_label?: Maybe<Scalars['String']['output']>;
  readonly branding_primary_color?: Maybe<Scalars['String']['output']>;
  readonly connected_sessions_count?: Maybe<Scalars['Int']['output']>;
  readonly connected_sessions_limit?: Maybe<Scalars['Int']['output']>;
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly favicon_url?: Maybe<Scalars['ResizableImage']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly is_active?: Maybe<Scalars['Boolean']['output']>;
  readonly is_medcart_used?: Maybe<Scalars['Boolean']['output']>;
  readonly is_redox_enable?: Maybe<Scalars['Boolean']['output']>;
  readonly logo_url?: Maybe<Scalars['ResizableImage']['output']>;
  readonly name: Scalars['String']['output'];
  readonly palette?: Maybe<Scalars['JSON']['output']>;
  readonly payment_enabled: Scalars['Boolean']['output'];
  readonly plan?: Maybe<Scalars['String']['output']>;
  readonly settings_appointment_email_suffix?: Maybe<Scalars['String']['output']>;
  readonly settings_booking_sms_consent_enabled: Scalars['Boolean']['output'];
  readonly settings_chat_enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_enable_ondemand?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_enable_registration?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_enable_trustvitals?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_first_reminder_time?: Maybe<Scalars['Int']['output']>;
  readonly settings_medcart_hide_remote_start_button_for_hosts?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_medcart_show_booking_flow_on_dashboard?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_participants_can_join_before_hosts?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_second_reminder_time?: Maybe<Scalars['Int']['output']>;
  readonly settings_service_for_appointments_required?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_session_notes_enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_show_calendar_on_appointment_cards?: Maybe<Scalars['Boolean']['output']>;
  readonly settings_show_dial_in_on_appointment_cards?: Maybe<Scalars['Boolean']['output']>;
  readonly stripe_public_key?: Maybe<Scalars['String']['output']>;
  readonly subdomain?: Maybe<Scalars['String']['output']>;
  readonly superadmin_settings_api_enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly superadmin_settings_sms_enabled?: Maybe<Scalars['Boolean']['output']>;
  readonly support_email?: Maybe<Scalars['String']['output']>;
  readonly support_info?: Maybe<Scalars['String']['output']>;
  readonly support_phone_number?: Maybe<Scalars['String']['output']>;
  readonly tracking_code?: Maybe<Scalars['String']['output']>;
  readonly updated_at: Scalars['DateTimeToTz']['output'];
  readonly use_organization_credits: Scalars['Boolean']['output'];
  readonly users?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly vsr_setting?: Maybe<OrganizationVsrEnum>;
};


export type OrganizationBooking_MessageArgs = {
  location: Scalars['String']['input'];
};

export type OrganizationInput = {
  readonly appointment_video_type?: InputMaybe<AppointmentVideoTypeEnum>;
  readonly booking_description?: InputMaybe<Scalars['String']['input']>;
  readonly booking_page_proposed_timeslot_duration?: InputMaybe<Scalars['Int']['input']>;
  readonly branding_primary_button_bg_color?: InputMaybe<Scalars['String']['input']>;
  readonly branding_primary_button_text_color?: InputMaybe<Scalars['String']['input']>;
  readonly branding_primary_color?: InputMaybe<Scalars['String']['input']>;
  readonly branding_secondary_button_bg_color?: InputMaybe<Scalars['String']['input']>;
  readonly branding_secondary_button_text_color?: InputMaybe<Scalars['String']['input']>;
  readonly branding_secondary_color?: InputMaybe<Scalars['String']['input']>;
  readonly favicon?: InputMaybe<Scalars['Upload']['input']>;
  readonly is_medcart_used?: InputMaybe<Scalars['Boolean']['input']>;
  readonly logo?: InputMaybe<Scalars['Upload']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly settings_appointment_email_suffix?: InputMaybe<Scalars['String']['input']>;
  readonly settings_chat_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_enable_ondemand?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_enable_registration?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_enable_trustvitals?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_first_reminder_time?: InputMaybe<Scalars['Int']['input']>;
  readonly settings_medcart_hide_remote_start_button_for_hosts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_medcart_show_booking_flow_on_dashboard?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_participants_can_join_before_hosts?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_second_reminder_time?: InputMaybe<Scalars['Int']['input']>;
  readonly settings_service_for_appointments_required?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_session_notes_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_show_calendar_on_appointment_cards?: InputMaybe<Scalars['Boolean']['input']>;
  readonly settings_show_dial_in_on_appointment_cards?: InputMaybe<Scalars['Boolean']['input']>;
  readonly superadmin_settings_admin_can_assign_practitioner_role?: InputMaybe<Scalars['Boolean']['input']>;
  readonly superadmin_settings_api_enable?: InputMaybe<Scalars['Boolean']['input']>;
  readonly support_email?: InputMaybe<Scalars['String']['input']>;
  readonly support_information?: InputMaybe<Scalars['String']['input']>;
  readonly support_phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type OrganizationMessage = {
  readonly __typename?: 'OrganizationMessage';
  readonly content?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly title?: Maybe<Scalars['String']['output']>;
  readonly type: OrganizationMessageTypeEnum;
};

export const enum OrganizationMessageTypeEnum {
  /** REDOX_PATIENT_NOT_FOUND */
  RedoxPatientNotFound = 'REDOX_PATIENT_NOT_FOUND',
  /** WARNING */
  Warning = 'WARNING',
  /** WELCOME */
  Welcome = 'WELCOME'
};

export const enum OrganizationVsrEnum {
  /** OFF */
  Off = 'OFF',
  /** ON_WITHOUT_ABRIDGE */
  OnWithoutAbridge = 'ON_WITHOUT_ABRIDGE',
  /** ON_WITH_ABRIDGE */
  OnWithAbridge = 'ON_WITH_ABRIDGE'
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  readonly __typename?: 'PageInfo';
  /** Number of nodes in the current page. */
  readonly count: Scalars['Int']['output'];
  /** Index of the current page. */
  readonly currentPage: Scalars['Int']['output'];
  /** The cursor to continue paginating forwards. */
  readonly endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  readonly hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  readonly hasPreviousPage: Scalars['Boolean']['output'];
  /** Index of the last available page. */
  readonly lastPage: Scalars['Int']['output'];
  /** The cursor to continue paginating backwards. */
  readonly startCursor?: Maybe<Scalars['String']['output']>;
  /** Total number of nodes in the paginated connection. */
  readonly total: Scalars['Int']['output'];
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  readonly __typename?: 'PaginatorInfo';
  /** Number of items in the current page. */
  readonly count: Scalars['Int']['output'];
  /** Index of the current page. */
  readonly currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  readonly firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  readonly hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  readonly lastItem?: Maybe<Scalars['Int']['output']>;
  /** Index of the last available page. */
  readonly lastPage: Scalars['Int']['output'];
  /** Number of items per page. */
  readonly perPage: Scalars['Int']['output'];
  /** Number of total available items. */
  readonly total: Scalars['Int']['output'];
};

export type Participant = {
  readonly __typename?: 'Participant';
  readonly appointment?: Maybe<Appointment>;
  readonly default_notification_channel: NotificationChannelsEnum;
  readonly document_submissions?: Maybe<ReadonlyArray<Maybe<DocumentSubmission>>>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly history?: Maybe<ReadonlyArray<Maybe<Activity>>>;
  readonly id: Scalars['ID']['output'];
  readonly ip?: Maybe<Scalars['String']['output']>;
  readonly is_host?: Maybe<Scalars['Boolean']['output']>;
  readonly is_in_meeting?: Maybe<Scalars['Boolean']['output']>;
  readonly join_app_url?: Maybe<Scalars['String']['output']>;
  readonly join_url?: Maybe<Scalars['String']['output']>;
  readonly location?: Maybe<Scalars['String']['output']>;
  readonly rsvp?: Maybe<RsvpTypesEnum>;
  readonly sms?: Maybe<Scalars['String']['output']>;
  readonly token_code?: Maybe<TokenCode>;
  readonly user: User;
  /** @deprecated zoom_join_url is deprecated. Use join_url instead. */
  readonly zoom_join_url?: Maybe<Scalars['String']['output']>;
};

export type ParticipantInput = {
  readonly default_notification_channel?: InputMaybe<NotificationChannelsEnum>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly sms?: InputMaybe<Scalars['String']['input']>;
  readonly user_id: Scalars['ID']['input'];
};

export type ParticipantStatusChanged = {
  readonly __typename?: 'ParticipantStatusChanged';
  readonly appointment_id: Scalars['ID']['output'];
  readonly enable_audio?: Maybe<Scalars['Boolean']['output']>;
  readonly enable_video?: Maybe<Scalars['Boolean']['output']>;
};

export type ParticipantStatusInput = {
  readonly appointment_id: Scalars['ID']['input'];
  readonly enable_audio?: InputMaybe<Scalars['Boolean']['input']>;
  readonly enable_video?: InputMaybe<Scalars['Boolean']['input']>;
  readonly user_id: Scalars['Int']['input'];
};

export type Patient = {
  readonly __typename?: 'Patient';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly avatar_url?: Maybe<Scalars['String']['output']>;
  readonly birth_date?: Maybe<Scalars['Date']['output']>;
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly default_notification_channel: NotificationChannelsEnum;
  readonly email: Scalars['String']['output'];
  readonly enable_notification?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly is_active?: Maybe<Scalars['Boolean']['output']>;
  readonly is_global: Scalars['Boolean']['output'];
  readonly name: Scalars['String']['output'];
  readonly notes?: Maybe<ReadonlyArray<Maybe<Note>>>;
  readonly notes_count: Scalars['Int']['output'];
  readonly organizations: ReadonlyArray<Maybe<Organization>>;
  readonly owners?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly permissions?: Maybe<ReadonlyArray<Maybe<Permission>>>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly roles?: Maybe<ReadonlyArray<Maybe<Role>>>;
  readonly sex?: Maybe<SexEnum>;
  readonly sms?: Maybe<Scalars['String']['output']>;
  readonly timezone: Scalars['String']['output'];
  readonly updated_at: Scalars['DateTimeToTz']['output'];
  readonly zip?: Maybe<Scalars['String']['output']>;
};

export const enum PatientFilter {
  All = 'ALL',
  Organization = 'ORGANIZATION',
  Own = 'OWN'
};

export type PatientNotesFilterInput = {
  readonly dateFrom?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  readonly dateTor?: InputMaybe<Scalars['DateTimeToTz']['input']>;
};

/** A paginated list of Patient items. */
export type PatientPaginator = {
  readonly __typename?: 'PatientPaginator';
  /** A list of Patient items. */
  readonly data: ReadonlyArray<Patient>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export const enum PaymentGatewayEnum {
  None = 'NONE',
  Stripe = 'STRIPE'
};

export type Permission = {
  readonly __typename?: 'Permission';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly roles?: Maybe<ReadonlyArray<Maybe<Role>>>;
};

export type PullInput = {
  readonly browser_identifier: Scalars['String']['input'];
  readonly organization_id?: InputMaybe<Scalars['ID']['input']>;
  readonly type: PullingType;
};

export type Pulling = {
  readonly __typename?: 'Pulling';
  readonly browser_identifier?: Maybe<Scalars['String']['output']>;
  readonly data?: Maybe<Scalars['JSON']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly is_received: Scalars['Boolean']['output'];
  readonly organization?: Maybe<Organization>;
  readonly type?: Maybe<PullingType>;
  readonly user: User;
};

export const enum PullingType {
  /** EXPORT */
  Export = 'EXPORT'
};

export type Query = {
  readonly __typename?: 'Query';
  readonly appointment?: Maybe<Appointment>;
  readonly appointmentAudio?: Maybe<AppointmentAudio>;
  readonly appointmentAudios?: Maybe<AppointmentAudioPaginator>;
  readonly appointmentRequest?: Maybe<AppointmentRequest>;
  readonly appointmentRequests: ReadonlyArray<Maybe<AppointmentRequest>>;
  readonly appointmentRequestsCount: Scalars['Int']['output'];
  readonly appointments: ReadonlyArray<Appointment>;
  readonly appointmentsConnection?: Maybe<AppointmentConnection>;
  readonly appointmentsMedia?: Maybe<ReadonlyArray<Maybe<AppointmentMedia>>>;
  readonly appointmentsScreenshot?: Maybe<ReadonlyArray<Maybe<AppointmentScreenshot>>>;
  readonly archivedChats: ReadonlyArray<Maybe<Chat>>;
  readonly biometricMeasurement: ReadonlyArray<BiometricMeasurement>;
  readonly biometricMeasurements: ReadonlyArray<BiometricMeasurement>;
  readonly biometricScans: ReadonlyArray<BiometricScan>;
  readonly biometricScansAvailable: ReadonlyArray<User>;
  readonly chat: Chat;
  readonly chatMessages?: Maybe<ChatMessagePaginator>;
  readonly chats: ReadonlyArray<Maybe<Chat>>;
  readonly contacts?: Maybe<UserConnection>;
  readonly countNewMessages: Scalars['Int']['output'];
  readonly document?: Maybe<Document>;
  readonly documentPacket?: Maybe<DocumentPacket>;
  readonly documentPackets?: Maybe<DocumentPacketPaginator>;
  readonly documentSubmission?: Maybe<DocumentSubmission>;
  readonly documentSubmissions?: Maybe<ReadonlyArray<DocumentSubmission>>;
  readonly documentSubmissionsOrg?: Maybe<DocumentSubmissionPaginator>;
  readonly documents?: Maybe<DocumentPaginator>;
  readonly getTranscriptFromApi?: Maybe<Transcript>;
  readonly hostAppointmentRequests: ReadonlyArray<Maybe<AppointmentRequest>>;
  readonly hosts?: Maybe<UserPaginator>;
  readonly identityProviders?: Maybe<ReadonlyArray<IdentityProvider>>;
  readonly invoice?: Maybe<Invoice>;
  readonly invoices?: Maybe<InvoicePaginator>;
  readonly loginReports?: Maybe<LoginReportsPaginator>;
  readonly me?: Maybe<User>;
  readonly noteTemplate?: Maybe<NoteTemplate>;
  readonly noteTemplates: ReadonlyArray<Maybe<NoteTemplate>>;
  readonly notes?: Maybe<NotePaginator>;
  readonly notesExport: Scalars['String']['output'];
  readonly onDemandAppointmentRequests: ReadonlyArray<Maybe<AppointmentRequest>>;
  readonly organization?: Maybe<Organization>;
  readonly organizationById?: Maybe<Organization>;
  readonly organization_messages?: Maybe<ReadonlyArray<Maybe<OrganizationMessage>>>;
  readonly organizations?: Maybe<ReadonlyArray<Maybe<Organization>>>;
  readonly participantExport?: Maybe<Scalars['String']['output']>;
  readonly participants?: Maybe<UserConnection>;
  readonly patient?: Maybe<Patient>;
  readonly patientAppointmentRequests: ReadonlyArray<Maybe<AppointmentRequest>>;
  readonly patientNotes?: Maybe<PatientPaginator>;
  readonly patients?: Maybe<PatientPaginator>;
  readonly pull?: Maybe<ReadonlyArray<Maybe<Pulling>>>;
  readonly retrieveInvoice?: Maybe<StripeInvoice>;
  readonly roles: ReadonlyArray<Maybe<Role>>;
  readonly service?: Maybe<Service>;
  readonly serviceGroup?: Maybe<ServiceGroup>;
  readonly serviceGroups: ReadonlyArray<Maybe<ServiceGroup>>;
  readonly services?: Maybe<ServicePaginator>;
  readonly sessionReport?: Maybe<Scalars['String']['output']>;
  readonly sessions?: Maybe<AppointmentPaginator>;
  readonly sessionsExport?: Maybe<Scalars['String']['output']>;
  readonly slots: ReadonlyArray<Maybe<Slot>>;
  readonly user?: Maybe<User>;
  readonly userAvailability?: Maybe<ReadonlyArray<AvailabilitySlot>>;
  readonly userOrganizations?: Maybe<ReadonlyArray<Organization>>;
  readonly users?: Maybe<UserPaginator>;
};


export type QueryAppointmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentAudioArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentAudiosArgs = {
  first: Scalars['Int']['input'];
  order_by?: InputMaybe<ReadonlyArray<QueryAppointmentAudiosOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryAppointmentAudiosWhereWhereConditions>;
};


export type QueryAppointmentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppointmentRequestsCountArgs = {
  host?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAppointmentsArgs = {
  from?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  host?: InputMaybe<Scalars['ID']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<AppointmentStatusEnum>>>;
  to?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
};


export type QueryAppointmentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  host?: InputMaybe<Scalars['ID']['input']>;
  showHidden?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<AppointmentStatusEnum>>>;
};


export type QueryAppointmentsMediaArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryAppointmentsScreenshotArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBiometricMeasurementArgs = {
  scanId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBiometricMeasurementsArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBiometricScansArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChatArgs = {
  chat_id: Scalars['ID']['input'];
};


export type QueryChatMessagesArgs = {
  chat_id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChatsArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryContactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentPacketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentPacketsArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDocumentSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDocumentSubmissionsArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type QueryDocumentSubmissionsOrgArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  document_id?: InputMaybe<Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  from: Scalars['DateTimeFromTz']['input'];
  order_by?: InputMaybe<DocumentSubmissionOrgSort>;
  order_sc?: InputMaybe<OrderSc>;
  page?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<DocumentSubmissionStatusEnum>;
  to: Scalars['DateTimeFromTz']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryDocumentsArgs = {
  first: Scalars['Int']['input'];
  order_by?: InputMaybe<ReadonlyArray<QueryDocumentsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetTranscriptFromApiArgs = {
  id: Scalars['ID']['input'];
};


export type QueryHostAppointmentRequestsArgs = {
  host?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryHostAppointmentRequestsWhereWhereConditions>;
};


export type QueryHostsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRoles?: InputMaybe<QueryHostsHasRolesWhereHasConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryHostsOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryHostsWhereWhereConditions>;
};


export type QueryIdentityProvidersArgs = {
  forMedcart?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvoiceArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type QueryInvoicesArgs = {
  first: Scalars['Int']['input'];
  hasParticipant?: InputMaybe<QueryInvoicesHasParticipantWhereHasConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryInvoicesOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryInvoicesWhereWhereConditions>;
};


export type QueryLoginReportsArgs = {
  first: Scalars['Int']['input'];
  orderBy?: InputMaybe<ReadonlyArray<QueryLoginReportsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNoteTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotesArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasAppointment?: InputMaybe<QueryNotesHasAppointmentWhereHasConditions>;
  hasUsers?: InputMaybe<QueryNotesHasUsersWhereHasConditions>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryNotesWhereWhereConditions>;
};


export type QueryNotesExportArgs = {
  browser_identifier: Scalars['String']['input'];
  input: NotesExportInput;
};


export type QueryOrganizationByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryParticipantExportArgs = {
  browser_identifier: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  participant_id: Scalars['ID']['input'];
};


export type QueryParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  exclude?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  first: Scalars['Int']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPatientArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPatientAppointmentRequestsArgs = {
  owner?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryPatientAppointmentRequestsWhereWhereConditions>;
};


export type QueryPatientNotesArgs = {
  filter?: InputMaybe<PatientNotesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<QueryPatientNotesOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryPatientNotesWhereWhereConditions>;
};


export type QueryPatientsArgs = {
  filter?: InputMaybe<PatientFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<QueryPatientsOrderByOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryPatientsWhereWhereConditions>;
};


export type QueryPullArgs = {
  input: PullInput;
};


export type QueryRetrieveInvoiceArgs = {
  appointment_id: Scalars['ID']['input'];
};


export type QueryServiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServiceGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryServicesArgs = {
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  practitioner?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<QueryServicesWhereWhereConditions>;
};


export type QuerySessionReportArgs = {
  id: Scalars['ID']['input'];
};


export type QuerySessionsArgs = {
  first: Scalars['Int']['input'];
  from_date: Scalars['DateTimeFromTz']['input'];
  host_id?: InputMaybe<Scalars['Int']['input']>;
  order_by?: InputMaybe<ReadonlyArray<QuerySessionsOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  participant_ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  session_type: SessionTypeEnum;
  to_date: Scalars['DateTimeFromTz']['input'];
};


export type QuerySessionsExportArgs = {
  browser_identifier: Scalars['String']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  from_date?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  host_id?: InputMaybe<Scalars['ID']['input']>;
  order_by?: InputMaybe<ReadonlyArray<QuerySessionsExportOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  participant_ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  session_id?: InputMaybe<Scalars['ID']['input']>;
  session_type?: InputMaybe<SessionTypeEnum>;
  to_date?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
};


export type QuerySlotsArgs = {
  user?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserAvailabilityArgs = {
  date: Scalars['DateTime']['input'];
  host?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  service: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  hasRoles?: InputMaybe<QueryUsersHasRolesWhereHasConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryUsersOrderByRelationOrderByClause>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<QueryUsersWhereWhereConditions>;
};

/** Allowed column names for Query.appointmentAudios.order_by. */
export const enum QueryAppointmentAudiosOrderByColumn {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Status = 'STATUS'
};

/** Order by clause for Query.appointmentAudios.order_by. */
export type QueryAppointmentAudiosOrderByOrderByClause = {
  /** The column that is used for ordering. */
  readonly column: QueryAppointmentAudiosOrderByColumn;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.appointmentAudios.where. */
export const enum QueryAppointmentAudiosWhereColumn {
  AppointmentId = 'APPOINTMENT_ID',
  ArchiveId = 'ARCHIVE_ID',
  Status = 'STATUS',
  Transcript = 'TRANSCRIPT'
};

/** Dynamic WHERE conditions for the `where` argument on the query `appointmentAudios`. */
export type QueryAppointmentAudiosWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryAppointmentAudiosWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryAppointmentAudiosWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryAppointmentAudiosWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryAppointmentAudiosWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `appointmentAudios`. */
export type QueryAppointmentAudiosWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryAppointmentAudiosWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.documents.order_by. */
export const enum QueryDocumentsOrderByColumn {
  Id = 'ID',
  Name = 'NAME'
};

/** Order by clause for Query.documents.order_by. */
export type QueryDocumentsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  readonly column: QueryDocumentsOrderByColumn;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.hostAppointmentRequests.where. */
export const enum QueryHostAppointmentRequestsWhereColumn {
  StartTime = 'START_TIME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `hostAppointmentRequests`. */
export type QueryHostAppointmentRequestsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryHostAppointmentRequestsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryHostAppointmentRequestsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryHostAppointmentRequestsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryHostAppointmentRequestsWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `hostAppointmentRequests`. */
export type QueryHostAppointmentRequestsWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryHostAppointmentRequestsWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.hosts.hasRoles. */
export const enum QueryHostsHasRolesColumn {
  Id = 'ID',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `hasRoles` argument on the query `hosts`. */
export type QueryHostsHasRolesWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryHostsHasRolesWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryHostsHasRolesWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryHostsHasRolesWhereHasConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryHostsHasRolesColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasRoles` argument on the query `hosts`. */
export type QueryHostsHasRolesWhereHasConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryHostsHasRolesWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.hosts.orderBy. */
export const enum QueryHostsOrderByColumn {
  BirthDate = 'BIRTH_DATE',
  Email = 'EMAIL',
  Id = 'ID',
  Name = 'NAME',
  Phone = 'PHONE'
};

/** Aggregate specification for Query.hosts.orderBy.notes. */
export type QueryHostsOrderByNotes = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QueryHostsOrderByNotesColumn>;
};

/** Allowed column names for Query.hosts.orderBy. */
export const enum QueryHostsOrderByNotesColumn {
  CreatedAt = 'CREATED_AT'
};

/** Order by clause for Query.hosts.orderBy. */
export type QueryHostsOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  readonly column?: InputMaybe<QueryHostsOrderByColumn>;
  /** Aggregate specification. */
  readonly notes?: InputMaybe<QueryHostsOrderByNotes>;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.hosts.where. */
export const enum QueryHostsWhereColumn {
  DeviceUser = 'DEVICE_USER',
  Email = 'EMAIL',
  Id = 'ID',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `hosts`. */
export type QueryHostsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryHostsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryHostsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryHostsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryHostsWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `hosts`. */
export type QueryHostsWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryHostsWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.invoices.hasParticipant. */
export const enum QueryInvoicesHasParticipantColumn {
  Id = 'ID',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `hasParticipant` argument on the query `invoices`. */
export type QueryInvoicesHasParticipantWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryInvoicesHasParticipantWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryInvoicesHasParticipantWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryInvoicesHasParticipantWhereHasConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryInvoicesHasParticipantColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasParticipant` argument on the query `invoices`. */
export type QueryInvoicesHasParticipantWhereHasConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryInvoicesHasParticipantWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.invoices.orderBy. */
export const enum QueryInvoicesOrderByColumn {
  Amount = 'AMOUNT',
  Id = 'ID',
  Status = 'STATUS'
};

/** Order by clause for Query.invoices.orderBy. */
export type QueryInvoicesOrderByOrderByClause = {
  /** The column that is used for ordering. */
  readonly column: QueryInvoicesOrderByColumn;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.invoices.where. */
export const enum QueryInvoicesWhereColumn {
  Amount = 'AMOUNT',
  Id = 'ID',
  Status = 'STATUS'
};

/** Dynamic WHERE conditions for the `where` argument on the query `invoices`. */
export type QueryInvoicesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryInvoicesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryInvoicesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryInvoicesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryInvoicesWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `invoices`. */
export type QueryInvoicesWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryInvoicesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.loginReports.orderBy. */
export const enum QueryLoginReportsOrderByColumn {
  Action = 'ACTION',
  Email = 'EMAIL',
  Ip = 'IP',
  LoginDateTime = 'LOGIN_DATE_TIME',
  UserName = 'USER_NAME'
};

/** Order by clause for Query.loginReports.orderBy. */
export type QueryLoginReportsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  readonly column: QueryLoginReportsOrderByColumn;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.notes.hasAppointment. */
export const enum QueryNotesHasAppointmentColumn {
  Id = 'ID'
};

/** Dynamic WHERE conditions for the `hasAppointment` argument on the query `notes`. */
export type QueryNotesHasAppointmentWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryNotesHasAppointmentWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryNotesHasAppointmentWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryNotesHasAppointmentWhereHasConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryNotesHasAppointmentColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasAppointment` argument on the query `notes`. */
export type QueryNotesHasAppointmentWhereHasConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryNotesHasAppointmentWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.notes.hasUsers. */
export const enum QueryNotesHasUsersColumn {
  Id = 'ID'
};

/** Dynamic WHERE conditions for the `hasUsers` argument on the query `notes`. */
export type QueryNotesHasUsersWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryNotesHasUsersWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryNotesHasUsersWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryNotesHasUsersWhereHasConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryNotesHasUsersColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasUsers` argument on the query `notes`. */
export type QueryNotesHasUsersWhereHasConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryNotesHasUsersWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.notes.where. */
export const enum QueryNotesWhereColumn {
  CreatedAt = 'CREATED_AT'
};

/** Dynamic WHERE conditions for the `where` argument on the query `notes`. */
export type QueryNotesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryNotesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryNotesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryNotesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryNotesWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `notes`. */
export type QueryNotesWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryNotesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.patientAppointmentRequests.where. */
export const enum QueryPatientAppointmentRequestsWhereColumn {
  StartTime = 'START_TIME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `patientAppointmentRequests`. */
export type QueryPatientAppointmentRequestsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryPatientAppointmentRequestsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryPatientAppointmentRequestsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryPatientAppointmentRequestsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryPatientAppointmentRequestsWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `patientAppointmentRequests`. */
export type QueryPatientAppointmentRequestsWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryPatientAppointmentRequestsWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.patientNotes.orderBy. */
export const enum QueryPatientNotesOrderByColumn {
  Email = 'EMAIL',
  Name = 'NAME'
};

/** Aggregate specification for Query.patientNotes.orderBy.notes. */
export type QueryPatientNotesOrderByNotes = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QueryPatientNotesOrderByNotesColumn>;
};

/** Allowed column names for Query.patientNotes.orderBy. */
export const enum QueryPatientNotesOrderByNotesColumn {
  CratedAt = 'CRATED_AT'
};

/** Order by clause for Query.patientNotes.orderBy. */
export type QueryPatientNotesOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  readonly column?: InputMaybe<QueryPatientNotesOrderByColumn>;
  /** Aggregate specification. */
  readonly notes?: InputMaybe<QueryPatientNotesOrderByNotes>;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.patientNotes.where. */
export const enum QueryPatientNotesWhereColumn {
  Email = 'EMAIL',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `patientNotes`. */
export type QueryPatientNotesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryPatientNotesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryPatientNotesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryPatientNotesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryPatientNotesWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `patientNotes`. */
export type QueryPatientNotesWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryPatientNotesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.patients.orderBy. */
export const enum QueryPatientsOrderByColumn {
  BirthDate = 'BIRTH_DATE',
  CreatedAt = 'CREATED_AT',
  Email = 'EMAIL',
  Id = 'ID',
  Name = 'NAME',
  Phone = 'PHONE'
};

/** Order by clause for Query.patients.orderBy. */
export type QueryPatientsOrderByOrderByClause = {
  /** The column that is used for ordering. */
  readonly column: QueryPatientsOrderByColumn;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.patients.where. */
export const enum QueryPatientsWhereColumn {
  Email = 'EMAIL',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `patients`. */
export type QueryPatientsWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryPatientsWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryPatientsWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryPatientsWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryPatientsWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `patients`. */
export type QueryPatientsWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryPatientsWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.services.where. */
export const enum QueryServicesWhereColumn {
  CanBeScheduled = 'CAN_BE_SCHEDULED',
  Code = 'CODE',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `services`. */
export type QueryServicesWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryServicesWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryServicesWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryServicesWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryServicesWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `services`. */
export type QueryServicesWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryServicesWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.sessionsExport.order_by. */
export const enum QuerySessionsExportOrderByColumn {
  Id = 'ID',
  StartedAt = 'STARTED_AT'
};

/** Aggregate specification for Query.sessionsExport.order_by.host. */
export type QuerySessionsExportOrderByHost = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QuerySessionsExportOrderByHostColumn>;
};

/** Allowed column names for Query.sessionsExport.order_by. */
export const enum QuerySessionsExportOrderByHostColumn {
  Name = 'NAME'
};

/** Order by clause for Query.sessionsExport.order_by. */
export type QuerySessionsExportOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  readonly column?: InputMaybe<QuerySessionsExportOrderByColumn>;
  /** Aggregate specification. */
  readonly host?: InputMaybe<QuerySessionsExportOrderByHost>;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
  /** Aggregate specification. */
  readonly service?: InputMaybe<QuerySessionsExportOrderByService>;
};

/** Aggregate specification for Query.sessionsExport.order_by.service. */
export type QuerySessionsExportOrderByService = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QuerySessionsExportOrderByServiceColumn>;
};

/** Allowed column names for Query.sessionsExport.order_by. */
export const enum QuerySessionsExportOrderByServiceColumn {
  Name = 'NAME'
};

/** Allowed column names for Query.sessions.order_by. */
export const enum QuerySessionsOrderByColumn {
  Id = 'ID',
  StartedAt = 'STARTED_AT'
};

/** Aggregate specification for Query.sessions.order_by.host. */
export type QuerySessionsOrderByHost = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QuerySessionsOrderByHostColumn>;
};

/** Allowed column names for Query.sessions.order_by. */
export const enum QuerySessionsOrderByHostColumn {
  Name = 'NAME'
};

/** Order by clause for Query.sessions.order_by. */
export type QuerySessionsOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  readonly column?: InputMaybe<QuerySessionsOrderByColumn>;
  /** Aggregate specification. */
  readonly host?: InputMaybe<QuerySessionsOrderByHost>;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
  /** Aggregate specification. */
  readonly service?: InputMaybe<QuerySessionsOrderByService>;
};

/** Aggregate specification for Query.sessions.order_by.service. */
export type QuerySessionsOrderByService = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QuerySessionsOrderByServiceColumn>;
};

/** Allowed column names for Query.sessions.order_by. */
export const enum QuerySessionsOrderByServiceColumn {
  Name = 'NAME'
};

/** Allowed column names for Query.users.hasRoles. */
export const enum QueryUsersHasRolesColumn {
  Id = 'ID',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `hasRoles` argument on the query `users`. */
export type QueryUsersHasRolesWhereHasConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryUsersHasRolesWhereHasConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryUsersHasRolesWhereHasConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryUsersHasRolesWhereHasConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryUsersHasRolesColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `hasRoles` argument on the query `users`. */
export type QueryUsersHasRolesWhereHasConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryUsersHasRolesWhereHasConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

/** Allowed column names for Query.users.orderBy. */
export const enum QueryUsersOrderByColumn {
  BirthDate = 'BIRTH_DATE',
  Email = 'EMAIL',
  EnableOndemand = 'ENABLE_ONDEMAND',
  Id = 'ID',
  Name = 'NAME',
  Phone = 'PHONE'
};

/** Aggregate specification for Query.users.orderBy.notes. */
export type QueryUsersOrderByNotes = {
  /** The aggregate function to apply to the column. */
  readonly aggregate: OrderByRelationWithColumnAggregateFunction;
  /** Name of the column to use. */
  readonly column?: InputMaybe<QueryUsersOrderByNotesColumn>;
};

/** Allowed column names for Query.users.orderBy. */
export const enum QueryUsersOrderByNotesColumn {
  CreatedAt = 'CREATED_AT'
};

/** Order by clause for Query.users.orderBy. */
export type QueryUsersOrderByRelationOrderByClause = {
  /** The column that is used for ordering. */
  readonly column?: InputMaybe<QueryUsersOrderByColumn>;
  /** Aggregate specification. */
  readonly notes?: InputMaybe<QueryUsersOrderByNotes>;
  /** The direction that is used for ordering. */
  readonly order: SortOrder;
};

/** Allowed column names for Query.users.where. */
export const enum QueryUsersWhereColumn {
  DeviceUser = 'DEVICE_USER',
  Email = 'EMAIL',
  EnableOndemand = 'ENABLE_ONDEMAND',
  Id = 'ID',
  Name = 'NAME'
};

/** Dynamic WHERE conditions for the `where` argument on the query `users`. */
export type QueryUsersWhereWhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<QueryUsersWhereWhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<QueryUsersWhereWhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<QueryUsersWhereWhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<QueryUsersWhereColumn>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE conditions for the `where` argument on the query `users`. */
export type QueryUsersWhereWhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<QueryUsersWhereWhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

export const enum RedoxSendingStatus {
  Error = 'ERROR',
  None = 'NONE',
  Success = 'SUCCESS',
  Waiting = 'WAITING'
};

export type RefreshTokenInput = {
  readonly id_token: Scalars['String']['input'];
  readonly refresh_token: Scalars['String']['input'];
};

export const enum RequirementType {
  After = 'AFTER',
  Before = 'BEFORE',
  None = 'NONE'
};

export type ResetPasswordInput = {
  readonly password: Scalars['String']['input'];
  readonly token: Scalars['String']['input'];
  readonly username: Scalars['String']['input'];
};

export type Role = {
  readonly __typename?: 'Role';
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly permissions?: Maybe<ReadonlyArray<Maybe<Permission>>>;
};

export const enum RsvpTypesEnum {
  /** RSVP_STATUS_ACCEPTED */
  RsvpStatusAccepted = 'RSVP_STATUS_ACCEPTED',
  /** RSVP_STATUS_DECLINED */
  RsvpStatusDeclined = 'RSVP_STATUS_DECLINED',
  /** RSVP_STATUS_NEEDS_ACTION */
  RsvpStatusNeedsAction = 'RSVP_STATUS_NEEDS_ACTION',
  /** RSVP_STATUS_TENTATIVE */
  RsvpStatusTentative = 'RSVP_STATUS_TENTATIVE'
};

/** The available SQL operators that are used to filter query results. */
export const enum SqlOperator {
  /** Whether a value is within a range of values (`BETWEEN`) */
  Between = 'BETWEEN',
  /** Equal operator (`=`) */
  Eq = 'EQ',
  /** Greater than operator (`>`) */
  Gt = 'GT',
  /** Greater than or equal operator (`>=`) */
  Gte = 'GTE',
  /** Whether a value is within a set of values (`IN`) */
  In = 'IN',
  /** Whether a value is not null (`IS NOT NULL`) */
  IsNotNull = 'IS_NOT_NULL',
  /** Whether a value is null (`IS NULL`) */
  IsNull = 'IS_NULL',
  /** Simple pattern matching (`LIKE`) */
  Like = 'LIKE',
  /** Less than operator (`<`) */
  Lt = 'LT',
  /** Less than or equal operator (`<=`) */
  Lte = 'LTE',
  /** Not equal operator (`!=`) */
  Neq = 'NEQ',
  /** Whether a value is not within a range of values (`NOT BETWEEN`) */
  NotBetween = 'NOT_BETWEEN',
  /** Whether a value is not within a set of values (`NOT IN`) */
  NotIn = 'NOT_IN',
  /** Negation of simple pattern matching (`NOT LIKE`) */
  NotLike = 'NOT_LIKE'
};

export type Service = {
  readonly __typename?: 'Service';
  readonly booking_approve_automatically: Scalars['Boolean']['output'];
  readonly booking_color?: Maybe<Scalars['String']['output']>;
  readonly booking_on_demand: Scalars['Boolean']['output'];
  readonly can_be_scheduled: Scalars['Boolean']['output'];
  readonly default_agenda?: Maybe<Scalars['String']['output']>;
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly documents?: Maybe<ReadonlyArray<Maybe<Document>>>;
  readonly duration: Scalars['Int']['output'];
  readonly duration_buffer?: Maybe<Scalars['Int']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly ondemand_practitioners?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly practitioners?: Maybe<ReadonlyArray<Maybe<User>>>;
  readonly price?: Maybe<Scalars['Int']['output']>;
  readonly select_any_provider: Scalars['Boolean']['output'];
  readonly service_groups?: Maybe<ReadonlyArray<Maybe<ServiceGroup>>>;
};


export type ServicePractitionersArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceGroup = {
  readonly __typename?: 'ServiceGroup';
  readonly description?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
  readonly services?: Maybe<ReadonlyArray<Maybe<Service>>>;
};

export type ServiceGroupInput = {
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly name: Scalars['String']['input'];
  readonly services?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
};

export type ServiceInput = {
  readonly booking_approve_automatically?: InputMaybe<Scalars['Boolean']['input']>;
  readonly booking_color?: InputMaybe<Scalars['String']['input']>;
  readonly booking_on_demand?: InputMaybe<Scalars['Boolean']['input']>;
  readonly can_be_scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  readonly default_agenda?: InputMaybe<Scalars['String']['input']>;
  readonly description?: InputMaybe<Scalars['String']['input']>;
  readonly documents_ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly duration: Scalars['Int']['input'];
  readonly duration_buffer?: InputMaybe<Scalars['Int']['input']>;
  readonly name: Scalars['String']['input'];
  readonly practitioners_ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
  readonly price: Scalars['Int']['input'];
  readonly service_groups_ids?: InputMaybe<ReadonlyArray<Scalars['ID']['input']>>;
};

/** A paginated list of Service items. */
export type ServicePaginator = {
  readonly __typename?: 'ServicePaginator';
  /** A list of Service items. */
  readonly data: ReadonlyArray<Service>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export const enum SessionTypeEnum {
  ConnectedSession = 'CONNECTED_SESSION',
  NonConnectedSession = 'NON_CONNECTED_SESSION'
};

export const enum SexEnum {
  Female = 'FEMALE',
  Male = 'MALE',
  NonBinary = 'NON_BINARY',
  Other = 'OTHER',
  PreferNotToAnswer = 'PREFER_NOT_TO_ANSWER',
  Unknown = 'UNKNOWN'
};

export type SignDocumentSubmissionInput = {
  readonly drawing?: InputMaybe<Scalars['Upload']['input']>;
  readonly sign_name?: InputMaybe<Scalars['String']['input']>;
};

export type Signature = {
  readonly __typename?: 'Signature';
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly drawing_url?: Maybe<Scalars['String']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly ip?: Maybe<Scalars['String']['output']>;
  readonly sign_name?: Maybe<Scalars['String']['output']>;
  readonly user: User;
};

export const enum SignatureType {
  Drawn = 'DRAWN',
  None = 'NONE',
  Typed = 'TYPED'
};

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  readonly __typename?: 'SimplePaginatorInfo';
  /** Number of items in the current page. */
  readonly count: Scalars['Int']['output'];
  /** Index of the current page. */
  readonly currentPage: Scalars['Int']['output'];
  /** Index of the first item in the current page. */
  readonly firstItem?: Maybe<Scalars['Int']['output']>;
  /** Are there more pages after this one? */
  readonly hasMorePages: Scalars['Boolean']['output'];
  /** Index of the last item in the current page. */
  readonly lastItem?: Maybe<Scalars['Int']['output']>;
  /** Number of items per page. */
  readonly perPage: Scalars['Int']['output'];
};

export type Slot = {
  readonly __typename?: 'Slot';
  readonly available?: Maybe<Scalars['Boolean']['output']>;
  readonly ending_on?: Maybe<Scalars['DateTime']['output']>;
  readonly from: Scalars['String']['output'];
  readonly id: Scalars['ID']['output'];
  readonly starting_on?: Maybe<Scalars['DateTime']['output']>;
  readonly to: Scalars['String']['output'];
  readonly user: ReadonlyArray<Maybe<User>>;
  readonly weekday: WeekdayEnum;
};

/** Directions for ordering a list of records. */
export const enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
};

export type StripeInvoice = {
  readonly __typename?: 'StripeInvoice';
  readonly amount?: Maybe<Scalars['Float']['output']>;
  readonly client_secret?: Maybe<Scalars['String']['output']>;
  readonly currency?: Maybe<Scalars['String']['output']>;
  readonly status?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  readonly __typename?: 'Subscription';
  readonly appointmentCancelled?: Maybe<Scalars['Int']['output']>;
  readonly appointmentCreated?: Maybe<Appointment>;
  readonly appointmentRequestCreated?: Maybe<AppointmentRequest>;
  readonly appointmentRequestStatusUpdated?: Maybe<AppointmentRequest>;
  readonly appointmentUpdated?: Maybe<Appointment>;
  readonly chat?: Maybe<ChatSubscriptionEvent>;
  readonly exportCreated?: Maybe<Scalars['String']['output']>;
  readonly hostDocumentSigned?: Maybe<Scalars['ID']['output']>;
  readonly participantUpdated?: Maybe<Participant>;
  readonly transcriptAdded?: Maybe<AppointmentAudio>;
  readonly twilioParticipantUpdated?: Maybe<ParticipantStatusChanged>;
};


export type SubscriptionAppointmentCancelledArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  host_id?: InputMaybe<Scalars['ID']['input']>;
  org_id: Scalars['ID']['input'];
};


export type SubscriptionAppointmentCreatedArgs = {
  host_id?: InputMaybe<Scalars['ID']['input']>;
  org_id: Scalars['ID']['input'];
};


export type SubscriptionAppointmentRequestCreatedArgs = {
  org_id: Scalars['ID']['input'];
};


export type SubscriptionAppointmentRequestStatusUpdatedArgs = {
  appointment_request_id?: InputMaybe<Scalars['ID']['input']>;
  org_id: Scalars['ID']['input'];
};


export type SubscriptionAppointmentUpdatedArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  host_id?: InputMaybe<Scalars['ID']['input']>;
  org_id: Scalars['ID']['input'];
};


export type SubscriptionChatArgs = {
  org_id: Scalars['ID']['input'];
};


export type SubscriptionExportCreatedArgs = {
  browser_identifier: Scalars['String']['input'];
  org_id: Scalars['ID']['input'];
};


export type SubscriptionHostDocumentSignedArgs = {
  org_id: Scalars['ID']['input'];
};


export type SubscriptionParticipantUpdatedArgs = {
  org_id: Scalars['ID']['input'];
  participant_id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionTranscriptAddedArgs = {
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
};


export type SubscriptionTwilioParticipantUpdatedArgs = {
  appointment_id: Scalars['ID']['input'];
  org_id: Scalars['ID']['input'];
};

export type TokenCode = {
  readonly __typename?: 'TokenCode';
  readonly id: Scalars['ID']['output'];
  readonly redirect_link: Scalars['String']['output'];
  readonly short_link: Scalars['String']['output'];
};

export type Transcript = {
  readonly __typename?: 'Transcript';
  readonly descriptions?: Maybe<ReadonlyArray<Maybe<TranscriptDescription>>>;
  readonly texts?: Maybe<ReadonlyArray<Maybe<TranscriptText>>>;
  readonly transcript_status?: Maybe<TranscriptStatusEnum>;
};

export type TranscriptDescription = {
  readonly __typename?: 'TranscriptDescription';
  readonly name?: Maybe<Scalars['String']['output']>;
  readonly summaries?: Maybe<ReadonlyArray<Maybe<TranscriptDescriptionSummary>>>;
};

export type TranscriptDescriptionSummary = {
  readonly __typename?: 'TranscriptDescriptionSummary';
  readonly inpSegments?: Maybe<ReadonlyArray<Maybe<ReadonlyArray<Maybe<Scalars['Int']['output']>>>>>;
  readonly text: Scalars['String']['output'];
};

export const enum TranscriptStatusEnum {
  /** AVAILABLE */
  Available = 'AVAILABLE',
  /** FAILED */
  Failed = 'FAILED',
  /** IN_PROGRESS */
  InProgress = 'IN_PROGRESS',
  /** NOT_EXISTS */
  NotExists = 'NOT_EXISTS'
};

export type TranscriptText = {
  readonly __typename?: 'TranscriptText';
  readonly highlightedWords?: Maybe<ReadonlyArray<Maybe<Scalars['String']['output']>>>;
  readonly speaker?: Maybe<Scalars['Int']['output']>;
  readonly startTime?: Maybe<Scalars['Float']['output']>;
  readonly text?: Maybe<Scalars['String']['output']>;
};

/** Specify if you want to include or exclude trashed results from a query. */
export const enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
};

export type TwilioToken = {
  readonly __typename?: 'TwilioToken';
  readonly room?: Maybe<Scalars['String']['output']>;
  readonly token?: Maybe<Scalars['String']['output']>;
};

export type UpdateAppointmentInput = {
  readonly agenda_description?: InputMaybe<Scalars['String']['input']>;
  readonly agenda_title?: InputMaybe<Scalars['String']['input']>;
  readonly documents_ids?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly host_id?: InputMaybe<Scalars['ID']['input']>;
  readonly meeting_type?: InputMaybe<AppointmentMeetingTypeEnum>;
  readonly message?: InputMaybe<Scalars['String']['input']>;
  readonly participants?: InputMaybe<ReadonlyArray<ParticipantInput>>;
  readonly price?: InputMaybe<Scalars['Int']['input']>;
  readonly report_content_json?: InputMaybe<Scalars['String']['input']>;
  readonly service_id?: InputMaybe<Scalars['ID']['input']>;
  readonly start_time?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
};

export type UpdatePatientInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly avatar?: InputMaybe<Scalars['Upload']['input']>;
  readonly birth_date?: InputMaybe<Scalars['Date']['input']>;
  readonly default_notification_channel?: InputMaybe<NotificationChannelsEnum>;
  readonly id: Scalars['ID']['input'];
  readonly is_active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly is_global?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly sex?: InputMaybe<SexEnum>;
  readonly sms?: InputMaybe<Scalars['String']['input']>;
  readonly timezone?: InputMaybe<Scalars['String']['input']>;
  readonly zip?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScansAvailableInput = {
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateUserInput = {
  readonly address?: InputMaybe<Scalars['String']['input']>;
  readonly avatar?: InputMaybe<Scalars['Upload']['input']>;
  readonly birth_date?: InputMaybe<Scalars['Date']['input']>;
  readonly default_notification_channel?: InputMaybe<NotificationChannelsEnum>;
  readonly email?: InputMaybe<Scalars['String']['input']>;
  readonly enable_ondemand?: InputMaybe<Scalars['Boolean']['input']>;
  readonly has_medcart?: InputMaybe<Scalars['Boolean']['input']>;
  readonly id: Scalars['ID']['input'];
  readonly is_active?: InputMaybe<Scalars['Boolean']['input']>;
  readonly name?: InputMaybe<Scalars['String']['input']>;
  readonly permissions?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly phone?: InputMaybe<Scalars['String']['input']>;
  readonly roles?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>>>;
  readonly sex?: InputMaybe<SexEnum>;
  readonly sms?: InputMaybe<Scalars['String']['input']>;
  readonly timezone?: InputMaybe<Scalars['String']['input']>;
  readonly zip?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  readonly __typename?: 'User';
  readonly address?: Maybe<Scalars['String']['output']>;
  readonly avatar_url?: Maybe<Scalars['ResizableImage']['output']>;
  readonly biometric_scans_available?: Maybe<Scalars['Int']['output']>;
  readonly birth_date?: Maybe<Scalars['Date']['output']>;
  readonly created_at: Scalars['DateTimeToTz']['output'];
  readonly default_notification_channel: NotificationChannelsEnum;
  readonly device_user?: Maybe<Scalars['Boolean']['output']>;
  readonly email?: Maybe<Scalars['String']['output']>;
  readonly enable_notification?: Maybe<Scalars['Boolean']['output']>;
  readonly enable_ondemand?: Maybe<Scalars['Boolean']['output']>;
  readonly external_calendar_connected: Scalars['Boolean']['output'];
  readonly has_medcart?: Maybe<Scalars['Boolean']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly is_active?: Maybe<Scalars['Boolean']['output']>;
  readonly is_admin?: Maybe<Scalars['Boolean']['output']>;
  readonly is_global: Scalars['Boolean']['output'];
  readonly is_online: Scalars['Boolean']['output'];
  readonly is_working_hours?: Maybe<Scalars['Boolean']['output']>;
  readonly last_login_host?: Maybe<Scalars['String']['output']>;
  readonly locations?: Maybe<ReadonlyArray<Maybe<Location>>>;
  readonly name: Scalars['String']['output'];
  readonly note_last_created?: Maybe<Scalars['DateTimeToTz']['output']>;
  readonly notes?: Maybe<ReadonlyArray<Maybe<Note>>>;
  readonly notes_count: Scalars['Int']['output'];
  readonly organizations: ReadonlyArray<Maybe<Organization>>;
  readonly permissions?: Maybe<ReadonlyArray<Maybe<Permission>>>;
  readonly phone?: Maybe<Scalars['String']['output']>;
  readonly redox_id?: Maybe<Scalars['JSON']['output']>;
  readonly roles?: Maybe<ReadonlyArray<Maybe<Role>>>;
  readonly settings: UserSettings;
  readonly sex?: Maybe<SexEnum>;
  readonly slots?: Maybe<ReadonlyArray<Maybe<Slot>>>;
  readonly sms?: Maybe<Scalars['String']['output']>;
  readonly timezone: Scalars['String']['output'];
  readonly updated_at: Scalars['DateTimeToTz']['output'];
  readonly username?: Maybe<Scalars['String']['output']>;
  readonly zip?: Maybe<Scalars['String']['output']>;
};

/** A paginated list of User edges. */
export type UserConnection = {
  readonly __typename?: 'UserConnection';
  /** A list of User edges. */
  readonly edges: ReadonlyArray<UserEdge>;
  /** Pagination information about the list of edges. */
  readonly pageInfo: PageInfo;
};

/** An edge that contains a node of type User and a cursor. */
export type UserEdge = {
  readonly __typename?: 'UserEdge';
  /** A unique cursor that can be used for pagination. */
  readonly cursor: Scalars['String']['output'];
  /** The User node. */
  readonly node: User;
};

export type UserLocationPivot = {
  readonly __typename?: 'UserLocationPivot';
  readonly primary?: Maybe<Scalars['Boolean']['output']>;
};

/** A paginated list of User items. */
export type UserPaginator = {
  readonly __typename?: 'UserPaginator';
  /** A list of User items. */
  readonly data: ReadonlyArray<User>;
  /** Pagination information about the list of items. */
  readonly paginatorInfo: PaginatorInfo;
};

export type UserSettings = {
  readonly __typename?: 'UserSettings';
  readonly notify_chat_documents?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_chat_mail?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_chat_messages?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_chat_new_chat?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_chat_sms?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_docs_mail?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_docs_not_required?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_docs_required?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_docs_resubmissions?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_docs_signed?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_docs_sms?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_payments_mail?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_payments_sms?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_requests_mail?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_requests_sms?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_scheduler_sessions_mail?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_scheduler_sessions_sms?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_updates_mail?: Maybe<Scalars['Boolean']['output']>;
  readonly notify_updates_sms?: Maybe<Scalars['Boolean']['output']>;
  readonly user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserSettingsInput = {
  readonly notify_chat_documents?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_chat_mail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_chat_messages?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_chat_new_chat?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_chat_sms?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_docs_mail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_docs_not_required?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_docs_required?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_docs_resubmissions?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_docs_signed?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_docs_sms?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_payments_mail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_payments_sms?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_requests_mail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_requests_sms?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_scheduler_sessions_mail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_scheduler_sessions_sms?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_updates_mail?: InputMaybe<Scalars['Boolean']['input']>;
  readonly notify_updates_sms?: InputMaybe<Scalars['Boolean']['input']>;
  readonly user_id: Scalars['ID']['input'];
};

export type Vital = {
  readonly __typename?: 'Vital';
  readonly fdata?: Maybe<Scalars['JSON']['output']>;
  readonly id: Scalars['ID']['output'];
  readonly name: Scalars['String']['output'];
};

export const enum WeekdayEnum {
  /** FRIDAY */
  Friday = 'FRIDAY',
  /** MONDAY */
  Monday = 'MONDAY',
  /** SATURDAY */
  Saturday = 'SATURDAY',
  /** SUNDAY */
  Sunday = 'SUNDAY',
  /** THURSDAY */
  Thursday = 'THURSDAY',
  /** TUESDAY */
  Tuesday = 'TUESDAY',
  /** WEDNESDAY */
  Wednesday = 'WEDNESDAY'
};

/** Dynamic WHERE conditions for queries. */
export type WhereConditions = {
  /** A set of conditions that requires all conditions to match. */
  readonly AND?: InputMaybe<ReadonlyArray<WhereConditions>>;
  /** Check whether a relation exists. Extra conditions or a minimum amount can be applied. */
  readonly HAS?: InputMaybe<WhereConditionsRelation>;
  /** A set of conditions that requires at least one condition to match. */
  readonly OR?: InputMaybe<ReadonlyArray<WhereConditions>>;
  /** The column that is used for the condition. */
  readonly column?: InputMaybe<Scalars['String']['input']>;
  /** The operator that is used for the condition. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The value that is used for the condition. */
  readonly value?: InputMaybe<Scalars['Mixed']['input']>;
};

/** Dynamic HAS conditions for WHERE condition queries. */
export type WhereConditionsRelation = {
  /** The amount to test. */
  readonly amount?: InputMaybe<Scalars['Int']['input']>;
  /** Additional condition logic. */
  readonly condition?: InputMaybe<WhereConditions>;
  /** The comparison operator to test against the amount. */
  readonly operator?: InputMaybe<SqlOperator>;
  /** The relation that is checked. */
  readonly relation: Scalars['String']['input'];
};

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { readonly __typename?: 'Mutation', readonly refresh?: { readonly __typename?: 'AuthResponse', readonly AccessToken: string, readonly IdToken: string, readonly Uid?: string | null } | null };

export type RolesQueryVariables = Exact<{ [key: string]: never; }>;


export type RolesQuery = { readonly __typename?: 'Query', readonly roles: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> };

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput;
}>;


export type CreateUserMutation = { readonly __typename?: 'Mutation', readonly createUser?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly timezone: string, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } | null };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteUserMutation = { readonly __typename?: 'Mutation', readonly deleteUser?: boolean | null };

export type UpdateUserSettingsMutationVariables = Exact<{
  input: UserSettingsInput;
}>;


export type UpdateUserSettingsMutation = { readonly __typename?: 'Mutation', readonly updateUserSettings?: { readonly __typename?: 'UserSettings', readonly user_id?: string | null, readonly notify_scheduler_sessions_sms?: boolean | null, readonly notify_scheduler_sessions_mail?: boolean | null, readonly notify_requests_sms?: boolean | null, readonly notify_requests_mail?: boolean | null, readonly notify_payments_mail?: boolean | null, readonly notify_payments_sms?: boolean | null, readonly notify_updates_sms?: boolean | null, readonly notify_updates_mail?: boolean | null, readonly notify_chat_sms?: boolean | null, readonly notify_chat_mail?: boolean | null, readonly notify_chat_new_chat?: boolean | null, readonly notify_chat_messages?: boolean | null, readonly notify_chat_documents?: boolean | null, readonly notify_docs_sms?: boolean | null, readonly notify_docs_mail?: boolean | null, readonly notify_docs_required?: boolean | null, readonly notify_docs_not_required?: boolean | null, readonly notify_docs_resubmissions?: boolean | null, readonly notify_docs_signed?: boolean | null } | null };

export type UpdateUserMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserMutation = { readonly __typename?: 'Mutation', readonly updateUser?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly avatar_url?: IResizableImage | null, readonly timezone: string, readonly address?: string | null, readonly zip?: string | null, readonly birth_date?: any | null, readonly sex?: SexEnum | null, readonly has_medcart?: boolean | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } | null };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserByIdQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly username?: string | null, readonly timezone: string, readonly has_medcart?: boolean | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } | null };

export type HostsListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  hasRoles?: InputMaybe<QueryHostsHasRolesWhereHasConditions>;
  where?: InputMaybe<QueryHostsWhereWhereConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryHostsOrderByRelationOrderByClause> | QueryHostsOrderByRelationOrderByClause>;
}>;


export type HostsListQuery = { readonly __typename?: 'Query', readonly hosts?: { readonly __typename?: 'UserPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly timezone: string, readonly phone?: string | null, readonly avatar_url?: IResizableImage | null, readonly is_online: boolean, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null }> } | null };

export type UserListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  hasRoles?: InputMaybe<QueryUsersHasRolesWhereHasConditions>;
  where?: InputMaybe<QueryUsersWhereWhereConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryUsersOrderByRelationOrderByClause> | QueryUsersOrderByRelationOrderByClause>;
}>;


export type UserListQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly timezone: string, readonly phone?: string | null, readonly avatar_url?: IResizableImage | null, readonly is_online: boolean, readonly enable_ondemand?: boolean | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null }> } | null };

export type CurrentOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrganizationQuery = { readonly __typename?: 'Query', readonly organization?: { readonly __typename?: 'Organization', readonly id: string, readonly subdomain?: string | null, readonly name: string, readonly settings_enable_ondemand?: boolean | null, readonly settings_enable_trustvitals?: boolean | null, readonly logo_url?: IResizableImage | null, readonly favicon_url?: IResizableImage | null, readonly payment_enabled: boolean, readonly support_phone_number?: string | null, readonly support_email?: string | null, readonly support_info?: string | null, readonly palette?: any | null, readonly is_medcart_used?: boolean | null, readonly superadmin_settings_sms_enabled?: boolean | null, readonly is_redox_enable?: boolean | null, readonly tracking_code?: string | null, readonly stripe_public_key?: string | null, readonly vsr_setting?: OrganizationVsrEnum | null, readonly connected_sessions_count?: number | null, readonly connected_sessions_limit?: number | null, readonly account_registration_required: boolean, readonly account_without_registration_required_fields?: AccountWithoutRegistrationRequiredFieldsEnum | null, readonly settings_booking_sms_consent_enabled: boolean, readonly booking_sms_consent_label?: string | null, readonly booking_sms_consent_helper_text?: string | null } | null };

export type SidebarUserQueryVariables = Exact<{ [key: string]: never; }>;


export type SidebarUserQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly organizations: ReadonlyArray<{ readonly __typename?: 'Organization', readonly id: string, readonly name: string, readonly subdomain?: string | null, readonly logo_url?: IResizableImage | null, readonly is_active?: boolean | null } | null> } | null };

export type AcceptAppointmentRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  hostId?: InputMaybe<Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptAppointmentRequestMutation = { readonly __typename?: 'Mutation', readonly acceptAppointmentRequest?: { readonly __typename?: 'Appointment', readonly id: string } | null };

export type DeclineAppointmentRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclineAppointmentRequestMutation = { readonly __typename?: 'Mutation', readonly declineAppointmentRequest?: boolean | null };

export type AppointmentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type AppointmentRequestsQuery = { readonly __typename?: 'Query', readonly appointmentRequests: ReadonlyArray<{ readonly __typename?: 'AppointmentRequest', readonly id: string, readonly start_time?: ICustomDate | null, readonly planned_end_time?: ICustomDate | null, readonly created_at: ICustomDate, readonly message?: string | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly enable_ondemand?: boolean | null, readonly avatar_url?: IResizableImage | null, readonly is_working_hours?: boolean | null } | null> | null } | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly name: string }, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly name: string, readonly slug: string } | null } | null> };

export type HostAppointmentRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type HostAppointmentRequestsQuery = { readonly __typename?: 'Query', readonly hostAppointmentRequests: ReadonlyArray<{ readonly __typename?: 'AppointmentRequest', readonly id: string, readonly start_time?: ICustomDate | null, readonly planned_end_time?: ICustomDate | null, readonly created_at: ICustomDate, readonly message?: string | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly name: string } } | null> };

export type OnDemandRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnDemandRequestsQuery = { readonly __typename?: 'Query', readonly onDemandAppointmentRequests: ReadonlyArray<{ readonly __typename?: 'AppointmentRequest', readonly id: string, readonly start_time?: ICustomDate | null, readonly planned_end_time?: ICustomDate | null, readonly message?: string | null, readonly created_at: ICustomDate, readonly owner: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly avatar_url?: IResizableImage | null }, readonly location?: { readonly __typename?: 'Location', readonly id: string, readonly name: string, readonly slug: string } | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly duration: number, readonly booking_color?: string | null } | null } | null> };

export type AppointmentRequestCreatedSubscriptionVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type AppointmentRequestCreatedSubscription = { readonly __typename?: 'Subscription', readonly appointmentRequestCreated?: { readonly __typename?: 'AppointmentRequest', readonly id: string } | null };

export type AppointmentRequestStatusUpdatedSubscriptionVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type AppointmentRequestStatusUpdatedSubscription = { readonly __typename?: 'Subscription', readonly appointmentRequestStatusUpdated?: { readonly __typename?: 'AppointmentRequest', readonly id: string } | null };

export type HideAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type HideAppointmentMutation = { readonly __typename?: 'Mutation', readonly hideAppointment: { readonly __typename?: 'Appointment', readonly id: string } };

export type RemindParticipantsMutationVariables = Exact<{
  input: AppointmentReminderInput;
}>;


export type RemindParticipantsMutation = { readonly __typename?: 'Mutation', readonly remind?: boolean | null };

export type RescheduleAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startTime: Scalars['DateTimeFromTz']['input'];
}>;


export type RescheduleAppointmentMutation = { readonly __typename?: 'Mutation', readonly updateAppointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null } | null };

export type DuplicateAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  startTime: Scalars['DateTimeFromTz']['input'];
}>;


export type DuplicateAppointmentMutation = { readonly __typename?: 'Mutation', readonly duplicateAppointment?: { readonly __typename?: 'Appointment', readonly id: string } | null };

export type CreateChatMutationVariables = Exact<{
  input?: InputMaybe<CreateChatInput>;
}>;


export type CreateChatMutation = { readonly __typename?: 'Mutation', readonly createChat: { readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly chat_archived: boolean, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string } } | null> } };

export type SendMessageMutationVariables = Exact<{
  input: ChatMessageInput;
}>;


export type SendMessageMutation = { readonly __typename?: 'Mutation', readonly sendChatMessage: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string }, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly path: string, readonly size: number, readonly mimetype: string, readonly filename: string } | null> | null } };

export type ArchivedChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type ArchivedChatsQuery = { readonly __typename?: 'Query', readonly archivedChats: ReadonlyArray<{ readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly chat_archived: boolean, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string } } | null> } | null> };

export type ChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ChatQuery = { readonly __typename?: 'Query', readonly chat: { readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly chat_archived: boolean, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string } }> | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string } } | null> } };

export type AllChatsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllChatsQuery = { readonly __typename?: 'Query', readonly chats: ReadonlyArray<{ readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly chat_archived: boolean, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string } }> | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string } } | null> } | null> };

export type CurrentChatQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CurrentChatQuery = { readonly __typename?: 'Query', readonly chat: { readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly chat_archived: boolean, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly email?: string | null, readonly name: string, readonly avatar_url?: IResizableImage | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string, readonly avatar_url?: IResizableImage | null, readonly name: string } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly status: AppointmentStatusEnum, readonly host?: { readonly __typename?: 'User', readonly id: string } | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string } }> | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate }, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } } | null> } };

export type MessagesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type MessagesQuery = { readonly __typename?: 'Query', readonly chatMessages?: { readonly __typename?: 'ChatMessagePaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly count: number, readonly hasMorePages: boolean, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string }, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly path: string, readonly size: number, readonly mimetype: string, readonly filename: string } | null> | null }> } | null };

export type SetMessageAsSeenMutationVariables = Exact<{
  message_id: Scalars['ID']['input'];
}>;


export type SetMessageAsSeenMutation = { readonly __typename?: 'Mutation', readonly setMessageAsSeen?: { readonly __typename?: 'ChatUser', readonly id: string } | null };

export type AppointmentChatsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AppointmentChatsQuery = { readonly __typename?: 'Query', readonly chats: ReadonlyArray<{ readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly avatar_url?: IResizableImage | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } } | null> } | null> };

export type CurrentOrganizationIdQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentOrganizationIdQuery = { readonly __typename?: 'Query', readonly organization?: { readonly __typename?: 'Organization', readonly id: string } | null };

export type LastMessageFragment = { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } };

export type ChatEventSubscriptionVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type ChatEventSubscription = { readonly __typename?: 'Subscription', readonly chat?: { readonly __typename?: 'ChatSubscriptionEvent', readonly type: ChatSubscriptionType, readonly unread: number, readonly item?: { readonly __typename?: 'Chat', readonly id: string, readonly type: ChatTypeEnum, readonly last_activity_at: ICustomDate, readonly chat_archived: boolean, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly avatar_url?: IResizableImage | null } | null>, readonly causer?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string } }> | null } | null, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } } | null> } | { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string }, readonly chat: { readonly __typename?: 'Chat', readonly id: string, readonly last_activity_at: ICustomDate, readonly last_message?: { readonly __typename?: 'ChatMessage', readonly id: string, readonly message: string, readonly created_at: ICustomDate, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly filename: string } | null> | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly created_at: ICustomDate } } | null, readonly chat_users: ReadonlyArray<{ readonly __typename?: 'ChatUser', readonly id: string, readonly unread_messages_count: number, readonly user: { readonly __typename?: 'User', readonly id: string } } | null> }, readonly files?: ReadonlyArray<{ readonly __typename?: 'ChatFile', readonly id: string, readonly path: string, readonly size: number, readonly mimetype: string, readonly filename: string } | null> | null } | null } | null };

export type UnreadMessagesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnreadMessagesCountQuery = { readonly __typename?: 'Query', readonly countNewMessages: number };

export type ArchiveChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveChatMutation = { readonly __typename?: 'Mutation', readonly archiveChat?: { readonly __typename?: 'Chat', readonly id: string, readonly chat_archived: boolean } | null };

export type DeleteChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteChatMutation = { readonly __typename?: 'Mutation', readonly deleteChat?: { readonly __typename?: 'Chat', readonly id: string } | null };

export type UnArchiveChatMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnArchiveChatMutation = { readonly __typename?: 'Mutation', readonly unArchiveChat?: { readonly __typename?: 'Chat', readonly id: string, readonly chat_archived: boolean } | null };

export type CreateDocumentPacketMutationVariables = Exact<{
  input?: InputMaybe<DocumentPacketInput>;
}>;


export type CreateDocumentPacketMutation = { readonly __typename?: 'Mutation', readonly createDocumentPacket?: { readonly __typename?: 'DocumentPacket', readonly id: string, readonly name: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly is_enabled: boolean, readonly can_be_viewed_by_everybody: boolean, readonly signature_type: SignatureType, readonly requirement: RequirementType, readonly fields: any, readonly created_at: ICustomDate, readonly updated_at: ICustomDate } | null> | null } | null };

export type CreateDocumentTemplateMutationVariables = Exact<{
  input?: InputMaybe<DocumentInput>;
}>;


export type CreateDocumentTemplateMutation = { readonly __typename?: 'Mutation', readonly createDocument?: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly can_be_viewed_by_everybody: boolean, readonly is_enabled: boolean, readonly signature_type: SignatureType, readonly requirement: RequirementType, readonly fields: any } | null };

export type DeleteDocumentPacketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentPacketMutation = { readonly __typename?: 'Mutation', readonly deleteDocumentPacket?: { readonly __typename?: 'DocumentPacket', readonly id: string } | null };

export type DeleteDocumentSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentSubmissionMutation = { readonly __typename?: 'Mutation', readonly deleteDocumentSubmission?: string | null };

export type DeleteDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteDocumentMutation = { readonly __typename?: 'Mutation', readonly deleteDocument?: { readonly __typename?: 'Document', readonly id: string } | null };

export type FillDocumentSubmissionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  results: Scalars['JSON']['input'];
}>;


export type FillDocumentSubmissionMutation = { readonly __typename?: 'Mutation', readonly fillDocumentSubmission?: { readonly __typename?: 'DocumentSubmission', readonly id: string } | null };

export type GenerateDocumentPdfMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GenerateDocumentPdfMutation = { readonly __typename?: 'Mutation', readonly generateDocumentPDF?: string | null };

export type SubmitDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<SignDocumentSubmissionInput>;
}>;


export type SubmitDocumentMutation = { readonly __typename?: 'Mutation', readonly submitDocument?: { readonly __typename?: 'DocumentSubmission', readonly id: string, readonly fields: any, readonly results: any, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly signature_type: SignatureType, readonly updated_at: ICustomDate }, readonly signatures?: ReadonlyArray<{ readonly __typename?: 'Signature', readonly id: string, readonly sign_name?: string | null, readonly drawing_url?: string | null, readonly ip?: string | null, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null, readonly participant: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly signature_type: SignatureType } } | null> | null }, readonly appointment: { readonly __typename?: 'Appointment', readonly id: string, readonly host_participant: { readonly __typename?: 'Participant', readonly id: string, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly signature_type: SignatureType } } | null> | null } } } | null };

export type SyncDocumentSubmissionsMutationVariables = Exact<{
  input: DocumentSubmissionInput;
}>;


export type SyncDocumentSubmissionsMutation = { readonly __typename?: 'Mutation', readonly syncDocumentSubmissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly submitted_at: ICustomDate, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly can_be_viewed_by_everybody: boolean, readonly signature_type: SignatureType }, readonly signatures?: ReadonlyArray<{ readonly __typename?: 'Signature', readonly id: string, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null } | null> | null };

export type UpdateDocumentPacketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<DocumentPacketInput>;
}>;


export type UpdateDocumentPacketMutation = { readonly __typename?: 'Mutation', readonly updateDocumentPacket?: { readonly __typename?: 'DocumentPacket', readonly id: string, readonly name: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly is_enabled: boolean, readonly can_be_viewed_by_everybody: boolean, readonly signature_type: SignatureType, readonly requirement: RequirementType, readonly fields: any, readonly created_at: ICustomDate, readonly updated_at: ICustomDate } | null> | null } | null };

export type UpdateDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input?: InputMaybe<DocumentInput>;
}>;


export type UpdateDocumentMutation = { readonly __typename?: 'Mutation', readonly updateDocument?: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly can_be_viewed_by_everybody: boolean, readonly is_enabled: boolean, readonly signature_type: SignatureType, readonly requirement: RequirementType, readonly fields: any } | null };

export type DocumentPacketQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentPacketQuery = { readonly __typename?: 'Query', readonly documentPacket?: { readonly __typename?: 'DocumentPacket', readonly id: string, readonly name: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly is_enabled: boolean, readonly can_be_viewed_by_everybody: boolean, readonly signature_type: SignatureType, readonly requirement: RequirementType, readonly fields: any, readonly created_at: ICustomDate, readonly updated_at: ICustomDate } | null> | null } | null };

export type DocumentPacketsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocumentPacketsQuery = { readonly __typename?: 'Query', readonly documentPackets?: { readonly __typename?: 'DocumentPacketPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'DocumentPacket', readonly id: string, readonly name: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly is_enabled: boolean, readonly can_be_viewed_by_everybody: boolean, readonly signature_type: SignatureType, readonly requirement: RequirementType, readonly fields: any, readonly created_at: ICustomDate, readonly updated_at: ICustomDate } | null> | null }>, readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly total: number, readonly currentPage: number, readonly hasMorePages: boolean } } | null };

export type DocumentSubmissionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentSubmissionQuery = { readonly __typename?: 'Query', readonly documentSubmission?: { readonly __typename?: 'DocumentSubmission', readonly id: string, readonly fields: any, readonly results: any, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly signature_type: SignatureType, readonly updated_at: ICustomDate }, readonly signatures?: ReadonlyArray<{ readonly __typename?: 'Signature', readonly id: string, readonly sign_name?: string | null, readonly drawing_url?: string | null, readonly ip?: string | null, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null, readonly participant: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } } } | null };

export type DocumentSubmissionsOrgQueryVariables = Exact<{
  document_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['DateTimeFromTz']['input'];
  to: Scalars['DateTimeFromTz']['input'];
  order_by?: InputMaybe<DocumentSubmissionOrgSort>;
  order_sc?: InputMaybe<OrderSc>;
  status?: InputMaybe<DocumentSubmissionStatusEnum>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocumentSubmissionsOrgQuery = { readonly __typename?: 'Query', readonly documentSubmissionsOrg?: { readonly __typename?: 'DocumentSubmissionPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly submitted_at: ICustomDate, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string }, readonly participant: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }, readonly appointment: { readonly __typename?: 'Appointment', readonly id: string } }> } | null };

export type DocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DocumentQuery = { readonly __typename?: 'Query', readonly document?: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly fields: any, readonly signature_type: SignatureType } | null };

export type DocumentsListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  orderBy?: InputMaybe<ReadonlyArray<QueryDocumentsOrderByOrderByClause> | QueryDocumentsOrderByOrderByClause>;
}>;


export type DocumentsListQuery = { readonly __typename?: 'Query', readonly documents?: { readonly __typename?: 'DocumentPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly is_enabled: boolean }>, readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly total: number, readonly currentPage: number, readonly hasMorePages: boolean } } | null };

export type BookingLocationMessageQueryVariables = Exact<{
  location: Scalars['String']['input'];
}>;


export type BookingLocationMessageQuery = { readonly __typename?: 'Query', readonly organization?: { readonly __typename?: 'Organization', readonly id: string, readonly booking_message?: string | null } | null };

export type NylasAuthMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type NylasAuthMutation = { readonly __typename?: 'Mutation', readonly nylasAuth?: { readonly __typename?: 'NylasAuthResponse', readonly redirect_url: string } | null };

export type UpdateUserOnDemandMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserOnDemandMutation = { readonly __typename?: 'Mutation', readonly updateUser?: { readonly __typename?: 'User', readonly id: string, readonly enable_ondemand?: boolean | null } | null };

export type UserListExportQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  hasRoles?: InputMaybe<QueryUsersHasRolesWhereHasConditions>;
  where?: InputMaybe<QueryUsersWhereWhereConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryUsersOrderByRelationOrderByClause> | QueryUsersOrderByRelationOrderByClause>;
}>;


export type UserListExportQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null }> } | null };

export type UserOnDemandUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserOnDemandUserQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly enable_ondemand?: boolean | null } | null };

export type UserOnDemandQueryVariables = Exact<{ [key: string]: never; }>;


export type UserOnDemandQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly enable_ondemand?: boolean | null } | null };

export type SessionUsageDetailQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SessionUsageDetailQuery = { readonly __typename?: 'Query', readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly started_at?: ICustomDate | null, readonly ended_at?: ICustomDate | null, readonly duration: number, readonly history?: ReadonlyArray<{ readonly __typename?: 'AppointmentHistory', readonly id: string, readonly log_name: AppointmentHistoryActivityEnum, readonly description: string, readonly created_at?: ICustomDate | null, readonly causer?: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } } | { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } | null> | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly ip?: string | null, readonly location?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null }, readonly history?: ReadonlyArray<{ readonly __typename?: 'Activity', readonly id: string, readonly log_name: string, readonly created_at?: ICustomDate | null } | null> | null }> | null, readonly service?: { readonly __typename?: 'Service', readonly name: string, readonly price?: number | null } | null } | null };

export type DeleteScreenshotMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteScreenshotMutation = { readonly __typename?: 'Mutation', readonly deleteScreenshot?: string | null };

export type CreateBiometricScanMutationVariables = Exact<{
  input: CreateBiometricScanInput;
}>;


export type CreateBiometricScanMutation = { readonly __typename?: 'Mutation', readonly createBiometricScan?: { readonly __typename?: 'BiometricScan', readonly id: string, readonly scanned_at: Date, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null, readonly measurements: ReadonlyArray<{ readonly __typename?: 'BiometricMeasurement', readonly id: string, readonly measurement_id: string, readonly display_name: string, readonly results_group: string, readonly results_group_sort: number, readonly number_format: string, readonly raw_value?: number | null, readonly formatted_value?: string | null }> } | null };

export type UpdateScansAvailableMutationVariables = Exact<{
  input: UpdateScansAvailableInput;
}>;


export type UpdateScansAvailableMutation = { readonly __typename?: 'Mutation', readonly updateScansAvailable?: { readonly __typename?: 'User', readonly biometric_scans_available?: number | null } | null };

export type BiometricMeasurementQueryVariables = Exact<{
  scanId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BiometricMeasurementQuery = { readonly __typename?: 'Query', readonly biometricMeasurement: ReadonlyArray<{ readonly __typename?: 'BiometricMeasurement', readonly id: string, readonly measurement_id: string, readonly display_name: string, readonly results_group: string, readonly results_group_sort: number, readonly number_format: string, readonly red_ranges?: any | null, readonly yellow_ranges?: any | null, readonly green_ranges?: any | null, readonly raw_value?: number | null, readonly formatted_value?: string | null, readonly created_at?: Date | null, readonly scan: { readonly __typename?: 'BiometricScan', readonly id: string, readonly scanned_at: Date, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } }> };

export type BiometricMeasurementsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BiometricMeasurementsQuery = { readonly __typename?: 'Query', readonly biometricMeasurements: ReadonlyArray<{ readonly __typename?: 'BiometricMeasurement', readonly id: string, readonly measurement_id: string, readonly display_name: string, readonly results_group: string, readonly results_group_sort: number, readonly number_format: string, readonly red_ranges?: any | null, readonly yellow_ranges?: any | null, readonly green_ranges?: any | null, readonly raw_value?: number | null, readonly formatted_value?: string | null, readonly created_at?: Date | null, readonly scan: { readonly __typename?: 'BiometricScan', readonly id: string, readonly scanned_at: Date, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } }> };

export type BiometricScansQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type BiometricScansQuery = { readonly __typename?: 'Query', readonly biometricScans: ReadonlyArray<{ readonly __typename?: 'BiometricScan', readonly id: string, readonly guest_uuid?: string | null, readonly scanned_at: Date, readonly appointment_id?: number | null, readonly device_model?: string | null, readonly environment_data?: any | null, readonly created_at?: Date | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null }> };

export type CreateNoteTemplateMutationVariables = Exact<{
  input: NoteTemplateInput;
}>;


export type CreateNoteTemplateMutation = { readonly __typename?: 'Mutation', readonly createNoteTemplate?: { readonly __typename?: 'NoteTemplate', readonly id: string, readonly name: string, readonly content: string } | null };

export type DeleteNoteTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNoteTemplateMutation = { readonly __typename?: 'Mutation', readonly deleteNoteTemplate?: string | null };

export type UpdateNoteTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NoteTemplateInput;
}>;


export type UpdateNoteTemplateMutation = { readonly __typename?: 'Mutation', readonly updateNoteTemplate?: { readonly __typename?: 'NoteTemplate', readonly id: string, readonly name: string, readonly content: string } | null };

export type NoteTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type NoteTemplateQuery = { readonly __typename?: 'Query', readonly noteTemplate?: { readonly __typename?: 'NoteTemplate', readonly id: string, readonly name: string, readonly content: string } | null };

export type NoteTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type NoteTemplatesQuery = { readonly __typename?: 'Query', readonly noteTemplates: ReadonlyArray<{ readonly __typename?: 'NoteTemplate', readonly id: string, readonly name: string, readonly content: string } | null> };

export type UserSessionNotesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserSessionNotesQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly notes?: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title?: string | null, readonly content: string, readonly owner_id?: string | null, readonly created_at: ICustomDate, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null>, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null, readonly email?: string | null } | null } | null } | null> | null } | null };

export type SaveSlotsMutationVariables = Exact<{
  input: CreateSlotsInput;
}>;


export type SaveSlotsMutation = { readonly __typename?: 'Mutation', readonly createSlots?: ReadonlyArray<{ readonly __typename?: 'Slot', readonly id: string, readonly from: string, readonly to: string, readonly weekday: WeekdayEnum } | null> | null };

export type VisitSummaryReportPdfMutationVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
}>;


export type VisitSummaryReportPdfMutation = { readonly __typename?: 'Mutation', readonly visitSummaryReport?: string | null };

export type AppointmentVsrQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AppointmentVsrQuery = { readonly __typename?: 'Query', readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly report_content_json?: string | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string } | null, readonly vitals_media?: ReadonlyArray<{ readonly __typename?: 'AppointmentMedia', readonly id: string, readonly download_url?: string | null, readonly created_at?: ICustomDate | null, readonly device?: string | null, readonly file_type?: AppointmentScreenshotTypeEnum | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } | null> | null, readonly filtered_vitals?: ReadonlyArray<{ readonly __typename?: 'Vital', readonly id: string, readonly name: string, readonly fdata?: any | null } | null> | null, readonly appointment_audios?: ReadonlyArray<{ readonly __typename?: 'AppointmentAudio', readonly id: string, readonly status?: AppointmentAudioStatusEnum | null, readonly audio_url?: string | null, readonly transcript?: { readonly __typename?: 'Transcript', readonly transcript_status?: TranscriptStatusEnum | null, readonly descriptions?: ReadonlyArray<{ readonly __typename?: 'TranscriptDescription', readonly name?: string | null, readonly summaries?: ReadonlyArray<{ readonly __typename?: 'TranscriptDescriptionSummary', readonly inpSegments?: ReadonlyArray<ReadonlyArray<number | null> | null> | null, readonly text: string } | null> | null } | null> | null, readonly texts?: ReadonlyArray<{ readonly __typename?: 'TranscriptText', readonly highlightedWords?: ReadonlyArray<string | null> | null, readonly speaker?: number | null, readonly text?: string | null, readonly startTime?: number | null } | null> | null } | null } | null> | null } | null };

export type AppointmentVsrViewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AppointmentVsrViewQuery = { readonly __typename?: 'Query', readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly report_content_json?: string | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string } | null } | null };

export type DocumentUsersQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DocumentUsersQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string }> } | null };

export type OrganizationDocumentSubmissionsQueryVariables = Exact<{
  document_id?: InputMaybe<Scalars['ID']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
  appointment_id?: InputMaybe<Scalars['ID']['input']>;
  from: Scalars['DateTimeFromTz']['input'];
  to: Scalars['DateTimeFromTz']['input'];
  order_by?: InputMaybe<DocumentSubmissionOrgSort>;
  order_sc?: InputMaybe<OrderSc>;
  status?: InputMaybe<DocumentSubmissionStatusEnum>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationDocumentSubmissionsQuery = { readonly __typename?: 'Query', readonly documentSubmissionsOrg?: { readonly __typename?: 'DocumentSubmissionPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly submitted_at: ICustomDate, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string }, readonly participant: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }, readonly appointment: { readonly __typename?: 'Appointment', readonly id: string } }> } | null };

export type OrganizationDocumentsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrganizationDocumentsQuery = { readonly __typename?: 'Query', readonly documents?: { readonly __typename?: 'DocumentPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string }> } | null };

export type CreateSessionNoteMutationVariables = Exact<{
  input: NoteInput;
}>;


export type CreateSessionNoteMutation = { readonly __typename?: 'Mutation', readonly createNote?: { readonly __typename?: 'Note', readonly id: string, readonly content: string, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null> } | null };

export type CreateSessionNoteUserListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type CreateSessionNoteUserListQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string }> } | null };

export type CreateSessionNoteTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateSessionNoteTemplatesQuery = { readonly __typename?: 'Query', readonly noteTemplates: ReadonlyArray<{ readonly __typename?: 'NoteTemplate', readonly id: string, readonly name: string, readonly content: string } | null> };

export type NotesExportQueryVariables = Exact<{
  input: NotesExportInput;
  browser_identifier: Scalars['String']['input'];
}>;


export type NotesExportQuery = { readonly __typename?: 'Query', readonly notesExport: string };

export type SessionNotesUserListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  hasRoles?: InputMaybe<QueryUsersHasRolesWhereHasConditions>;
  where?: InputMaybe<QueryUsersWhereWhereConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryUsersOrderByRelationOrderByClause> | QueryUsersOrderByRelationOrderByClause>;
}>;


export type SessionNotesUserListQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly note_last_created?: ICustomDate | null }> } | null };

export type CancelAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelAppointmentMutation = { readonly __typename?: 'Mutation', readonly cancelAppointment: { readonly __typename?: 'Appointment', readonly id: string } };

export type CreateAppointmentMutationVariables = Exact<{
  input: CreateAppointmentInput;
}>;


export type CreateAppointmentMutation = { readonly __typename?: 'Mutation', readonly createAppointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly device_user?: boolean | null } | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly duration: number } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum } }> | null } | null };

export type CreateNoteMutationVariables = Exact<{
  input: NoteInput;
}>;


export type CreateNoteMutation = { readonly __typename?: 'Mutation', readonly createNote?: { readonly __typename?: 'Note', readonly id: string, readonly title?: string | null, readonly content: string, readonly created_at: ICustomDate, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string } | null> } | null };

export type DeleteNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteNoteMutation = { readonly __typename?: 'Mutation', readonly deleteNote?: string | null };

export type UpdateAppointmentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAppointmentInput;
}>;


export type UpdateAppointmentMutation = { readonly __typename?: 'Mutation', readonly updateAppointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly agenda_title?: string | null, readonly agenda_description?: string | null, readonly start_time: ICustomDate, readonly meeting_type: AppointmentMeetingTypeEnum, readonly price?: number | null, readonly report_content_json?: string | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null, readonly duration: number, readonly price?: number | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly created_at: ICustomDate, readonly can_be_viewed_by_everybody: boolean } } | null> | null }> | null, readonly host?: { readonly __typename?: 'User', readonly id: string } | null } | null };

export type UpdateNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: NoteInput;
}>;


export type UpdateNoteMutation = { readonly __typename?: 'Mutation', readonly updateNote?: { readonly __typename?: 'Note', readonly id: string, readonly title?: string | null, readonly content: string, readonly created_at: ICustomDate, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string } | null> } | null };

export type AppointmentRequestsCountQueryVariables = Exact<{
  hostId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AppointmentRequestsCountQuery = { readonly __typename?: 'Query', readonly appointmentRequestsCount: number };

export type AppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type AppointmentQuery = { readonly __typename?: 'Query', readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly start_app_url?: string | null, readonly start_url?: string | null, readonly join_url?: string | null, readonly join_app_url?: string | null, readonly status: AppointmentStatusEnum, readonly created_at: ICustomDate, readonly meeting_type: AppointmentMeetingTypeEnum, readonly message?: string | null, readonly price?: number | null, readonly video_type?: AppointmentVideoTypeEnum | null, readonly dial_in?: string | null, readonly dial_in_meeting_id?: string | null, readonly agenda_title?: string | null, readonly agenda_description?: string | null, readonly redox_sending_status?: RedoxSendingStatus | null, readonly report_content_json?: string | null, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string } | null> | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly avatar_url?: IResizableImage | null } | null, readonly host_participant: { readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly submitted_at: ICustomDate, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly can_be_viewed_by_everybody: boolean }, readonly signatures?: ReadonlyArray<{ readonly __typename?: 'Signature', readonly id: string, readonly created_at: ICustomDate, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null } | null> | null }, readonly notes?: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly title?: string | null, readonly content: string, readonly created_at: ICustomDate, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null> } | null> | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly submitted_at: ICustomDate, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly can_be_viewed_by_everybody: boolean, readonly signature_type: SignatureType } } | null> | null, readonly token_code?: { readonly __typename?: 'TokenCode', readonly id: string, readonly short_link: string } | null }> | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly description?: string | null, readonly booking_color?: string | null, readonly duration: number, readonly price?: number | null, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string } | null> | null } | null, readonly history?: ReadonlyArray<{ readonly __typename?: 'AppointmentHistory', readonly id: string, readonly log_name: AppointmentHistoryActivityEnum, readonly description: string, readonly created_at?: ICustomDate | null, readonly properties?: any | null, readonly causer?: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } } | { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } | null> | null, readonly filtered_vitals?: ReadonlyArray<{ readonly __typename?: 'Vital', readonly id: string, readonly name: string, readonly fdata?: any | null } | null> | null, readonly vitals_media?: ReadonlyArray<{ readonly __typename?: 'AppointmentMedia', readonly id: string, readonly url?: IResizableImage | null, readonly created_at?: ICustomDate | null, readonly download_url?: string | null, readonly device?: string | null, readonly file_type?: AppointmentScreenshotTypeEnum | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } | null> | null, readonly appointment_audios?: ReadonlyArray<{ readonly __typename?: 'AppointmentAudio', readonly id: string, readonly status?: AppointmentAudioStatusEnum | null, readonly audio_url?: string | null, readonly transcript?: { readonly __typename?: 'Transcript', readonly transcript_status?: TranscriptStatusEnum | null, readonly descriptions?: ReadonlyArray<{ readonly __typename?: 'TranscriptDescription', readonly name?: string | null } | null> | null } | null } | null> | null } | null };

export type AppointmentsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  to?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  host?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AppointmentsQuery = { readonly __typename?: 'Query', readonly appointments: ReadonlyArray<{ readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly start_url?: string | null, readonly start_app_url?: string | null, readonly join_url?: string | null, readonly join_app_url?: string | null, readonly status: AppointmentStatusEnum, readonly meeting_type: AppointmentMeetingTypeEnum, readonly video_type?: AppointmentVideoTypeEnum | null, readonly created_at: ICustomDate, readonly price?: number | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly device_user?: boolean | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly token_code?: { readonly __typename?: 'TokenCode', readonly id: string, readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly requirement: RequirementType } } | null> | null }> | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly booking_color?: string | null, readonly duration: number, readonly price?: number | null } | null, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string } | null> | null }> };

export type DocumentsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  orderBy?: InputMaybe<ReadonlyArray<QueryDocumentsOrderByOrderByClause> | QueryDocumentsOrderByOrderByClause>;
}>;


export type DocumentsQuery = { readonly __typename?: 'Query', readonly documents?: { readonly __typename?: 'DocumentPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType }> } | null };

export type OrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationQuery = { readonly __typename?: 'Query', readonly organization?: { readonly __typename?: 'Organization', readonly id: string, readonly booking_page_proposed_timeslot_duration?: number | null } | null };

export type PacketsQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type PacketsQuery = { readonly __typename?: 'Query', readonly documentPackets?: { readonly __typename?: 'DocumentPacketPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'DocumentPacket', readonly id: string, readonly name: string, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType } | null> | null }> } | null };

export type ParticipantsConnectionQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  dob?: InputMaybe<Scalars['DateTime']['input']>;
  exclude?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ParticipantsConnectionQuery = { readonly __typename?: 'Query', readonly participants?: { readonly __typename?: 'UserConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly count: number, readonly endCursor?: string | null, readonly startCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly phone?: string | null, readonly name: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } }> } | null };

export type CreateAppointmentServiceListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  where?: InputMaybe<QueryServicesWhereWhereConditions>;
  practitioner?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateAppointmentServiceListQuery = { readonly __typename?: 'Query', readonly services?: { readonly __typename?: 'ServicePaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly duration: number, readonly booking_color?: string | null, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string } | null> | null, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null> | null }> } | null };

export type SlotsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SlotsQuery = { readonly __typename?: 'Query', readonly slots: ReadonlyArray<{ readonly __typename?: 'Slot', readonly id: string, readonly from: string, readonly to: string, readonly weekday: WeekdayEnum } | null> };

export type TodayAppointmentsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  to?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<AppointmentStatusEnum>> | InputMaybe<AppointmentStatusEnum>>;
}>;


export type TodayAppointmentsQuery = { readonly __typename?: 'Query', readonly appointments: ReadonlyArray<{ readonly __typename?: 'Appointment', readonly id: string }> };

export type UserAvailabilityQueryVariables = Exact<{
  host?: InputMaybe<Scalars['ID']['input']>;
  service: Scalars['ID']['input'];
  date: Scalars['DateTime']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserAvailabilityQuery = { readonly __typename?: 'Query', readonly userAvailability?: ReadonlyArray<{ readonly __typename?: 'AvailabilitySlot', readonly available: boolean, readonly is_appointment: boolean, readonly time: ICustomDate, readonly outside_working_hours: boolean }> | null };

export type AppointmentCancelledSubscriptionVariables = Exact<{
  orgId: Scalars['ID']['input'];
  host_id?: InputMaybe<Scalars['ID']['input']>;
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AppointmentCancelledSubscription = { readonly __typename?: 'Subscription', readonly appointmentCancelled?: number | null };

export type AppointmentCreatedSubscriptionVariables = Exact<{
  org_id: Scalars['ID']['input'];
  host_id?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AppointmentCreatedSubscription = { readonly __typename?: 'Subscription', readonly appointmentCreated?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly start_url?: string | null, readonly join_url?: string | null, readonly status: AppointmentStatusEnum, readonly start_app_url?: string | null, readonly join_app_url?: string | null, readonly created_at: ICustomDate, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string } | null> | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly avatar_url?: IResizableImage | null } | null, readonly notes?: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly created_at: ICustomDate } | null> | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly requirement: RequirementType } } | null> | null }> | null, readonly history?: ReadonlyArray<{ readonly __typename?: 'AppointmentHistory', readonly id: string, readonly log_name: AppointmentHistoryActivityEnum, readonly description: string, readonly created_at?: ICustomDate | null, readonly properties?: any | null, readonly causer?: { readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } } | { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } | null> | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly description?: string | null, readonly booking_color?: string | null } | null } | null };

export type AppointmentUpdatedSubscriptionVariables = Exact<{
  org_id: Scalars['ID']['input'];
  host_id?: InputMaybe<Scalars['ID']['input']>;
  appointmentId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AppointmentUpdatedSubscription = { readonly __typename?: 'Subscription', readonly appointmentUpdated?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly status: AppointmentStatusEnum, readonly start_url?: string | null, readonly join_url?: string | null, readonly created_at: ICustomDate, readonly start_app_url?: string | null, readonly join_app_url?: string | null, readonly redox_sending_status?: RedoxSendingStatus | null, readonly documents?: ReadonlyArray<{ readonly __typename?: 'Document', readonly id: string, readonly name: string } | null> | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly join_url?: string | null, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly sms?: string | null, readonly default_notification_channel: NotificationChannelsEnum } }> | null, readonly host?: { readonly __typename?: 'User', readonly id: string } | null, readonly vitals_media?: ReadonlyArray<{ readonly __typename?: 'AppointmentMedia', readonly id: string, readonly url?: IResizableImage | null, readonly created_at?: ICustomDate | null, readonly device?: string | null, readonly file_type?: AppointmentScreenshotTypeEnum | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null } | null> | null, readonly filtered_vitals?: ReadonlyArray<{ readonly __typename?: 'Vital', readonly id: string, readonly name: string, readonly fdata?: any | null } | null> | null } | null };

export type ParticipantStatusUpdatedSubscriptionVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type ParticipantStatusUpdatedSubscription = { readonly __typename?: 'Subscription', readonly participantUpdated?: { readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly token_code?: { readonly __typename?: 'TokenCode', readonly short_link: string } | null } | null };

export type AuthByTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type AuthByTokenMutation = { readonly __typename?: 'Mutation', readonly customAuth?: { readonly __typename?: 'AuthResponse', readonly IdToken: string, readonly RefreshToken: string, readonly AccessToken: string, readonly ExpiresIn: number } | null };

export type ChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type ChangePasswordMutation = { readonly __typename?: 'Mutation', readonly changePassword?: boolean | null };

export type ChangeTemporaryPasswordMutationVariables = Exact<{
  input: ChangeTemporaryPasswordInput;
}>;


export type ChangeTemporaryPasswordMutation = { readonly __typename?: 'Mutation', readonly changeTemporaryPassword?: { readonly __typename?: 'AuthResponse', readonly AccessToken: string, readonly RefreshToken: string, readonly ExpiresIn: number, readonly IdToken: string, readonly TokenType: string, readonly Uid?: string | null } | null };

export type ExchangeCodeForTokenMutationVariables = Exact<{
  code: Scalars['String']['input'];
  forMedcart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ExchangeCodeForTokenMutation = { readonly __typename?: 'Mutation', readonly exchangeCodeForToken?: { readonly __typename?: 'AuthResponse', readonly IdToken: string, readonly RefreshToken: string, readonly AccessToken: string, readonly ExpiresIn: number, readonly Uid?: string | null } | null };

export type ForgotPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { readonly __typename?: 'Mutation', readonly forgotPassword?: boolean | null };

export type LoginMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { readonly __typename?: 'Mutation', readonly login?: { readonly __typename?: 'AuthResponse', readonly AccessToken: string, readonly RefreshToken: string, readonly ExpiresIn: number, readonly IdToken: string, readonly TokenType: string, readonly Uid?: string | null } | { readonly __typename?: 'NewPasswordRequired', readonly Session: string } | null };

export type UpdatePasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type UpdatePasswordMutation = { readonly __typename?: 'Mutation', readonly reset?: boolean | null };

export type IdentityProvidersQueryVariables = Exact<{
  forMedcart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IdentityProvidersQuery = { readonly __typename?: 'Query', readonly identityProviders?: ReadonlyArray<{ readonly __typename?: 'IdentityProvider', readonly name: string, readonly url: string }> | null };

export type ShortTokenMutationVariables = Exact<{
  uid: Scalars['String']['input'];
}>;


export type ShortTokenMutation = { readonly __typename?: 'Mutation', readonly exchangeUid?: string | null };

export type CreateServiceGroupMutationVariables = Exact<{
  input: ServiceGroupInput;
}>;


export type CreateServiceGroupMutation = { readonly __typename?: 'Mutation', readonly createServiceGroup?: { readonly __typename?: 'ServiceGroup', readonly id: string, readonly name: string, readonly services?: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string } | null> | null } | null };

export type DeleteServiceGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteServiceGroupMutation = { readonly __typename?: 'Mutation', readonly deleteServiceGroup?: boolean | null };

export type SaveBookingMutationVariables = Exact<{
  input: OrganizationInput;
}>;


export type SaveBookingMutation = { readonly __typename?: 'Mutation', readonly updateOrganization?: { readonly __typename?: 'Organization', readonly id: string, readonly booking_description?: string | null, readonly booking_page_proposed_timeslot_duration?: number | null } | null };

export type UpdateServiceGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ServiceGroupInput;
}>;


export type UpdateServiceGroupMutation = { readonly __typename?: 'Mutation', readonly updateServiceGroup?: { readonly __typename?: 'ServiceGroup', readonly id: string, readonly name: string, readonly services?: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string } | null> | null } | null };

export type BookingOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingOrganizationQuery = { readonly __typename?: 'Query', readonly organization?: { readonly __typename?: 'Organization', readonly id: string, readonly booking_description?: string | null, readonly booking_page_proposed_timeslot_duration?: number | null } | null };

export type ServiceGroupListQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceGroupListQuery = { readonly __typename?: 'Query', readonly serviceGroups: ReadonlyArray<{ readonly __typename?: 'ServiceGroup', readonly id: string, readonly name: string, readonly services?: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string } | null> | null } | null> };

export type GetServiceGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetServiceGroupQuery = { readonly __typename?: 'Query', readonly serviceGroup?: { readonly __typename?: 'ServiceGroup', readonly id: string, readonly name: string, readonly description?: string | null, readonly services?: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string } | null> | null } | null };

export type CreateServiceGroupServiceListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type CreateServiceGroupServiceListQuery = { readonly __typename?: 'Query', readonly services?: { readonly __typename?: 'ServicePaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string }> } | null };

export type ChangeParticipantStatusMutationVariables = Exact<{
  input: ParticipantStatusInput;
}>;


export type ChangeParticipantStatusMutation = { readonly __typename?: 'Mutation', readonly changeParticipantStatus?: boolean | null };

export type GenerateTwilioTokenMutationVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
}>;


export type GenerateTwilioTokenMutation = { readonly __typename?: 'Mutation', readonly generateTwilioToken?: { readonly __typename?: 'TwilioToken', readonly room?: string | null, readonly token?: string | null } | null };

export type TwilioParticipantUpdatedSubscriptionVariables = Exact<{
  org_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
}>;


export type TwilioParticipantUpdatedSubscription = { readonly __typename?: 'Subscription', readonly twilioParticipantUpdated?: { readonly __typename?: 'ParticipantStatusChanged', readonly enable_audio?: boolean | null, readonly enable_video?: boolean | null } | null };

export type FastRegistrationMutationVariables = Exact<{
  input: CreatePatientWithoutContactInput;
}>;


export type FastRegistrationMutation = { readonly __typename?: 'Mutation', readonly createPatientWithoutContact?: { readonly __typename?: 'AuthResponse', readonly AccessToken: string, readonly RefreshToken: string, readonly ExpiresIn: number, readonly IdToken: string, readonly TokenType: string, readonly Uid?: string | null } | { readonly __typename?: 'NewPasswordRequired' } | null };

export type BookingInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingInfoQuery = { readonly __typename?: 'Query', readonly organization?: { readonly __typename?: 'Organization', readonly id: string, readonly booking_description?: string | null } | null };

export type ServiceByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
}>;


export type ServiceByIdQuery = { readonly __typename?: 'Query', readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly description?: string | null, readonly duration: number, readonly price?: number | null, readonly booking_on_demand: boolean, readonly select_any_provider: boolean, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null> | null } | null };

export type OrganizationMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationMessagesQuery = { readonly __typename?: 'Query', readonly organization_messages?: ReadonlyArray<{ readonly __typename?: 'OrganizationMessage', readonly id: string, readonly type: OrganizationMessageTypeEnum, readonly title?: string | null, readonly content?: string | null } | null> | null };

export type ServiceGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceGroupsQuery = { readonly __typename?: 'Query', readonly serviceGroups: ReadonlyArray<{ readonly __typename?: 'ServiceGroup', readonly id: string, readonly name: string, readonly description?: string | null, readonly services?: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly duration: number, readonly description?: string | null, readonly can_be_scheduled: boolean, readonly booking_on_demand: boolean, readonly select_any_provider: boolean, readonly ondemand_practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string } | null> | null, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null> | null } | null> | null } | null> };

export type ServiceWithProviderQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
  providerId: Scalars['ID']['input'];
}>;


export type ServiceWithProviderQuery = { readonly __typename?: 'Query', readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly description?: string | null, readonly duration: number, readonly price?: number | null, readonly booking_on_demand: boolean } | null, readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null };

export type ServiceQueryVariables = Exact<{
  serviceId: Scalars['ID']['input'];
}>;


export type ServiceQuery = { readonly __typename?: 'Query', readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly description?: string | null, readonly duration: number, readonly price?: number | null, readonly booking_on_demand: boolean, readonly select_any_provider: boolean } | null };

export type CreateAppointmentRequestMutationVariables = Exact<{
  input: CreateAppointmentRequestInput;
}>;


export type CreateAppointmentRequestMutation = { readonly __typename?: 'Mutation', readonly createAppointmentRequest?: { readonly __typename?: 'AppointmentRequest', readonly id: string, readonly start_time?: ICustomDate | null, readonly planned_end_time?: ICustomDate | null } | null };

export type ParticipantAppointmentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ParticipantAppointmentQuery = { readonly __typename?: 'Query', readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly status: AppointmentStatusEnum, readonly message?: string | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly description?: string | null, readonly price?: number | null } | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly phone?: string | null, readonly avatar_url?: IResizableImage | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly join_app_url?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly submitted_at: ICustomDate, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly signature_type: SignatureType } } | null> | null }> | null, readonly invoices?: ReadonlyArray<{ readonly __typename?: 'Invoice', readonly id?: string | null, readonly amount?: number | null, readonly status?: InvoiceStatusEnum | null }> | null } | null };

export type ParticipantRsvpMutationVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
  rsvp: RsvpTypesEnum;
}>;


export type ParticipantRsvpMutation = { readonly __typename?: 'Mutation', readonly participantRsvp?: { readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null } | null };

export type ParticipantAppointmentsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  status?: InputMaybe<ReadonlyArray<InputMaybe<AppointmentStatusEnum>> | InputMaybe<AppointmentStatusEnum>>;
}>;


export type ParticipantAppointmentsQuery = { readonly __typename?: 'Query', readonly patientAppointmentRequests: ReadonlyArray<{ readonly __typename?: 'AppointmentRequest', readonly id: string, readonly start_time?: ICustomDate | null, readonly planned_end_time?: ICustomDate | null, readonly created_at: ICustomDate, readonly message?: string | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly duration: number } | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null } | null>, readonly appointments: ReadonlyArray<{ readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly status: AppointmentStatusEnum, readonly planned_end_time?: ICustomDate | null, readonly message?: string | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly booking_color?: string | null, readonly duration: number } | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly join_app_url?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly fields: any, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly submitted_at: ICustomDate, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType, readonly signature_type: SignatureType } } | null> | null }> | null, readonly invoices?: ReadonlyArray<{ readonly __typename?: 'Invoice', readonly id?: string | null, readonly amount?: number | null, readonly status?: InvoiceStatusEnum | null }> | null }> };

export type HostDocumentSignedSubscriptionVariables = Exact<{
  orgId: Scalars['ID']['input'];
}>;


export type HostDocumentSignedSubscription = { readonly __typename?: 'Subscription', readonly hostDocumentSigned?: string | null };

export type AppointmentsHistoryQueryVariables = Exact<{
  status?: InputMaybe<ReadonlyArray<InputMaybe<AppointmentStatusEnum>> | InputMaybe<AppointmentStatusEnum>>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type AppointmentsHistoryQuery = { readonly __typename?: 'Query', readonly appointmentsConnection?: { readonly __typename?: 'AppointmentConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly endCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'AppointmentEdge', readonly node: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate, readonly planned_end_time?: ICustomDate | null, readonly started_at?: ICustomDate | null, readonly ended_at?: ICustomDate | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly booking_color?: string | null } | null, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly avatar_url?: IResizableImage | null } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly rsvp?: RsvpTypesEnum | null, readonly is_in_meeting?: boolean | null, readonly join_url?: string | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null }, readonly document_submissions?: ReadonlyArray<{ readonly __typename?: 'DocumentSubmission', readonly id: string, readonly fields: any, readonly status: DocumentSubmissionStatusEnum, readonly signed_by_current_user: boolean, readonly document: { readonly __typename?: 'Document', readonly id: string, readonly name: string, readonly requirement: RequirementType } } | null> | null }> | null } }> } | null };

export type CreatePatientMutationVariables = Exact<{
  input: CreatePatientInput;
}>;


export type CreatePatientMutation = { readonly __typename?: 'Mutation', readonly createPatient?: { readonly __typename?: 'Patient', readonly id: string, readonly name: string, readonly email: string, readonly sms?: string | null, readonly phone?: string | null, readonly timezone: string, readonly default_notification_channel: NotificationChannelsEnum, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } | null };

export type UpdatePatientMutationVariables = Exact<{
  input: UpdatePatientInput;
}>;


export type UpdatePatientMutation = { readonly __typename?: 'Mutation', readonly updatePatient?: { readonly __typename?: 'Patient', readonly id: string, readonly name: string, readonly email: string, readonly phone?: string | null, readonly timezone: string, readonly default_notification_channel: NotificationChannelsEnum } | null };

export type PatientListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  where?: InputMaybe<QueryPatientsWhereWhereConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryPatientsOrderByOrderByClause> | QueryPatientsOrderByOrderByClause>;
}>;


export type PatientListQuery = { readonly __typename?: 'Query', readonly patients?: { readonly __typename?: 'PatientPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'Patient', readonly id: string, readonly name: string, readonly email: string, readonly timezone: string, readonly phone?: string | null }> } | null };

export type GetPatientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPatientQuery = { readonly __typename?: 'Query', readonly patient?: { readonly __typename?: 'Patient', readonly id: string, readonly name: string, readonly email: string, readonly phone?: string | null, readonly timezone: string, readonly is_global: boolean, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null, readonly notes?: ReadonlyArray<{ readonly __typename?: 'Note', readonly id: string, readonly content: string, readonly created_at: ICustomDate, readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string, readonly start_time: ICustomDate } | null } | null> | null } | null };

export type RetrieveOrganizationInvoicesQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
  hasParticipant?: InputMaybe<QueryInvoicesHasParticipantWhereHasConditions>;
  where?: InputMaybe<QueryInvoicesWhereWhereConditions>;
  orderBy?: InputMaybe<ReadonlyArray<QueryInvoicesOrderByOrderByClause> | QueryInvoicesOrderByOrderByClause>;
}>;


export type RetrieveOrganizationInvoicesQuery = { readonly __typename?: 'Query', readonly invoices?: { readonly __typename?: 'InvoicePaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'Invoice', readonly id?: string | null, readonly amount?: number | null, readonly status?: InvoiceStatusEnum | null, readonly data?: any | null, readonly participant?: { readonly __typename?: 'Participant', readonly appointment?: { readonly __typename?: 'Appointment', readonly id: string } | null, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly sms?: string | null } } | null }> } | null };

export type ProviderUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ProviderUserQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly timezone: string, readonly enable_ondemand?: boolean | null, readonly avatar_url?: IResizableImage | null } | null };

export type GetLoginsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']['input']>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<QueryLoginReportsOrderByOrderByClause> | QueryLoginReportsOrderByOrderByClause>;
}>;


export type GetLoginsQuery = { readonly __typename?: 'Query', readonly loginReports?: { readonly __typename?: 'LoginReportsPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'LoginReports', readonly id: string, readonly loginDateTime: ICustomDate, readonly userName: string, readonly email?: string | null, readonly action: string, readonly ip?: string | null }> } | null };

export type ReportHostsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReportHostsQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string }> } | null };

export type ParticipantExportQueryVariables = Exact<{
  participantId: Scalars['ID']['input'];
  extension?: InputMaybe<Scalars['String']['input']>;
  browser_identifier: Scalars['String']['input'];
}>;


export type ParticipantExportQuery = { readonly __typename?: 'Query', readonly participantExport?: string | null };

export type SessionsExportQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  sessionId?: InputMaybe<Scalars['ID']['input']>;
  hostId?: InputMaybe<Scalars['ID']['input']>;
  participantIds?: InputMaybe<ReadonlyArray<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
  sessionType?: InputMaybe<SessionTypeEnum>;
  fromDate?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  toDate?: InputMaybe<Scalars['DateTimeFromTz']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<QuerySessionsExportOrderByRelationOrderByClause> | QuerySessionsExportOrderByRelationOrderByClause>;
  extension?: InputMaybe<Scalars['String']['input']>;
  browser_identifier: Scalars['String']['input'];
}>;


export type SessionsExportQuery = { readonly __typename?: 'Query', readonly sessionsExport?: string | null };

export type GetSessionUsageQueryVariables = Exact<{
  hostId?: InputMaybe<Scalars['Int']['input']>;
  sessionType: SessionTypeEnum;
  fromDate: Scalars['DateTimeFromTz']['input'];
  toDate: Scalars['DateTimeFromTz']['input'];
  first: Scalars['Int']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReadonlyArray<QuerySessionsOrderByRelationOrderByClause> | QuerySessionsOrderByRelationOrderByClause>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetSessionUsageQuery = { readonly __typename?: 'Query', readonly sessions?: { readonly __typename?: 'AppointmentPaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'Appointment', readonly id: string, readonly started_at?: ICustomDate | null, readonly duration: number, readonly host?: { readonly __typename?: 'User', readonly id: string, readonly name: string } | null, readonly participants?: ReadonlyArray<{ readonly __typename?: 'Participant', readonly id: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly name: string } }> | null, readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string } | null }> } | null };

export type CreateServiceMutationVariables = Exact<{
  input: ServiceInput;
}>;


export type CreateServiceMutation = { readonly __typename?: 'Mutation', readonly createService?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly duration: number, readonly can_be_scheduled: boolean, readonly price?: number | null, readonly booking_on_demand: boolean, readonly booking_color?: string | null } | null };

export type DeleteServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteServiceMutation = { readonly __typename?: 'Mutation', readonly deleteService?: boolean | null };

export type UpdateServiceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ServiceInput;
}>;


export type UpdateServiceMutation = { readonly __typename?: 'Mutation', readonly updateService?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly duration: number, readonly description?: string | null, readonly can_be_scheduled: boolean, readonly booking_on_demand: boolean, readonly booking_color?: string | null, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null> | null } | null };

export type GetServiceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetServiceQuery = { readonly __typename?: 'Query', readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly duration: number, readonly description?: string | null, readonly can_be_scheduled: boolean, readonly booking_on_demand: boolean, readonly booking_color?: string | null, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string } | null> | null } | null };

export type CreateServicePractitionerListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type CreateServicePractitionerListQuery = { readonly __typename?: 'Query', readonly users?: { readonly __typename?: 'UserPaginator', readonly data: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null }> } | null };

export type ServiceListQueryVariables = Exact<{
  first: Scalars['Int']['input'];
  page: Scalars['Int']['input'];
}>;


export type ServiceListQuery = { readonly __typename?: 'Query', readonly services?: { readonly __typename?: 'ServicePaginator', readonly paginatorInfo: { readonly __typename?: 'PaginatorInfo', readonly currentPage: number, readonly total: number }, readonly data: ReadonlyArray<{ readonly __typename?: 'Service', readonly id: string, readonly name: string, readonly price?: number | null, readonly duration: number }> } | null };

export type GenerateOpentokTokenMutationVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
}>;


export type GenerateOpentokTokenMutation = { readonly __typename?: 'Mutation', readonly generateOpentokToken?: { readonly __typename?: 'OpentokToken', readonly sid?: string | null, readonly token?: string | null } | null };

export type GeneratePubnubKeysMutationVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
}>;


export type GeneratePubnubKeysMutation = { readonly __typename?: 'Mutation', readonly generateOpentokToken?: { readonly __typename?: 'OpentokToken', readonly subscribe_key?: string | null, readonly cipher_key?: string | null, readonly channels?: ReadonlyArray<string> | null } | null };

export type PullQueryVariables = Exact<{
  input: PullInput;
}>;


export type PullQuery = { readonly __typename?: 'Query', readonly pull?: ReadonlyArray<{ readonly __typename?: 'Pulling', readonly id: string, readonly data?: any | null } | null> | null };

export type SharedDataQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedDataQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly id: string, readonly timezone: string, readonly name: string, readonly email?: string | null, readonly phone?: string | null, readonly sms?: string | null, readonly username?: string | null, readonly is_admin?: boolean | null, readonly avatar_url?: IResizableImage | null, readonly has_medcart?: boolean | null, readonly address?: string | null, readonly zip?: string | null, readonly birth_date?: any | null, readonly sex?: SexEnum | null, readonly external_calendar_connected: boolean, readonly device_user?: boolean | null, readonly permissions?: ReadonlyArray<{ readonly __typename?: 'Permission', readonly id: string, readonly name: string } | null> | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string, readonly permissions?: ReadonlyArray<{ readonly __typename?: 'Permission', readonly id: string, readonly name: string } | null> | null } | null> | null, readonly settings: { readonly __typename?: 'UserSettings', readonly user_id?: string | null, readonly notify_scheduler_sessions_sms?: boolean | null, readonly notify_scheduler_sessions_mail?: boolean | null, readonly notify_requests_sms?: boolean | null, readonly notify_requests_mail?: boolean | null, readonly notify_payments_mail?: boolean | null, readonly notify_payments_sms?: boolean | null, readonly notify_updates_sms?: boolean | null, readonly notify_updates_mail?: boolean | null, readonly notify_chat_sms?: boolean | null, readonly notify_chat_mail?: boolean | null, readonly notify_chat_new_chat?: boolean | null, readonly notify_chat_messages?: boolean | null, readonly notify_chat_documents?: boolean | null, readonly notify_docs_sms?: boolean | null, readonly notify_docs_mail?: boolean | null, readonly notify_docs_required?: boolean | null, readonly notify_docs_not_required?: boolean | null, readonly notify_docs_resubmissions?: boolean | null, readonly notify_docs_signed?: boolean | null } } | null };

export type ProvidersForLocationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  location: Scalars['String']['input'];
}>;


export type ProvidersForLocationQuery = { readonly __typename?: 'Query', readonly service?: { readonly __typename?: 'Service', readonly id: string, readonly practitioners?: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly enable_ondemand?: boolean | null, readonly avatar_url?: IResizableImage | null, readonly is_working_hours?: boolean | null, readonly locations?: ReadonlyArray<{ readonly __typename?: 'Location', readonly id: string, readonly name: string, readonly slug: string, readonly pivot?: { readonly __typename?: 'UserLocationPivot', readonly primary?: boolean | null } | null, readonly group?: { readonly __typename?: 'LocationGroup', readonly id: string, readonly name: string } | null } | null> | null } | null> | null } | null };

export type RegisterPatientMutationVariables = Exact<{
  input: CreatePatientInput;
}>;


export type RegisterPatientMutation = { readonly __typename?: 'Mutation', readonly createPatient?: { readonly __typename?: 'Patient', readonly id: string, readonly email: string } | null };

export type InvoiceQueryVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
}>;


export type InvoiceQuery = { readonly __typename?: 'Query', readonly invoice?: { readonly __typename?: 'Invoice', readonly id?: string | null, readonly status?: InvoiceStatusEnum | null, readonly data?: any | null } | null };

export type RetrieveInvoiceQueryVariables = Exact<{
  appointment_id: Scalars['ID']['input'];
}>;


export type RetrieveInvoiceQuery = { readonly __typename?: 'Query', readonly retrieveInvoice?: { readonly __typename?: 'StripeInvoice', readonly client_secret?: string | null, readonly amount?: number | null, readonly currency?: string | null, readonly status?: string | null } | null };

export type SearchContactsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
  exclude?: InputMaybe<ReadonlyArray<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type SearchContactsQuery = { readonly __typename?: 'Query', readonly contacts?: { readonly __typename?: 'UserConnection', readonly pageInfo: { readonly __typename?: 'PageInfo', readonly hasNextPage: boolean, readonly count: number, readonly endCursor?: string | null, readonly startCursor?: string | null }, readonly edges: ReadonlyArray<{ readonly __typename?: 'UserEdge', readonly cursor: string, readonly node: { readonly __typename?: 'User', readonly id: string, readonly name: string, readonly email?: string | null, readonly username?: string | null, readonly avatar_url?: IResizableImage | null, readonly enable_ondemand?: boolean | null, readonly roles?: ReadonlyArray<{ readonly __typename?: 'Role', readonly id: string, readonly name: string } | null> | null } }> } | null };

export const LastMessageFragmentDoc = gql`
    fragment LastMessage on ChatMessage {
  id
  message
  created_at
  files {
    id
    filename
  }
  user {
    id
    name
    created_at
  }
}
    `;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput!) {
  refresh(input: $input) {
    AccessToken
    IdToken
    Uid
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const RolesDocument = gql`
    query Roles {
  roles {
    id
    name
  }
}
    `;

/**
 * __useRolesQuery__
 *
 * To run a query within a React component, call `useRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRolesQuery(baseOptions?: Apollo.QueryHookOptions<RolesQuery, RolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
      }
export function useRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RolesQuery, RolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RolesQuery, RolesQueryVariables>(RolesDocument, options);
        }
export type RolesQueryHookResult = ReturnType<typeof useRolesQuery>;
export type RolesLazyQueryHookResult = ReturnType<typeof useRolesLazyQuery>;
export type RolesQueryResult = Apollo.QueryResult<RolesQuery, RolesQueryVariables>;
export const CreateUserDocument = gql`
    mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    id
    name
    email
    phone
    timezone
    roles {
      id
      name
    }
  }
}
    `;
export type CreateUserMutationFn = Apollo.MutationFunction<CreateUserMutation, CreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateUserMutation, CreateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUserMutation, CreateUserMutationVariables>(CreateUserDocument, options);
      }
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<CreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<CreateUserMutation, CreateUserMutationVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: ID!) {
  deleteUser(id: $id)
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateUserSettingsDocument = gql`
    mutation UpdateUserSettings($input: UserSettingsInput!) {
  updateUserSettings(input: $input) {
    user_id
    notify_scheduler_sessions_sms
    notify_scheduler_sessions_mail
    notify_requests_sms
    notify_requests_mail
    notify_payments_mail
    notify_payments_sms
    notify_updates_sms
    notify_updates_mail
    notify_chat_sms
    notify_chat_mail
    notify_chat_new_chat
    notify_chat_messages
    notify_chat_documents
    notify_docs_sms
    notify_docs_mail
    notify_docs_required
    notify_docs_not_required
    notify_docs_resubmissions
    notify_docs_signed
  }
}
    `;
export type UpdateUserSettingsMutationFn = Apollo.MutationFunction<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;

/**
 * __useUpdateUserSettingsMutation__
 *
 * To run a mutation, you first call `useUpdateUserSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSettingsMutation, { data, loading, error }] = useUpdateUserSettingsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserSettingsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>(UpdateUserSettingsDocument, options);
      }
export type UpdateUserSettingsMutationHookResult = ReturnType<typeof useUpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationResult = Apollo.MutationResult<UpdateUserSettingsMutation>;
export type UpdateUserSettingsMutationOptions = Apollo.BaseMutationOptions<UpdateUserSettingsMutation, UpdateUserSettingsMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    name
    email
    phone
    avatar_url
    timezone
    address
    zip
    birth_date
    sex
    roles {
      id
      name
    }
    has_medcart
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetUserByIdDocument = gql`
    query GetUserById($id: ID!) {
  user(id: $id) {
    id
    name
    email
    phone
    username
    timezone
    roles {
      id
      name
    }
    has_medcart
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const HostsListDocument = gql`
    query HostsList($first: Int!, $page: Int!, $hasRoles: QueryHostsHasRolesWhereHasConditions, $where: QueryHostsWhereWhereConditions, $orderBy: [QueryHostsOrderByRelationOrderByClause!]) {
  hosts(
    first: $first
    page: $page
    hasRoles: $hasRoles
    where: $where
    orderBy: $orderBy
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      name
      email
      timezone
      phone
      roles {
        id
        name
      }
      avatar_url
      is_online
    }
  }
}
    `;

/**
 * __useHostsListQuery__
 *
 * To run a query within a React component, call `useHostsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      hasRoles: // value for 'hasRoles'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useHostsListQuery(baseOptions: Apollo.QueryHookOptions<HostsListQuery, HostsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostsListQuery, HostsListQueryVariables>(HostsListDocument, options);
      }
export function useHostsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostsListQuery, HostsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostsListQuery, HostsListQueryVariables>(HostsListDocument, options);
        }
export type HostsListQueryHookResult = ReturnType<typeof useHostsListQuery>;
export type HostsListLazyQueryHookResult = ReturnType<typeof useHostsListLazyQuery>;
export type HostsListQueryResult = Apollo.QueryResult<HostsListQuery, HostsListQueryVariables>;
export const UserListDocument = gql`
    query UserList($first: Int!, $page: Int!, $hasRoles: QueryUsersHasRolesWhereHasConditions, $where: QueryUsersWhereWhereConditions, $orderBy: [QueryUsersOrderByRelationOrderByClause!]) {
  users(
    first: $first
    page: $page
    hasRoles: $hasRoles
    where: $where
    orderBy: $orderBy
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      name
      email
      timezone
      phone
      roles {
        id
        name
      }
      avatar_url
      is_online
      enable_ondemand
    }
  }
}
    `;

/**
 * __useUserListQuery__
 *
 * To run a query within a React component, call `useUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      hasRoles: // value for 'hasRoles'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserListQuery(baseOptions: Apollo.QueryHookOptions<UserListQuery, UserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
      }
export function useUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListQuery, UserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListQuery, UserListQueryVariables>(UserListDocument, options);
        }
export type UserListQueryHookResult = ReturnType<typeof useUserListQuery>;
export type UserListLazyQueryHookResult = ReturnType<typeof useUserListLazyQuery>;
export type UserListQueryResult = Apollo.QueryResult<UserListQuery, UserListQueryVariables>;
export const CurrentOrganizationDocument = gql`
    query CurrentOrganization {
  organization {
    id
    subdomain
    name
    settings_enable_ondemand
    settings_enable_trustvitals
    logo_url
    favicon_url
    payment_enabled
    support_phone_number
    support_email
    support_info
    palette
    is_medcart_used
    superadmin_settings_sms_enabled
    is_redox_enable
    tracking_code
    stripe_public_key
    vsr_setting
    connected_sessions_count
    connected_sessions_limit
    account_registration_required
    account_without_registration_required_fields
    settings_booking_sms_consent_enabled
    booking_sms_consent_label
    booking_sms_consent_helper_text
  }
}
    `;

/**
 * __useCurrentOrganizationQuery__
 *
 * To run a query within a React component, call `useCurrentOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<CurrentOrganizationQuery, CurrentOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentOrganizationQuery, CurrentOrganizationQueryVariables>(CurrentOrganizationDocument, options);
      }
export function useCurrentOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentOrganizationQuery, CurrentOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentOrganizationQuery, CurrentOrganizationQueryVariables>(CurrentOrganizationDocument, options);
        }
export type CurrentOrganizationQueryHookResult = ReturnType<typeof useCurrentOrganizationQuery>;
export type CurrentOrganizationLazyQueryHookResult = ReturnType<typeof useCurrentOrganizationLazyQuery>;
export type CurrentOrganizationQueryResult = Apollo.QueryResult<CurrentOrganizationQuery, CurrentOrganizationQueryVariables>;
export const SidebarUserDocument = gql`
    query SidebarUser {
  user: me {
    id
    organizations {
      id
      name
      subdomain
      logo_url
      is_active
    }
  }
}
    `;

/**
 * __useSidebarUserQuery__
 *
 * To run a query within a React component, call `useSidebarUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useSidebarUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSidebarUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useSidebarUserQuery(baseOptions?: Apollo.QueryHookOptions<SidebarUserQuery, SidebarUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SidebarUserQuery, SidebarUserQueryVariables>(SidebarUserDocument, options);
      }
export function useSidebarUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SidebarUserQuery, SidebarUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SidebarUserQuery, SidebarUserQueryVariables>(SidebarUserDocument, options);
        }
export type SidebarUserQueryHookResult = ReturnType<typeof useSidebarUserQuery>;
export type SidebarUserLazyQueryHookResult = ReturnType<typeof useSidebarUserLazyQuery>;
export type SidebarUserQueryResult = Apollo.QueryResult<SidebarUserQuery, SidebarUserQueryVariables>;
export const AcceptAppointmentRequestDocument = gql`
    mutation AcceptAppointmentRequest($id: ID!, $hostId: ID, $message: String = null) {
  acceptAppointmentRequest(id: $id, host: $hostId, message: $message) {
    id
  }
}
    `;
export type AcceptAppointmentRequestMutationFn = Apollo.MutationFunction<AcceptAppointmentRequestMutation, AcceptAppointmentRequestMutationVariables>;

/**
 * __useAcceptAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useAcceptAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptAppointmentRequestMutation, { data, loading, error }] = useAcceptAppointmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      hostId: // value for 'hostId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useAcceptAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<AcceptAppointmentRequestMutation, AcceptAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptAppointmentRequestMutation, AcceptAppointmentRequestMutationVariables>(AcceptAppointmentRequestDocument, options);
      }
export type AcceptAppointmentRequestMutationHookResult = ReturnType<typeof useAcceptAppointmentRequestMutation>;
export type AcceptAppointmentRequestMutationResult = Apollo.MutationResult<AcceptAppointmentRequestMutation>;
export type AcceptAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<AcceptAppointmentRequestMutation, AcceptAppointmentRequestMutationVariables>;
export const DeclineAppointmentRequestDocument = gql`
    mutation DeclineAppointmentRequest($id: ID!, $message: String = null) {
  declineAppointmentRequest(id: $id, message: $message)
}
    `;
export type DeclineAppointmentRequestMutationFn = Apollo.MutationFunction<DeclineAppointmentRequestMutation, DeclineAppointmentRequestMutationVariables>;

/**
 * __useDeclineAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useDeclineAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeclineAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [declineAppointmentRequestMutation, { data, loading, error }] = useDeclineAppointmentRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useDeclineAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<DeclineAppointmentRequestMutation, DeclineAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeclineAppointmentRequestMutation, DeclineAppointmentRequestMutationVariables>(DeclineAppointmentRequestDocument, options);
      }
export type DeclineAppointmentRequestMutationHookResult = ReturnType<typeof useDeclineAppointmentRequestMutation>;
export type DeclineAppointmentRequestMutationResult = Apollo.MutationResult<DeclineAppointmentRequestMutation>;
export type DeclineAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<DeclineAppointmentRequestMutation, DeclineAppointmentRequestMutationVariables>;
export const AppointmentRequestsDocument = gql`
    query AppointmentRequests {
  appointmentRequests {
    id
    start_time
    planned_end_time
    service {
      id
      name
      booking_color
      practitioners {
        id
        name
        email
        enable_ondemand
        avatar_url
        is_working_hours
      }
    }
    host {
      id
      name
      avatar_url
    }
    owner {
      id
      name
    }
    location {
      id
      name
      slug
    }
    created_at
    message
  }
}
    `;

/**
 * __useAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>(AppointmentRequestsDocument, options);
      }
export function useAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>(AppointmentRequestsDocument, options);
        }
export type AppointmentRequestsQueryHookResult = ReturnType<typeof useAppointmentRequestsQuery>;
export type AppointmentRequestsLazyQueryHookResult = ReturnType<typeof useAppointmentRequestsLazyQuery>;
export type AppointmentRequestsQueryResult = Apollo.QueryResult<AppointmentRequestsQuery, AppointmentRequestsQueryVariables>;
export const HostAppointmentRequestsDocument = gql`
    query HostAppointmentRequests {
  hostAppointmentRequests {
    id
    start_time
    planned_end_time
    service {
      id
      name
      booking_color
    }
    host {
      id
      name
      avatar_url
    }
    owner {
      id
      name
    }
    created_at
    message
  }
}
    `;

/**
 * __useHostAppointmentRequestsQuery__
 *
 * To run a query within a React component, call `useHostAppointmentRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHostAppointmentRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostAppointmentRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHostAppointmentRequestsQuery(baseOptions?: Apollo.QueryHookOptions<HostAppointmentRequestsQuery, HostAppointmentRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HostAppointmentRequestsQuery, HostAppointmentRequestsQueryVariables>(HostAppointmentRequestsDocument, options);
      }
export function useHostAppointmentRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HostAppointmentRequestsQuery, HostAppointmentRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HostAppointmentRequestsQuery, HostAppointmentRequestsQueryVariables>(HostAppointmentRequestsDocument, options);
        }
export type HostAppointmentRequestsQueryHookResult = ReturnType<typeof useHostAppointmentRequestsQuery>;
export type HostAppointmentRequestsLazyQueryHookResult = ReturnType<typeof useHostAppointmentRequestsLazyQuery>;
export type HostAppointmentRequestsQueryResult = Apollo.QueryResult<HostAppointmentRequestsQuery, HostAppointmentRequestsQueryVariables>;
export const OnDemandRequestsDocument = gql`
    query OnDemandRequests {
  onDemandAppointmentRequests {
    id
    start_time
    planned_end_time
    message
    owner {
      id
      name
      email
      avatar_url
    }
    location {
      id
      name
      slug
    }
    created_at
    service {
      id
      name
      duration
      booking_color
    }
  }
}
    `;

/**
 * __useOnDemandRequestsQuery__
 *
 * To run a query within a React component, call `useOnDemandRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnDemandRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnDemandRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnDemandRequestsQuery(baseOptions?: Apollo.QueryHookOptions<OnDemandRequestsQuery, OnDemandRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnDemandRequestsQuery, OnDemandRequestsQueryVariables>(OnDemandRequestsDocument, options);
      }
export function useOnDemandRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnDemandRequestsQuery, OnDemandRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnDemandRequestsQuery, OnDemandRequestsQueryVariables>(OnDemandRequestsDocument, options);
        }
export type OnDemandRequestsQueryHookResult = ReturnType<typeof useOnDemandRequestsQuery>;
export type OnDemandRequestsLazyQueryHookResult = ReturnType<typeof useOnDemandRequestsLazyQuery>;
export type OnDemandRequestsQueryResult = Apollo.QueryResult<OnDemandRequestsQuery, OnDemandRequestsQueryVariables>;
export const AppointmentRequestCreatedDocument = gql`
    subscription appointmentRequestCreated($orgId: ID!) {
  appointmentRequestCreated(org_id: $orgId) {
    id
  }
}
    `;

/**
 * __useAppointmentRequestCreatedSubscription__
 *
 * To run a query within a React component, call `useAppointmentRequestCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestCreatedSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAppointmentRequestCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentRequestCreatedSubscription, AppointmentRequestCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentRequestCreatedSubscription, AppointmentRequestCreatedSubscriptionVariables>(AppointmentRequestCreatedDocument, options);
      }
export type AppointmentRequestCreatedSubscriptionHookResult = ReturnType<typeof useAppointmentRequestCreatedSubscription>;
export type AppointmentRequestCreatedSubscriptionResult = Apollo.SubscriptionResult<AppointmentRequestCreatedSubscription>;
export const AppointmentRequestStatusUpdatedDocument = gql`
    subscription appointmentRequestStatusUpdated($orgId: ID!) {
  appointmentRequestStatusUpdated(org_id: $orgId) {
    id
  }
}
    `;

/**
 * __useAppointmentRequestStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useAppointmentRequestStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestStatusUpdatedSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useAppointmentRequestStatusUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentRequestStatusUpdatedSubscription, AppointmentRequestStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentRequestStatusUpdatedSubscription, AppointmentRequestStatusUpdatedSubscriptionVariables>(AppointmentRequestStatusUpdatedDocument, options);
      }
export type AppointmentRequestStatusUpdatedSubscriptionHookResult = ReturnType<typeof useAppointmentRequestStatusUpdatedSubscription>;
export type AppointmentRequestStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<AppointmentRequestStatusUpdatedSubscription>;
export const HideAppointmentDocument = gql`
    mutation HideAppointment($id: ID!) {
  hideAppointment(id: $id) {
    id
  }
}
    `;
export type HideAppointmentMutationFn = Apollo.MutationFunction<HideAppointmentMutation, HideAppointmentMutationVariables>;

/**
 * __useHideAppointmentMutation__
 *
 * To run a mutation, you first call `useHideAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideAppointmentMutation, { data, loading, error }] = useHideAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHideAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<HideAppointmentMutation, HideAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideAppointmentMutation, HideAppointmentMutationVariables>(HideAppointmentDocument, options);
      }
export type HideAppointmentMutationHookResult = ReturnType<typeof useHideAppointmentMutation>;
export type HideAppointmentMutationResult = Apollo.MutationResult<HideAppointmentMutation>;
export type HideAppointmentMutationOptions = Apollo.BaseMutationOptions<HideAppointmentMutation, HideAppointmentMutationVariables>;
export const RemindParticipantsDocument = gql`
    mutation RemindParticipants($input: AppointmentReminderInput!) {
  remind(input: $input)
}
    `;
export type RemindParticipantsMutationFn = Apollo.MutationFunction<RemindParticipantsMutation, RemindParticipantsMutationVariables>;

/**
 * __useRemindParticipantsMutation__
 *
 * To run a mutation, you first call `useRemindParticipantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemindParticipantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [remindParticipantsMutation, { data, loading, error }] = useRemindParticipantsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemindParticipantsMutation(baseOptions?: Apollo.MutationHookOptions<RemindParticipantsMutation, RemindParticipantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemindParticipantsMutation, RemindParticipantsMutationVariables>(RemindParticipantsDocument, options);
      }
export type RemindParticipantsMutationHookResult = ReturnType<typeof useRemindParticipantsMutation>;
export type RemindParticipantsMutationResult = Apollo.MutationResult<RemindParticipantsMutation>;
export type RemindParticipantsMutationOptions = Apollo.BaseMutationOptions<RemindParticipantsMutation, RemindParticipantsMutationVariables>;
export const RescheduleAppointmentDocument = gql`
    mutation RescheduleAppointment($id: ID!, $startTime: DateTimeFromTz!) {
  updateAppointment(id: $id, input: {start_time: $startTime}) {
    id
    start_time
    planned_end_time
  }
}
    `;
export type RescheduleAppointmentMutationFn = Apollo.MutationFunction<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;

/**
 * __useRescheduleAppointmentMutation__
 *
 * To run a mutation, you first call `useRescheduleAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleAppointmentMutation, { data, loading, error }] = useRescheduleAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useRescheduleAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>(RescheduleAppointmentDocument, options);
      }
export type RescheduleAppointmentMutationHookResult = ReturnType<typeof useRescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationResult = Apollo.MutationResult<RescheduleAppointmentMutation>;
export type RescheduleAppointmentMutationOptions = Apollo.BaseMutationOptions<RescheduleAppointmentMutation, RescheduleAppointmentMutationVariables>;
export const DuplicateAppointmentDocument = gql`
    mutation DuplicateAppointment($id: ID!, $startTime: DateTimeFromTz!) {
  duplicateAppointment(id: $id, start_time: $startTime) {
    id
  }
}
    `;
export type DuplicateAppointmentMutationFn = Apollo.MutationFunction<DuplicateAppointmentMutation, DuplicateAppointmentMutationVariables>;

/**
 * __useDuplicateAppointmentMutation__
 *
 * To run a mutation, you first call `useDuplicateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAppointmentMutation, { data, loading, error }] = useDuplicateAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useDuplicateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateAppointmentMutation, DuplicateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateAppointmentMutation, DuplicateAppointmentMutationVariables>(DuplicateAppointmentDocument, options);
      }
export type DuplicateAppointmentMutationHookResult = ReturnType<typeof useDuplicateAppointmentMutation>;
export type DuplicateAppointmentMutationResult = Apollo.MutationResult<DuplicateAppointmentMutation>;
export type DuplicateAppointmentMutationOptions = Apollo.BaseMutationOptions<DuplicateAppointmentMutation, DuplicateAppointmentMutationVariables>;
export const CreateChatDocument = gql`
    mutation CreateChat($input: CreateChatInput) {
  createChat(input: $input) {
    id
    type
    last_activity_at
    chat_archived
    users {
      id
      name
      email
    }
    causer {
      id
    }
    appointment {
      id
      service {
        id
        name
        booking_color
      }
    }
    last_message {
      id
      message
      created_at
      files {
        id
        filename
      }
      user {
        id
        name
        created_at
      }
    }
    chat_users {
      id
      user {
        id
      }
      unread_messages_count
    }
  }
}
    `;
export type CreateChatMutationFn = Apollo.MutationFunction<CreateChatMutation, CreateChatMutationVariables>;

/**
 * __useCreateChatMutation__
 *
 * To run a mutation, you first call `useCreateChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createChatMutation, { data, loading, error }] = useCreateChatMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateChatMutation(baseOptions?: Apollo.MutationHookOptions<CreateChatMutation, CreateChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateChatMutation, CreateChatMutationVariables>(CreateChatDocument, options);
      }
export type CreateChatMutationHookResult = ReturnType<typeof useCreateChatMutation>;
export type CreateChatMutationResult = Apollo.MutationResult<CreateChatMutation>;
export type CreateChatMutationOptions = Apollo.BaseMutationOptions<CreateChatMutation, CreateChatMutationVariables>;
export const SendMessageDocument = gql`
    mutation SendMessage($input: ChatMessageInput!) {
  sendChatMessage(input: $input) {
    id
    message
    user {
      id
      name
    }
    files {
      id
      path
      size
      mimetype
      filename
    }
    created_at
  }
}
    `;
export type SendMessageMutationFn = Apollo.MutationFunction<SendMessageMutation, SendMessageMutationVariables>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendMessageMutation(baseOptions?: Apollo.MutationHookOptions<SendMessageMutation, SendMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, options);
      }
export type SendMessageMutationHookResult = ReturnType<typeof useSendMessageMutation>;
export type SendMessageMutationResult = Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<SendMessageMutation, SendMessageMutationVariables>;
export const ArchivedChatsDocument = gql`
    query ArchivedChats {
  archivedChats {
    id
    type
    last_activity_at
    chat_archived
    users {
      id
      name
      email
    }
    causer {
      id
    }
    appointment {
      id
      service {
        id
        name
        booking_color
      }
    }
    last_message {
      id
      message
      created_at
      files {
        id
        filename
      }
      user {
        id
        name
        created_at
      }
    }
    chat_users {
      id
      user {
        id
      }
      unread_messages_count
    }
  }
}
    `;

/**
 * __useArchivedChatsQuery__
 *
 * To run a query within a React component, call `useArchivedChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchivedChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchivedChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useArchivedChatsQuery(baseOptions?: Apollo.QueryHookOptions<ArchivedChatsQuery, ArchivedChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchivedChatsQuery, ArchivedChatsQueryVariables>(ArchivedChatsDocument, options);
      }
export function useArchivedChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchivedChatsQuery, ArchivedChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchivedChatsQuery, ArchivedChatsQueryVariables>(ArchivedChatsDocument, options);
        }
export type ArchivedChatsQueryHookResult = ReturnType<typeof useArchivedChatsQuery>;
export type ArchivedChatsLazyQueryHookResult = ReturnType<typeof useArchivedChatsLazyQuery>;
export type ArchivedChatsQueryResult = Apollo.QueryResult<ArchivedChatsQuery, ArchivedChatsQueryVariables>;
export const ChatDocument = gql`
    query Chat($id: ID!) {
  chat(chat_id: $id) {
    id
    type
    last_activity_at
    chat_archived
    users {
      id
      name
      email
    }
    causer {
      id
      name
      avatar_url
    }
    appointment {
      id
      service {
        id
        name
        booking_color
      }
      participants {
        id
        token_code {
          short_link
        }
        user {
          id
        }
      }
    }
    last_message {
      id
      message
      created_at
      files {
        id
        filename
      }
      user {
        id
        name
        created_at
      }
    }
    chat_users {
      id
      user {
        id
      }
      unread_messages_count
    }
  }
}
    `;

/**
 * __useChatQuery__
 *
 * To run a query within a React component, call `useChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useChatQuery(baseOptions: Apollo.QueryHookOptions<ChatQuery, ChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
      }
export function useChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChatQuery, ChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChatQuery, ChatQueryVariables>(ChatDocument, options);
        }
export type ChatQueryHookResult = ReturnType<typeof useChatQuery>;
export type ChatLazyQueryHookResult = ReturnType<typeof useChatLazyQuery>;
export type ChatQueryResult = Apollo.QueryResult<ChatQuery, ChatQueryVariables>;
export const AllChatsDocument = gql`
    query AllChats {
  chats {
    id
    type
    last_activity_at
    chat_archived
    users {
      id
      name
      email
    }
    causer {
      id
    }
    appointment {
      id
      service {
        id
        name
        booking_color
      }
      participants {
        id
        token_code {
          short_link
        }
        user {
          id
        }
      }
    }
    last_message {
      id
      message
      created_at
      files {
        id
        filename
      }
      user {
        id
        name
        created_at
      }
    }
    chat_users {
      id
      user {
        id
      }
      unread_messages_count
    }
  }
}
    `;

/**
 * __useAllChatsQuery__
 *
 * To run a query within a React component, call `useAllChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllChatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllChatsQuery(baseOptions?: Apollo.QueryHookOptions<AllChatsQuery, AllChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllChatsQuery, AllChatsQueryVariables>(AllChatsDocument, options);
      }
export function useAllChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllChatsQuery, AllChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllChatsQuery, AllChatsQueryVariables>(AllChatsDocument, options);
        }
export type AllChatsQueryHookResult = ReturnType<typeof useAllChatsQuery>;
export type AllChatsLazyQueryHookResult = ReturnType<typeof useAllChatsLazyQuery>;
export type AllChatsQueryResult = Apollo.QueryResult<AllChatsQuery, AllChatsQueryVariables>;
export const CurrentChatDocument = gql`
    query CurrentChat($id: ID!) {
  chat(chat_id: $id) {
    id
    type
    last_activity_at
    chat_archived
    users {
      id
      email
      name
      avatar_url
    }
    causer {
      id
      avatar_url
      name
    }
    appointment {
      id
      status
      host {
        id
      }
      service {
        id
        name
        booking_color
      }
      participants {
        id
        token_code {
          short_link
        }
        user {
          id
        }
      }
    }
    last_message {
      id
      message
      created_at
      user {
        id
        name
        created_at
      }
      files {
        id
        filename
      }
    }
    chat_users {
      id
      user {
        id
        name
        avatar_url
        roles {
          id
          name
        }
      }
      unread_messages_count
    }
  }
}
    `;

/**
 * __useCurrentChatQuery__
 *
 * To run a query within a React component, call `useCurrentChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentChatQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCurrentChatQuery(baseOptions: Apollo.QueryHookOptions<CurrentChatQuery, CurrentChatQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentChatQuery, CurrentChatQueryVariables>(CurrentChatDocument, options);
      }
export function useCurrentChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentChatQuery, CurrentChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentChatQuery, CurrentChatQueryVariables>(CurrentChatDocument, options);
        }
export type CurrentChatQueryHookResult = ReturnType<typeof useCurrentChatQuery>;
export type CurrentChatLazyQueryHookResult = ReturnType<typeof useCurrentChatLazyQuery>;
export type CurrentChatQueryResult = Apollo.QueryResult<CurrentChatQuery, CurrentChatQueryVariables>;
export const MessagesDocument = gql`
    query Messages($id: ID!, $first: Int!, $page: Int!) {
  chatMessages(chat_id: $id, first: $first, page: $page) {
    paginatorInfo {
      count
      hasMorePages
      total
    }
    data {
      id
      message
      user {
        id
        name
      }
      files {
        id
        path
        size
        mimetype
        filename
      }
      created_at
    }
  }
}
    `;

/**
 * __useMessagesQuery__
 *
 * To run a query within a React component, call `useMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMessagesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMessagesQuery(baseOptions: Apollo.QueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
      }
export function useMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MessagesQuery, MessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MessagesQuery, MessagesQueryVariables>(MessagesDocument, options);
        }
export type MessagesQueryHookResult = ReturnType<typeof useMessagesQuery>;
export type MessagesLazyQueryHookResult = ReturnType<typeof useMessagesLazyQuery>;
export type MessagesQueryResult = Apollo.QueryResult<MessagesQuery, MessagesQueryVariables>;
export const SetMessageAsSeenDocument = gql`
    mutation SetMessageAsSeen($message_id: ID!) {
  setMessageAsSeen(message_id: $message_id) {
    id
  }
}
    `;
export type SetMessageAsSeenMutationFn = Apollo.MutationFunction<SetMessageAsSeenMutation, SetMessageAsSeenMutationVariables>;

/**
 * __useSetMessageAsSeenMutation__
 *
 * To run a mutation, you first call `useSetMessageAsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMessageAsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMessageAsSeenMutation, { data, loading, error }] = useSetMessageAsSeenMutation({
 *   variables: {
 *      message_id: // value for 'message_id'
 *   },
 * });
 */
export function useSetMessageAsSeenMutation(baseOptions?: Apollo.MutationHookOptions<SetMessageAsSeenMutation, SetMessageAsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMessageAsSeenMutation, SetMessageAsSeenMutationVariables>(SetMessageAsSeenDocument, options);
      }
export type SetMessageAsSeenMutationHookResult = ReturnType<typeof useSetMessageAsSeenMutation>;
export type SetMessageAsSeenMutationResult = Apollo.MutationResult<SetMessageAsSeenMutation>;
export type SetMessageAsSeenMutationOptions = Apollo.BaseMutationOptions<SetMessageAsSeenMutation, SetMessageAsSeenMutationVariables>;
export const AppointmentChatsDocument = gql`
    query AppointmentChats($id: ID!) {
  chats(appointment_id: $id) {
    id
    type
    last_activity_at
    users {
      id
      name
      email
      avatar_url
    }
    causer {
      id
      name
      avatar_url
    }
    appointment {
      id
      service {
        id
        name
        booking_color
      }
    }
    last_message {
      id
      message
      created_at
      files {
        id
        filename
      }
      user {
        id
        name
        created_at
      }
    }
    chat_users {
      id
      user {
        id
        name
        avatar_url
      }
      unread_messages_count
    }
  }
}
    `;

/**
 * __useAppointmentChatsQuery__
 *
 * To run a query within a React component, call `useAppointmentChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentChatsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentChatsQuery(baseOptions: Apollo.QueryHookOptions<AppointmentChatsQuery, AppointmentChatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentChatsQuery, AppointmentChatsQueryVariables>(AppointmentChatsDocument, options);
      }
export function useAppointmentChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentChatsQuery, AppointmentChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentChatsQuery, AppointmentChatsQueryVariables>(AppointmentChatsDocument, options);
        }
export type AppointmentChatsQueryHookResult = ReturnType<typeof useAppointmentChatsQuery>;
export type AppointmentChatsLazyQueryHookResult = ReturnType<typeof useAppointmentChatsLazyQuery>;
export type AppointmentChatsQueryResult = Apollo.QueryResult<AppointmentChatsQuery, AppointmentChatsQueryVariables>;
export const CurrentOrganizationIdDocument = gql`
    query CurrentOrganizationId {
  organization {
    id
  }
}
    `;

/**
 * __useCurrentOrganizationIdQuery__
 *
 * To run a query within a React component, call `useCurrentOrganizationIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentOrganizationIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentOrganizationIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentOrganizationIdQuery(baseOptions?: Apollo.QueryHookOptions<CurrentOrganizationIdQuery, CurrentOrganizationIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentOrganizationIdQuery, CurrentOrganizationIdQueryVariables>(CurrentOrganizationIdDocument, options);
      }
export function useCurrentOrganizationIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentOrganizationIdQuery, CurrentOrganizationIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentOrganizationIdQuery, CurrentOrganizationIdQueryVariables>(CurrentOrganizationIdDocument, options);
        }
export type CurrentOrganizationIdQueryHookResult = ReturnType<typeof useCurrentOrganizationIdQuery>;
export type CurrentOrganizationIdLazyQueryHookResult = ReturnType<typeof useCurrentOrganizationIdLazyQuery>;
export type CurrentOrganizationIdQueryResult = Apollo.QueryResult<CurrentOrganizationIdQuery, CurrentOrganizationIdQueryVariables>;
export const ChatEventDocument = gql`
    subscription ChatEvent($orgId: ID!) {
  chat(org_id: $orgId) {
    type
    unread
    item {
      ... on Chat {
        id
        type
        last_activity_at
        chat_archived
        users {
          id
          name
          email
          avatar_url
        }
        causer {
          id
          name
          avatar_url
        }
        appointment {
          id
          service {
            id
            name
            booking_color
          }
          participants {
            id
            token_code {
              short_link
            }
            user {
              id
            }
          }
        }
        last_message {
          ...LastMessage
        }
        chat_users {
          id
          user {
            id
            name
            avatar_url
          }
          unread_messages_count
        }
      }
      ... on ChatMessage {
        id
        message
        user {
          id
          name
        }
        chat {
          id
          last_message {
            ...LastMessage
          }
          last_activity_at
          chat_users {
            id
            user {
              id
            }
            unread_messages_count
          }
        }
        files {
          id
          path
          size
          mimetype
          filename
        }
        created_at
      }
    }
  }
}
    ${LastMessageFragmentDoc}`;

/**
 * __useChatEventSubscription__
 *
 * To run a query within a React component, call `useChatEventSubscription` and pass it any options that fit your needs.
 * When your component renders, `useChatEventSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatEventSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useChatEventSubscription(baseOptions: Apollo.SubscriptionHookOptions<ChatEventSubscription, ChatEventSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ChatEventSubscription, ChatEventSubscriptionVariables>(ChatEventDocument, options);
      }
export type ChatEventSubscriptionHookResult = ReturnType<typeof useChatEventSubscription>;
export type ChatEventSubscriptionResult = Apollo.SubscriptionResult<ChatEventSubscription>;
export const UnreadMessagesCountDocument = gql`
    query UnreadMessagesCount {
  countNewMessages
}
    `;

/**
 * __useUnreadMessagesCountQuery__
 *
 * To run a query within a React component, call `useUnreadMessagesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useUnreadMessagesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUnreadMessagesCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useUnreadMessagesCountQuery(baseOptions?: Apollo.QueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(UnreadMessagesCountDocument, options);
      }
export function useUnreadMessagesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>(UnreadMessagesCountDocument, options);
        }
export type UnreadMessagesCountQueryHookResult = ReturnType<typeof useUnreadMessagesCountQuery>;
export type UnreadMessagesCountLazyQueryHookResult = ReturnType<typeof useUnreadMessagesCountLazyQuery>;
export type UnreadMessagesCountQueryResult = Apollo.QueryResult<UnreadMessagesCountQuery, UnreadMessagesCountQueryVariables>;
export const ArchiveChatDocument = gql`
    mutation ArchiveChat($id: ID!) {
  archiveChat(chat_id: $id) {
    id
    chat_archived
  }
}
    `;
export type ArchiveChatMutationFn = Apollo.MutationFunction<ArchiveChatMutation, ArchiveChatMutationVariables>;

/**
 * __useArchiveChatMutation__
 *
 * To run a mutation, you first call `useArchiveChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveChatMutation, { data, loading, error }] = useArchiveChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveChatMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveChatMutation, ArchiveChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveChatMutation, ArchiveChatMutationVariables>(ArchiveChatDocument, options);
      }
export type ArchiveChatMutationHookResult = ReturnType<typeof useArchiveChatMutation>;
export type ArchiveChatMutationResult = Apollo.MutationResult<ArchiveChatMutation>;
export type ArchiveChatMutationOptions = Apollo.BaseMutationOptions<ArchiveChatMutation, ArchiveChatMutationVariables>;
export const DeleteChatDocument = gql`
    mutation DeleteChat($id: ID!) {
  deleteChat(chat_id: $id) {
    id
  }
}
    `;
export type DeleteChatMutationFn = Apollo.MutationFunction<DeleteChatMutation, DeleteChatMutationVariables>;

/**
 * __useDeleteChatMutation__
 *
 * To run a mutation, you first call `useDeleteChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteChatMutation, { data, loading, error }] = useDeleteChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteChatMutation(baseOptions?: Apollo.MutationHookOptions<DeleteChatMutation, DeleteChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteChatMutation, DeleteChatMutationVariables>(DeleteChatDocument, options);
      }
export type DeleteChatMutationHookResult = ReturnType<typeof useDeleteChatMutation>;
export type DeleteChatMutationResult = Apollo.MutationResult<DeleteChatMutation>;
export type DeleteChatMutationOptions = Apollo.BaseMutationOptions<DeleteChatMutation, DeleteChatMutationVariables>;
export const UnArchiveChatDocument = gql`
    mutation UnArchiveChat($id: ID!) {
  unArchiveChat(chat_id: $id) {
    id
    chat_archived
  }
}
    `;
export type UnArchiveChatMutationFn = Apollo.MutationFunction<UnArchiveChatMutation, UnArchiveChatMutationVariables>;

/**
 * __useUnArchiveChatMutation__
 *
 * To run a mutation, you first call `useUnArchiveChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnArchiveChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unArchiveChatMutation, { data, loading, error }] = useUnArchiveChatMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnArchiveChatMutation(baseOptions?: Apollo.MutationHookOptions<UnArchiveChatMutation, UnArchiveChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnArchiveChatMutation, UnArchiveChatMutationVariables>(UnArchiveChatDocument, options);
      }
export type UnArchiveChatMutationHookResult = ReturnType<typeof useUnArchiveChatMutation>;
export type UnArchiveChatMutationResult = Apollo.MutationResult<UnArchiveChatMutation>;
export type UnArchiveChatMutationOptions = Apollo.BaseMutationOptions<UnArchiveChatMutation, UnArchiveChatMutationVariables>;
export const CreateDocumentPacketDocument = gql`
    mutation CreateDocumentPacket($input: DocumentPacketInput) {
  createDocumentPacket(input: $input) {
    id
    name
    documents {
      id
      name
      is_enabled
      can_be_viewed_by_everybody
      signature_type
      requirement
      fields
      created_at
      updated_at
    }
  }
}
    `;
export type CreateDocumentPacketMutationFn = Apollo.MutationFunction<CreateDocumentPacketMutation, CreateDocumentPacketMutationVariables>;

/**
 * __useCreateDocumentPacketMutation__
 *
 * To run a mutation, you first call `useCreateDocumentPacketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentPacketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentPacketMutation, { data, loading, error }] = useCreateDocumentPacketMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentPacketMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentPacketMutation, CreateDocumentPacketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentPacketMutation, CreateDocumentPacketMutationVariables>(CreateDocumentPacketDocument, options);
      }
export type CreateDocumentPacketMutationHookResult = ReturnType<typeof useCreateDocumentPacketMutation>;
export type CreateDocumentPacketMutationResult = Apollo.MutationResult<CreateDocumentPacketMutation>;
export type CreateDocumentPacketMutationOptions = Apollo.BaseMutationOptions<CreateDocumentPacketMutation, CreateDocumentPacketMutationVariables>;
export const CreateDocumentTemplateDocument = gql`
    mutation CreateDocumentTemplate($input: DocumentInput) {
  createDocument(input: $input) {
    id
    name
    can_be_viewed_by_everybody
    is_enabled
    signature_type
    requirement
    fields
  }
}
    `;
export type CreateDocumentTemplateMutationFn = Apollo.MutationFunction<CreateDocumentTemplateMutation, CreateDocumentTemplateMutationVariables>;

/**
 * __useCreateDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useCreateDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDocumentTemplateMutation, { data, loading, error }] = useCreateDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDocumentTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateDocumentTemplateMutation, CreateDocumentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDocumentTemplateMutation, CreateDocumentTemplateMutationVariables>(CreateDocumentTemplateDocument, options);
      }
export type CreateDocumentTemplateMutationHookResult = ReturnType<typeof useCreateDocumentTemplateMutation>;
export type CreateDocumentTemplateMutationResult = Apollo.MutationResult<CreateDocumentTemplateMutation>;
export type CreateDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<CreateDocumentTemplateMutation, CreateDocumentTemplateMutationVariables>;
export const DeleteDocumentPacketDocument = gql`
    mutation DeleteDocumentPacket($id: ID!) {
  deleteDocumentPacket(id: $id) {
    id
  }
}
    `;
export type DeleteDocumentPacketMutationFn = Apollo.MutationFunction<DeleteDocumentPacketMutation, DeleteDocumentPacketMutationVariables>;

/**
 * __useDeleteDocumentPacketMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentPacketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentPacketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentPacketMutation, { data, loading, error }] = useDeleteDocumentPacketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentPacketMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentPacketMutation, DeleteDocumentPacketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentPacketMutation, DeleteDocumentPacketMutationVariables>(DeleteDocumentPacketDocument, options);
      }
export type DeleteDocumentPacketMutationHookResult = ReturnType<typeof useDeleteDocumentPacketMutation>;
export type DeleteDocumentPacketMutationResult = Apollo.MutationResult<DeleteDocumentPacketMutation>;
export type DeleteDocumentPacketMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentPacketMutation, DeleteDocumentPacketMutationVariables>;
export const DeleteDocumentSubmissionDocument = gql`
    mutation DeleteDocumentSubmission($id: ID!) {
  deleteDocumentSubmission(id: $id)
}
    `;
export type DeleteDocumentSubmissionMutationFn = Apollo.MutationFunction<DeleteDocumentSubmissionMutation, DeleteDocumentSubmissionMutationVariables>;

/**
 * __useDeleteDocumentSubmissionMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentSubmissionMutation, { data, loading, error }] = useDeleteDocumentSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentSubmissionMutation, DeleteDocumentSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentSubmissionMutation, DeleteDocumentSubmissionMutationVariables>(DeleteDocumentSubmissionDocument, options);
      }
export type DeleteDocumentSubmissionMutationHookResult = ReturnType<typeof useDeleteDocumentSubmissionMutation>;
export type DeleteDocumentSubmissionMutationResult = Apollo.MutationResult<DeleteDocumentSubmissionMutation>;
export type DeleteDocumentSubmissionMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentSubmissionMutation, DeleteDocumentSubmissionMutationVariables>;
export const DeleteDocumentDocument = gql`
    mutation DeleteDocument($id: ID!) {
  deleteDocument(id: $id) {
    id
  }
}
    `;
export type DeleteDocumentMutationFn = Apollo.MutationFunction<DeleteDocumentMutation, DeleteDocumentMutationVariables>;

/**
 * __useDeleteDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDocumentMutation, { data, loading, error }] = useDeleteDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDocumentMutation, DeleteDocumentMutationVariables>(DeleteDocumentDocument, options);
      }
export type DeleteDocumentMutationHookResult = ReturnType<typeof useDeleteDocumentMutation>;
export type DeleteDocumentMutationResult = Apollo.MutationResult<DeleteDocumentMutation>;
export type DeleteDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteDocumentMutation, DeleteDocumentMutationVariables>;
export const FillDocumentSubmissionDocument = gql`
    mutation FillDocumentSubmission($id: ID!, $results: JSON!) {
  fillDocumentSubmission(id: $id, results: $results) {
    id
  }
}
    `;
export type FillDocumentSubmissionMutationFn = Apollo.MutationFunction<FillDocumentSubmissionMutation, FillDocumentSubmissionMutationVariables>;

/**
 * __useFillDocumentSubmissionMutation__
 *
 * To run a mutation, you first call `useFillDocumentSubmissionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFillDocumentSubmissionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fillDocumentSubmissionMutation, { data, loading, error }] = useFillDocumentSubmissionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      results: // value for 'results'
 *   },
 * });
 */
export function useFillDocumentSubmissionMutation(baseOptions?: Apollo.MutationHookOptions<FillDocumentSubmissionMutation, FillDocumentSubmissionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FillDocumentSubmissionMutation, FillDocumentSubmissionMutationVariables>(FillDocumentSubmissionDocument, options);
      }
export type FillDocumentSubmissionMutationHookResult = ReturnType<typeof useFillDocumentSubmissionMutation>;
export type FillDocumentSubmissionMutationResult = Apollo.MutationResult<FillDocumentSubmissionMutation>;
export type FillDocumentSubmissionMutationOptions = Apollo.BaseMutationOptions<FillDocumentSubmissionMutation, FillDocumentSubmissionMutationVariables>;
export const GenerateDocumentPdfDocument = gql`
    mutation GenerateDocumentPDF($id: ID!) {
  generateDocumentPDF(id: $id)
}
    `;
export type GenerateDocumentPdfMutationFn = Apollo.MutationFunction<GenerateDocumentPdfMutation, GenerateDocumentPdfMutationVariables>;

/**
 * __useGenerateDocumentPdfMutation__
 *
 * To run a mutation, you first call `useGenerateDocumentPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateDocumentPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateDocumentPdfMutation, { data, loading, error }] = useGenerateDocumentPdfMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGenerateDocumentPdfMutation(baseOptions?: Apollo.MutationHookOptions<GenerateDocumentPdfMutation, GenerateDocumentPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateDocumentPdfMutation, GenerateDocumentPdfMutationVariables>(GenerateDocumentPdfDocument, options);
      }
export type GenerateDocumentPdfMutationHookResult = ReturnType<typeof useGenerateDocumentPdfMutation>;
export type GenerateDocumentPdfMutationResult = Apollo.MutationResult<GenerateDocumentPdfMutation>;
export type GenerateDocumentPdfMutationOptions = Apollo.BaseMutationOptions<GenerateDocumentPdfMutation, GenerateDocumentPdfMutationVariables>;
export const SubmitDocumentDocument = gql`
    mutation SubmitDocument($id: ID!, $input: SignDocumentSubmissionInput) {
  submitDocument(id: $id, input: $input) {
    id
    fields
    results
    status
    signed_by_current_user
    document {
      id
      name
      requirement
      signature_type
      updated_at
    }
    signatures {
      id
      sign_name
      drawing_url
      ip
      created_at
      user {
        id
        name
      }
    }
    participant {
      id
      user {
        id
        name
      }
      document_submissions {
        id
        status
        signed_by_current_user
        document {
          id
          name
          signature_type
        }
      }
    }
    appointment {
      id
      host_participant {
        id
        document_submissions {
          id
          status
          signed_by_current_user
          document {
            id
            name
            signature_type
          }
        }
      }
    }
  }
}
    `;
export type SubmitDocumentMutationFn = Apollo.MutationFunction<SubmitDocumentMutation, SubmitDocumentMutationVariables>;

/**
 * __useSubmitDocumentMutation__
 *
 * To run a mutation, you first call `useSubmitDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitDocumentMutation, { data, loading, error }] = useSubmitDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SubmitDocumentMutation, SubmitDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitDocumentMutation, SubmitDocumentMutationVariables>(SubmitDocumentDocument, options);
      }
export type SubmitDocumentMutationHookResult = ReturnType<typeof useSubmitDocumentMutation>;
export type SubmitDocumentMutationResult = Apollo.MutationResult<SubmitDocumentMutation>;
export type SubmitDocumentMutationOptions = Apollo.BaseMutationOptions<SubmitDocumentMutation, SubmitDocumentMutationVariables>;
export const SyncDocumentSubmissionsDocument = gql`
    mutation SyncDocumentSubmissions($input: DocumentSubmissionInput!) {
  syncDocumentSubmissions(input: $input) {
    id
    status
    document {
      id
      name
      requirement
      can_be_viewed_by_everybody
      signature_type
    }
    signatures {
      id
      created_at
      user {
        id
        name
      }
    }
    submitted_at
    signed_by_current_user
  }
}
    `;
export type SyncDocumentSubmissionsMutationFn = Apollo.MutationFunction<SyncDocumentSubmissionsMutation, SyncDocumentSubmissionsMutationVariables>;

/**
 * __useSyncDocumentSubmissionsMutation__
 *
 * To run a mutation, you first call `useSyncDocumentSubmissionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncDocumentSubmissionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncDocumentSubmissionsMutation, { data, loading, error }] = useSyncDocumentSubmissionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSyncDocumentSubmissionsMutation(baseOptions?: Apollo.MutationHookOptions<SyncDocumentSubmissionsMutation, SyncDocumentSubmissionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncDocumentSubmissionsMutation, SyncDocumentSubmissionsMutationVariables>(SyncDocumentSubmissionsDocument, options);
      }
export type SyncDocumentSubmissionsMutationHookResult = ReturnType<typeof useSyncDocumentSubmissionsMutation>;
export type SyncDocumentSubmissionsMutationResult = Apollo.MutationResult<SyncDocumentSubmissionsMutation>;
export type SyncDocumentSubmissionsMutationOptions = Apollo.BaseMutationOptions<SyncDocumentSubmissionsMutation, SyncDocumentSubmissionsMutationVariables>;
export const UpdateDocumentPacketDocument = gql`
    mutation UpdateDocumentPacket($id: ID!, $input: DocumentPacketInput) {
  updateDocumentPacket(id: $id, input: $input) {
    id
    name
    documents {
      id
      name
      is_enabled
      can_be_viewed_by_everybody
      signature_type
      requirement
      fields
      created_at
      updated_at
    }
  }
}
    `;
export type UpdateDocumentPacketMutationFn = Apollo.MutationFunction<UpdateDocumentPacketMutation, UpdateDocumentPacketMutationVariables>;

/**
 * __useUpdateDocumentPacketMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentPacketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentPacketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentPacketMutation, { data, loading, error }] = useUpdateDocumentPacketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentPacketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentPacketMutation, UpdateDocumentPacketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentPacketMutation, UpdateDocumentPacketMutationVariables>(UpdateDocumentPacketDocument, options);
      }
export type UpdateDocumentPacketMutationHookResult = ReturnType<typeof useUpdateDocumentPacketMutation>;
export type UpdateDocumentPacketMutationResult = Apollo.MutationResult<UpdateDocumentPacketMutation>;
export type UpdateDocumentPacketMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentPacketMutation, UpdateDocumentPacketMutationVariables>;
export const UpdateDocumentDocument = gql`
    mutation UpdateDocument($id: ID!, $input: DocumentInput) {
  updateDocument(id: $id, input: $input) {
    id
    name
    can_be_viewed_by_everybody
    is_enabled
    signature_type
    requirement
    fields
  }
}
    `;
export type UpdateDocumentMutationFn = Apollo.MutationFunction<UpdateDocumentMutation, UpdateDocumentMutationVariables>;

/**
 * __useUpdateDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDocumentMutation, { data, loading, error }] = useUpdateDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDocumentMutation, UpdateDocumentMutationVariables>(UpdateDocumentDocument, options);
      }
export type UpdateDocumentMutationHookResult = ReturnType<typeof useUpdateDocumentMutation>;
export type UpdateDocumentMutationResult = Apollo.MutationResult<UpdateDocumentMutation>;
export type UpdateDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateDocumentMutation, UpdateDocumentMutationVariables>;
export const DocumentPacketDocument = gql`
    query DocumentPacket($id: ID!) {
  documentPacket(id: $id) {
    id
    name
    documents {
      id
      name
      is_enabled
      can_be_viewed_by_everybody
      signature_type
      requirement
      fields
      created_at
      updated_at
    }
  }
}
    `;

/**
 * __useDocumentPacketQuery__
 *
 * To run a query within a React component, call `useDocumentPacketQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentPacketQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentPacketQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentPacketQuery(baseOptions: Apollo.QueryHookOptions<DocumentPacketQuery, DocumentPacketQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentPacketQuery, DocumentPacketQueryVariables>(DocumentPacketDocument, options);
      }
export function useDocumentPacketLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentPacketQuery, DocumentPacketQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentPacketQuery, DocumentPacketQueryVariables>(DocumentPacketDocument, options);
        }
export type DocumentPacketQueryHookResult = ReturnType<typeof useDocumentPacketQuery>;
export type DocumentPacketLazyQueryHookResult = ReturnType<typeof useDocumentPacketLazyQuery>;
export type DocumentPacketQueryResult = Apollo.QueryResult<DocumentPacketQuery, DocumentPacketQueryVariables>;
export const DocumentPacketsDocument = gql`
    query DocumentPackets($first: Int!, $page: Int) {
  documentPackets(first: $first, page: $page) {
    data {
      id
      name
      documents {
        id
        name
        is_enabled
        can_be_viewed_by_everybody
        signature_type
        requirement
        fields
        created_at
        updated_at
      }
    }
    paginatorInfo {
      total
      currentPage
      hasMorePages
    }
  }
}
    `;

/**
 * __useDocumentPacketsQuery__
 *
 * To run a query within a React component, call `useDocumentPacketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentPacketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentPacketsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDocumentPacketsQuery(baseOptions: Apollo.QueryHookOptions<DocumentPacketsQuery, DocumentPacketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentPacketsQuery, DocumentPacketsQueryVariables>(DocumentPacketsDocument, options);
      }
export function useDocumentPacketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentPacketsQuery, DocumentPacketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentPacketsQuery, DocumentPacketsQueryVariables>(DocumentPacketsDocument, options);
        }
export type DocumentPacketsQueryHookResult = ReturnType<typeof useDocumentPacketsQuery>;
export type DocumentPacketsLazyQueryHookResult = ReturnType<typeof useDocumentPacketsLazyQuery>;
export type DocumentPacketsQueryResult = Apollo.QueryResult<DocumentPacketsQuery, DocumentPacketsQueryVariables>;
export const DocumentSubmissionDocument = gql`
    query DocumentSubmission($id: ID!) {
  documentSubmission(id: $id) {
    id
    fields
    results
    status
    signed_by_current_user
    document {
      id
      name
      requirement
      signature_type
      updated_at
    }
    signatures {
      id
      sign_name
      drawing_url
      ip
      created_at
      user {
        id
        name
      }
    }
    participant {
      id
      user {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useDocumentSubmissionQuery__
 *
 * To run a query within a React component, call `useDocumentSubmissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSubmissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSubmissionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentSubmissionQuery(baseOptions: Apollo.QueryHookOptions<DocumentSubmissionQuery, DocumentSubmissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSubmissionQuery, DocumentSubmissionQueryVariables>(DocumentSubmissionDocument, options);
      }
export function useDocumentSubmissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSubmissionQuery, DocumentSubmissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSubmissionQuery, DocumentSubmissionQueryVariables>(DocumentSubmissionDocument, options);
        }
export type DocumentSubmissionQueryHookResult = ReturnType<typeof useDocumentSubmissionQuery>;
export type DocumentSubmissionLazyQueryHookResult = ReturnType<typeof useDocumentSubmissionLazyQuery>;
export type DocumentSubmissionQueryResult = Apollo.QueryResult<DocumentSubmissionQuery, DocumentSubmissionQueryVariables>;
export const DocumentSubmissionsOrgDocument = gql`
    query DocumentSubmissionsOrg($document_id: ID, $user_id: ID, $appointment_id: ID, $from: DateTimeFromTz!, $to: DateTimeFromTz!, $order_by: DocumentSubmissionOrgSort, $order_sc: OrderSc, $status: DocumentSubmissionStatusEnum, $first: Int!, $page: Int) {
  documentSubmissionsOrg(
    document_id: $document_id
    user_id: $user_id
    appointment_id: $appointment_id
    from: $from
    to: $to
    order_by: $order_by
    order_sc: $order_sc
    status: $status
    first: $first
    page: $page
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      document {
        id
        name
      }
      participant {
        id
        user {
          id
          name
        }
      }
      appointment {
        id
      }
      submitted_at
    }
  }
}
    `;

/**
 * __useDocumentSubmissionsOrgQuery__
 *
 * To run a query within a React component, call `useDocumentSubmissionsOrgQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentSubmissionsOrgQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentSubmissionsOrgQuery({
 *   variables: {
 *      document_id: // value for 'document_id'
 *      user_id: // value for 'user_id'
 *      appointment_id: // value for 'appointment_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      order_by: // value for 'order_by'
 *      order_sc: // value for 'order_sc'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDocumentSubmissionsOrgQuery(baseOptions: Apollo.QueryHookOptions<DocumentSubmissionsOrgQuery, DocumentSubmissionsOrgQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentSubmissionsOrgQuery, DocumentSubmissionsOrgQueryVariables>(DocumentSubmissionsOrgDocument, options);
      }
export function useDocumentSubmissionsOrgLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentSubmissionsOrgQuery, DocumentSubmissionsOrgQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentSubmissionsOrgQuery, DocumentSubmissionsOrgQueryVariables>(DocumentSubmissionsOrgDocument, options);
        }
export type DocumentSubmissionsOrgQueryHookResult = ReturnType<typeof useDocumentSubmissionsOrgQuery>;
export type DocumentSubmissionsOrgLazyQueryHookResult = ReturnType<typeof useDocumentSubmissionsOrgLazyQuery>;
export type DocumentSubmissionsOrgQueryResult = Apollo.QueryResult<DocumentSubmissionsOrgQuery, DocumentSubmissionsOrgQueryVariables>;
export const DocumentDocument = gql`
    query Document($id: ID!) {
  document(id: $id) {
    id
    name
    requirement
    fields
    signature_type
  }
}
    `;

/**
 * __useDocumentQuery__
 *
 * To run a query within a React component, call `useDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDocumentQuery(baseOptions: Apollo.QueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
      }
export function useDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentQuery, DocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentQuery, DocumentQueryVariables>(DocumentDocument, options);
        }
export type DocumentQueryHookResult = ReturnType<typeof useDocumentQuery>;
export type DocumentLazyQueryHookResult = ReturnType<typeof useDocumentLazyQuery>;
export type DocumentQueryResult = Apollo.QueryResult<DocumentQuery, DocumentQueryVariables>;
export const DocumentsListDocument = gql`
    query DocumentsList($first: Int!, $page: Int!, $orderBy: [QueryDocumentsOrderByOrderByClause!]) {
  documents(first: $first, page: $page, order_by: $orderBy) {
    data {
      id
      name
      requirement
      is_enabled
    }
    paginatorInfo {
      total
      currentPage
      hasMorePages
    }
  }
}
    `;

/**
 * __useDocumentsListQuery__
 *
 * To run a query within a React component, call `useDocumentsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDocumentsListQuery(baseOptions: Apollo.QueryHookOptions<DocumentsListQuery, DocumentsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsListQuery, DocumentsListQueryVariables>(DocumentsListDocument, options);
      }
export function useDocumentsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsListQuery, DocumentsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsListQuery, DocumentsListQueryVariables>(DocumentsListDocument, options);
        }
export type DocumentsListQueryHookResult = ReturnType<typeof useDocumentsListQuery>;
export type DocumentsListLazyQueryHookResult = ReturnType<typeof useDocumentsListLazyQuery>;
export type DocumentsListQueryResult = Apollo.QueryResult<DocumentsListQuery, DocumentsListQueryVariables>;
export const BookingLocationMessageDocument = gql`
    query BookingLocationMessage($location: String!) {
  organization {
    id
    booking_message(location: $location)
  }
}
    `;

/**
 * __useBookingLocationMessageQuery__
 *
 * To run a query within a React component, call `useBookingLocationMessageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingLocationMessageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingLocationMessageQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useBookingLocationMessageQuery(baseOptions: Apollo.QueryHookOptions<BookingLocationMessageQuery, BookingLocationMessageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingLocationMessageQuery, BookingLocationMessageQueryVariables>(BookingLocationMessageDocument, options);
      }
export function useBookingLocationMessageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingLocationMessageQuery, BookingLocationMessageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingLocationMessageQuery, BookingLocationMessageQueryVariables>(BookingLocationMessageDocument, options);
        }
export type BookingLocationMessageQueryHookResult = ReturnType<typeof useBookingLocationMessageQuery>;
export type BookingLocationMessageLazyQueryHookResult = ReturnType<typeof useBookingLocationMessageLazyQuery>;
export type BookingLocationMessageQueryResult = Apollo.QueryResult<BookingLocationMessageQuery, BookingLocationMessageQueryVariables>;
export const NylasAuthDocument = gql`
    mutation NylasAuth($email: String!) {
  nylasAuth(email: $email) {
    redirect_url
  }
}
    `;
export type NylasAuthMutationFn = Apollo.MutationFunction<NylasAuthMutation, NylasAuthMutationVariables>;

/**
 * __useNylasAuthMutation__
 *
 * To run a mutation, you first call `useNylasAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNylasAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nylasAuthMutation, { data, loading, error }] = useNylasAuthMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useNylasAuthMutation(baseOptions?: Apollo.MutationHookOptions<NylasAuthMutation, NylasAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<NylasAuthMutation, NylasAuthMutationVariables>(NylasAuthDocument, options);
      }
export type NylasAuthMutationHookResult = ReturnType<typeof useNylasAuthMutation>;
export type NylasAuthMutationResult = Apollo.MutationResult<NylasAuthMutation>;
export type NylasAuthMutationOptions = Apollo.BaseMutationOptions<NylasAuthMutation, NylasAuthMutationVariables>;
export const UpdateUserOnDemandDocument = gql`
    mutation UpdateUserOnDemand($input: UpdateUserInput!) {
  updateUser(input: $input) {
    id
    enable_ondemand
  }
}
    `;
export type UpdateUserOnDemandMutationFn = Apollo.MutationFunction<UpdateUserOnDemandMutation, UpdateUserOnDemandMutationVariables>;

/**
 * __useUpdateUserOnDemandMutation__
 *
 * To run a mutation, you first call `useUpdateUserOnDemandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserOnDemandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserOnDemandMutation, { data, loading, error }] = useUpdateUserOnDemandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserOnDemandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserOnDemandMutation, UpdateUserOnDemandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserOnDemandMutation, UpdateUserOnDemandMutationVariables>(UpdateUserOnDemandDocument, options);
      }
export type UpdateUserOnDemandMutationHookResult = ReturnType<typeof useUpdateUserOnDemandMutation>;
export type UpdateUserOnDemandMutationResult = Apollo.MutationResult<UpdateUserOnDemandMutation>;
export type UpdateUserOnDemandMutationOptions = Apollo.BaseMutationOptions<UpdateUserOnDemandMutation, UpdateUserOnDemandMutationVariables>;
export const UserListExportDocument = gql`
    query UserListExport($first: Int!, $page: Int!, $hasRoles: QueryUsersHasRolesWhereHasConditions, $where: QueryUsersWhereWhereConditions, $orderBy: [QueryUsersOrderByRelationOrderByClause!]) {
  users(
    first: $first
    page: $page
    hasRoles: $hasRoles
    where: $where
    orderBy: $orderBy
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      name
      email
      phone
      roles {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useUserListExportQuery__
 *
 * To run a query within a React component, call `useUserListExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserListExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserListExportQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      hasRoles: // value for 'hasRoles'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useUserListExportQuery(baseOptions: Apollo.QueryHookOptions<UserListExportQuery, UserListExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserListExportQuery, UserListExportQueryVariables>(UserListExportDocument, options);
      }
export function useUserListExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserListExportQuery, UserListExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserListExportQuery, UserListExportQueryVariables>(UserListExportDocument, options);
        }
export type UserListExportQueryHookResult = ReturnType<typeof useUserListExportQuery>;
export type UserListExportLazyQueryHookResult = ReturnType<typeof useUserListExportLazyQuery>;
export type UserListExportQueryResult = Apollo.QueryResult<UserListExportQuery, UserListExportQueryVariables>;
export const UserOnDemandUserDocument = gql`
    query UserOnDemandUser($id: ID!) {
  user(id: $id) {
    id
    enable_ondemand
  }
}
    `;

/**
 * __useUserOnDemandUserQuery__
 *
 * To run a query within a React component, call `useUserOnDemandUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOnDemandUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOnDemandUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserOnDemandUserQuery(baseOptions: Apollo.QueryHookOptions<UserOnDemandUserQuery, UserOnDemandUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserOnDemandUserQuery, UserOnDemandUserQueryVariables>(UserOnDemandUserDocument, options);
      }
export function useUserOnDemandUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserOnDemandUserQuery, UserOnDemandUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserOnDemandUserQuery, UserOnDemandUserQueryVariables>(UserOnDemandUserDocument, options);
        }
export type UserOnDemandUserQueryHookResult = ReturnType<typeof useUserOnDemandUserQuery>;
export type UserOnDemandUserLazyQueryHookResult = ReturnType<typeof useUserOnDemandUserLazyQuery>;
export type UserOnDemandUserQueryResult = Apollo.QueryResult<UserOnDemandUserQuery, UserOnDemandUserQueryVariables>;
export const UserOnDemandDocument = gql`
    query UserOnDemand {
  user: me {
    id
    enable_ondemand
  }
}
    `;

/**
 * __useUserOnDemandQuery__
 *
 * To run a query within a React component, call `useUserOnDemandQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserOnDemandQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserOnDemandQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserOnDemandQuery(baseOptions?: Apollo.QueryHookOptions<UserOnDemandQuery, UserOnDemandQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserOnDemandQuery, UserOnDemandQueryVariables>(UserOnDemandDocument, options);
      }
export function useUserOnDemandLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserOnDemandQuery, UserOnDemandQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserOnDemandQuery, UserOnDemandQueryVariables>(UserOnDemandDocument, options);
        }
export type UserOnDemandQueryHookResult = ReturnType<typeof useUserOnDemandQuery>;
export type UserOnDemandLazyQueryHookResult = ReturnType<typeof useUserOnDemandLazyQuery>;
export type UserOnDemandQueryResult = Apollo.QueryResult<UserOnDemandQuery, UserOnDemandQueryVariables>;
export const SessionUsageDetailDocument = gql`
    query SessionUsageDetail($id: ID!) {
  appointment(id: $id) {
    id
    start_time
    started_at
    ended_at
    duration
    history {
      id
      log_name
      description
      created_at
      causer {
        ... on User {
          id
          name
        }
        ... on Participant {
          id
          user {
            id
            name
          }
        }
      }
    }
    host {
      id
      name
    }
    participants {
      id
      user {
        id
        name
        email
      }
      history {
        id
        log_name
        created_at
      }
      ip
      location
    }
    service {
      name
      price
    }
  }
}
    `;

/**
 * __useSessionUsageDetailQuery__
 *
 * To run a query within a React component, call `useSessionUsageDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionUsageDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionUsageDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSessionUsageDetailQuery(baseOptions: Apollo.QueryHookOptions<SessionUsageDetailQuery, SessionUsageDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionUsageDetailQuery, SessionUsageDetailQueryVariables>(SessionUsageDetailDocument, options);
      }
export function useSessionUsageDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionUsageDetailQuery, SessionUsageDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionUsageDetailQuery, SessionUsageDetailQueryVariables>(SessionUsageDetailDocument, options);
        }
export type SessionUsageDetailQueryHookResult = ReturnType<typeof useSessionUsageDetailQuery>;
export type SessionUsageDetailLazyQueryHookResult = ReturnType<typeof useSessionUsageDetailLazyQuery>;
export type SessionUsageDetailQueryResult = Apollo.QueryResult<SessionUsageDetailQuery, SessionUsageDetailQueryVariables>;
export const DeleteScreenshotDocument = gql`
    mutation DeleteScreenshot($id: ID!) {
  deleteScreenshot(id: $id)
}
    `;
export type DeleteScreenshotMutationFn = Apollo.MutationFunction<DeleteScreenshotMutation, DeleteScreenshotMutationVariables>;

/**
 * __useDeleteScreenshotMutation__
 *
 * To run a mutation, you first call `useDeleteScreenshotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteScreenshotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteScreenshotMutation, { data, loading, error }] = useDeleteScreenshotMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteScreenshotMutation(baseOptions?: Apollo.MutationHookOptions<DeleteScreenshotMutation, DeleteScreenshotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteScreenshotMutation, DeleteScreenshotMutationVariables>(DeleteScreenshotDocument, options);
      }
export type DeleteScreenshotMutationHookResult = ReturnType<typeof useDeleteScreenshotMutation>;
export type DeleteScreenshotMutationResult = Apollo.MutationResult<DeleteScreenshotMutation>;
export type DeleteScreenshotMutationOptions = Apollo.BaseMutationOptions<DeleteScreenshotMutation, DeleteScreenshotMutationVariables>;
export const CreateBiometricScanDocument = gql`
    mutation createBiometricScan($input: CreateBiometricScanInput!) {
  createBiometricScan(input: $input) {
    id
    scanned_at
    user {
      id
      name
    }
    measurements {
      id
      measurement_id
      display_name
      results_group
      results_group_sort
      number_format
      raw_value
      formatted_value
    }
  }
}
    `;
export type CreateBiometricScanMutationFn = Apollo.MutationFunction<CreateBiometricScanMutation, CreateBiometricScanMutationVariables>;

/**
 * __useCreateBiometricScanMutation__
 *
 * To run a mutation, you first call `useCreateBiometricScanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBiometricScanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBiometricScanMutation, { data, loading, error }] = useCreateBiometricScanMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBiometricScanMutation(baseOptions?: Apollo.MutationHookOptions<CreateBiometricScanMutation, CreateBiometricScanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBiometricScanMutation, CreateBiometricScanMutationVariables>(CreateBiometricScanDocument, options);
      }
export type CreateBiometricScanMutationHookResult = ReturnType<typeof useCreateBiometricScanMutation>;
export type CreateBiometricScanMutationResult = Apollo.MutationResult<CreateBiometricScanMutation>;
export type CreateBiometricScanMutationOptions = Apollo.BaseMutationOptions<CreateBiometricScanMutation, CreateBiometricScanMutationVariables>;
export const UpdateScansAvailableDocument = gql`
    mutation updateScansAvailable($input: UpdateScansAvailableInput!) {
  updateScansAvailable(input: $input) {
    biometric_scans_available
  }
}
    `;
export type UpdateScansAvailableMutationFn = Apollo.MutationFunction<UpdateScansAvailableMutation, UpdateScansAvailableMutationVariables>;

/**
 * __useUpdateScansAvailableMutation__
 *
 * To run a mutation, you first call `useUpdateScansAvailableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScansAvailableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScansAvailableMutation, { data, loading, error }] = useUpdateScansAvailableMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateScansAvailableMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScansAvailableMutation, UpdateScansAvailableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScansAvailableMutation, UpdateScansAvailableMutationVariables>(UpdateScansAvailableDocument, options);
      }
export type UpdateScansAvailableMutationHookResult = ReturnType<typeof useUpdateScansAvailableMutation>;
export type UpdateScansAvailableMutationResult = Apollo.MutationResult<UpdateScansAvailableMutation>;
export type UpdateScansAvailableMutationOptions = Apollo.BaseMutationOptions<UpdateScansAvailableMutation, UpdateScansAvailableMutationVariables>;
export const BiometricMeasurementDocument = gql`
    query biometricMeasurement($scanId: ID) {
  biometricMeasurement(scanId: $scanId) {
    id
    measurement_id
    display_name
    results_group
    results_group_sort
    number_format
    red_ranges
    yellow_ranges
    green_ranges
    raw_value
    formatted_value
    created_at
    scan {
      id
      user {
        id
        name
      }
      scanned_at
    }
  }
}
    `;

/**
 * __useBiometricMeasurementQuery__
 *
 * To run a query within a React component, call `useBiometricMeasurementQuery` and pass it any options that fit your needs.
 * When your component renders, `useBiometricMeasurementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBiometricMeasurementQuery({
 *   variables: {
 *      scanId: // value for 'scanId'
 *   },
 * });
 */
export function useBiometricMeasurementQuery(baseOptions?: Apollo.QueryHookOptions<BiometricMeasurementQuery, BiometricMeasurementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BiometricMeasurementQuery, BiometricMeasurementQueryVariables>(BiometricMeasurementDocument, options);
      }
export function useBiometricMeasurementLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BiometricMeasurementQuery, BiometricMeasurementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BiometricMeasurementQuery, BiometricMeasurementQueryVariables>(BiometricMeasurementDocument, options);
        }
export type BiometricMeasurementQueryHookResult = ReturnType<typeof useBiometricMeasurementQuery>;
export type BiometricMeasurementLazyQueryHookResult = ReturnType<typeof useBiometricMeasurementLazyQuery>;
export type BiometricMeasurementQueryResult = Apollo.QueryResult<BiometricMeasurementQuery, BiometricMeasurementQueryVariables>;
export const BiometricMeasurementsDocument = gql`
    query biometricMeasurements($userId: ID) {
  biometricMeasurements(userId: $userId) {
    id
    measurement_id
    display_name
    results_group
    results_group_sort
    number_format
    red_ranges
    yellow_ranges
    green_ranges
    raw_value
    formatted_value
    created_at
    scan {
      id
      user {
        id
        name
      }
      scanned_at
    }
  }
}
    `;

/**
 * __useBiometricMeasurementsQuery__
 *
 * To run a query within a React component, call `useBiometricMeasurementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBiometricMeasurementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBiometricMeasurementsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBiometricMeasurementsQuery(baseOptions?: Apollo.QueryHookOptions<BiometricMeasurementsQuery, BiometricMeasurementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BiometricMeasurementsQuery, BiometricMeasurementsQueryVariables>(BiometricMeasurementsDocument, options);
      }
export function useBiometricMeasurementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BiometricMeasurementsQuery, BiometricMeasurementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BiometricMeasurementsQuery, BiometricMeasurementsQueryVariables>(BiometricMeasurementsDocument, options);
        }
export type BiometricMeasurementsQueryHookResult = ReturnType<typeof useBiometricMeasurementsQuery>;
export type BiometricMeasurementsLazyQueryHookResult = ReturnType<typeof useBiometricMeasurementsLazyQuery>;
export type BiometricMeasurementsQueryResult = Apollo.QueryResult<BiometricMeasurementsQuery, BiometricMeasurementsQueryVariables>;
export const BiometricScansDocument = gql`
    query biometricScans($userId: ID) {
  biometricScans(userId: $userId) {
    id
    user {
      id
      name
    }
    guest_uuid
    scanned_at
    appointment_id
    device_model
    environment_data
    created_at
  }
}
    `;

/**
 * __useBiometricScansQuery__
 *
 * To run a query within a React component, call `useBiometricScansQuery` and pass it any options that fit your needs.
 * When your component renders, `useBiometricScansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBiometricScansQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useBiometricScansQuery(baseOptions?: Apollo.QueryHookOptions<BiometricScansQuery, BiometricScansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BiometricScansQuery, BiometricScansQueryVariables>(BiometricScansDocument, options);
      }
export function useBiometricScansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BiometricScansQuery, BiometricScansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BiometricScansQuery, BiometricScansQueryVariables>(BiometricScansDocument, options);
        }
export type BiometricScansQueryHookResult = ReturnType<typeof useBiometricScansQuery>;
export type BiometricScansLazyQueryHookResult = ReturnType<typeof useBiometricScansLazyQuery>;
export type BiometricScansQueryResult = Apollo.QueryResult<BiometricScansQuery, BiometricScansQueryVariables>;
export const CreateNoteTemplateDocument = gql`
    mutation CreateNoteTemplate($input: NoteTemplateInput!) {
  createNoteTemplate(input: $input) {
    id
    name
    content
  }
}
    `;
export type CreateNoteTemplateMutationFn = Apollo.MutationFunction<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>;

/**
 * __useCreateNoteTemplateMutation__
 *
 * To run a mutation, you first call `useCreateNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteTemplateMutation, { data, loading, error }] = useCreateNoteTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>(CreateNoteTemplateDocument, options);
      }
export type CreateNoteTemplateMutationHookResult = ReturnType<typeof useCreateNoteTemplateMutation>;
export type CreateNoteTemplateMutationResult = Apollo.MutationResult<CreateNoteTemplateMutation>;
export type CreateNoteTemplateMutationOptions = Apollo.BaseMutationOptions<CreateNoteTemplateMutation, CreateNoteTemplateMutationVariables>;
export const DeleteNoteTemplateDocument = gql`
    mutation DeleteNoteTemplate($id: ID!) {
  deleteNoteTemplate(id: $id)
}
    `;
export type DeleteNoteTemplateMutationFn = Apollo.MutationFunction<DeleteNoteTemplateMutation, DeleteNoteTemplateMutationVariables>;

/**
 * __useDeleteNoteTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteTemplateMutation, { data, loading, error }] = useDeleteNoteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteTemplateMutation, DeleteNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteTemplateMutation, DeleteNoteTemplateMutationVariables>(DeleteNoteTemplateDocument, options);
      }
export type DeleteNoteTemplateMutationHookResult = ReturnType<typeof useDeleteNoteTemplateMutation>;
export type DeleteNoteTemplateMutationResult = Apollo.MutationResult<DeleteNoteTemplateMutation>;
export type DeleteNoteTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteNoteTemplateMutation, DeleteNoteTemplateMutationVariables>;
export const UpdateNoteTemplateDocument = gql`
    mutation UpdateNoteTemplate($id: ID!, $input: NoteTemplateInput!) {
  updateNoteTemplate(id: $id, input: $input) {
    id
    name
    content
  }
}
    `;
export type UpdateNoteTemplateMutationFn = Apollo.MutationFunction<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>;

/**
 * __useUpdateNoteTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateNoteTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteTemplateMutation, { data, loading, error }] = useUpdateNoteTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>(UpdateNoteTemplateDocument, options);
      }
export type UpdateNoteTemplateMutationHookResult = ReturnType<typeof useUpdateNoteTemplateMutation>;
export type UpdateNoteTemplateMutationResult = Apollo.MutationResult<UpdateNoteTemplateMutation>;
export type UpdateNoteTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateNoteTemplateMutation, UpdateNoteTemplateMutationVariables>;
export const NoteTemplateDocument = gql`
    query NoteTemplate($id: ID!) {
  noteTemplate(id: $id) {
    id
    name
    content
  }
}
    `;

/**
 * __useNoteTemplateQuery__
 *
 * To run a query within a React component, call `useNoteTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useNoteTemplateQuery(baseOptions: Apollo.QueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteTemplateQuery, NoteTemplateQueryVariables>(NoteTemplateDocument, options);
      }
export function useNoteTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteTemplateQuery, NoteTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteTemplateQuery, NoteTemplateQueryVariables>(NoteTemplateDocument, options);
        }
export type NoteTemplateQueryHookResult = ReturnType<typeof useNoteTemplateQuery>;
export type NoteTemplateLazyQueryHookResult = ReturnType<typeof useNoteTemplateLazyQuery>;
export type NoteTemplateQueryResult = Apollo.QueryResult<NoteTemplateQuery, NoteTemplateQueryVariables>;
export const NoteTemplatesDocument = gql`
    query NoteTemplates {
  noteTemplates {
    id
    name
    content
  }
}
    `;

/**
 * __useNoteTemplatesQuery__
 *
 * To run a query within a React component, call `useNoteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoteTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useNoteTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoteTemplatesQuery, NoteTemplatesQueryVariables>(NoteTemplatesDocument, options);
      }
export function useNoteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoteTemplatesQuery, NoteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoteTemplatesQuery, NoteTemplatesQueryVariables>(NoteTemplatesDocument, options);
        }
export type NoteTemplatesQueryHookResult = ReturnType<typeof useNoteTemplatesQuery>;
export type NoteTemplatesLazyQueryHookResult = ReturnType<typeof useNoteTemplatesLazyQuery>;
export type NoteTemplatesQueryResult = Apollo.QueryResult<NoteTemplatesQuery, NoteTemplatesQueryVariables>;
export const UserSessionNotesDocument = gql`
    query UserSessionNotes($id: ID!) {
  user(id: $id) {
    id
    name
    notes {
      id
      title
      content
      owner_id
      created_at
      users {
        id
        name
      }
      appointment {
        id
        host {
          id
          name
          avatar_url
          email
        }
      }
    }
  }
}
    `;

/**
 * __useUserSessionNotesQuery__
 *
 * To run a query within a React component, call `useUserSessionNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSessionNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSessionNotesQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserSessionNotesQuery(baseOptions: Apollo.QueryHookOptions<UserSessionNotesQuery, UserSessionNotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSessionNotesQuery, UserSessionNotesQueryVariables>(UserSessionNotesDocument, options);
      }
export function useUserSessionNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSessionNotesQuery, UserSessionNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSessionNotesQuery, UserSessionNotesQueryVariables>(UserSessionNotesDocument, options);
        }
export type UserSessionNotesQueryHookResult = ReturnType<typeof useUserSessionNotesQuery>;
export type UserSessionNotesLazyQueryHookResult = ReturnType<typeof useUserSessionNotesLazyQuery>;
export type UserSessionNotesQueryResult = Apollo.QueryResult<UserSessionNotesQuery, UserSessionNotesQueryVariables>;
export const SaveSlotsDocument = gql`
    mutation SaveSlots($input: CreateSlotsInput!) {
  createSlots(input: $input) {
    id
    from
    to
    weekday
  }
}
    `;
export type SaveSlotsMutationFn = Apollo.MutationFunction<SaveSlotsMutation, SaveSlotsMutationVariables>;

/**
 * __useSaveSlotsMutation__
 *
 * To run a mutation, you first call `useSaveSlotsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveSlotsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveSlotsMutation, { data, loading, error }] = useSaveSlotsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveSlotsMutation(baseOptions?: Apollo.MutationHookOptions<SaveSlotsMutation, SaveSlotsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveSlotsMutation, SaveSlotsMutationVariables>(SaveSlotsDocument, options);
      }
export type SaveSlotsMutationHookResult = ReturnType<typeof useSaveSlotsMutation>;
export type SaveSlotsMutationResult = Apollo.MutationResult<SaveSlotsMutation>;
export type SaveSlotsMutationOptions = Apollo.BaseMutationOptions<SaveSlotsMutation, SaveSlotsMutationVariables>;
export const VisitSummaryReportPdfDocument = gql`
    mutation visitSummaryReportPDF($appointment_id: ID!) {
  visitSummaryReport(appointment_id: $appointment_id)
}
    `;
export type VisitSummaryReportPdfMutationFn = Apollo.MutationFunction<VisitSummaryReportPdfMutation, VisitSummaryReportPdfMutationVariables>;

/**
 * __useVisitSummaryReportPdfMutation__
 *
 * To run a mutation, you first call `useVisitSummaryReportPdfMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVisitSummaryReportPdfMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [visitSummaryReportPdfMutation, { data, loading, error }] = useVisitSummaryReportPdfMutation({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *   },
 * });
 */
export function useVisitSummaryReportPdfMutation(baseOptions?: Apollo.MutationHookOptions<VisitSummaryReportPdfMutation, VisitSummaryReportPdfMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VisitSummaryReportPdfMutation, VisitSummaryReportPdfMutationVariables>(VisitSummaryReportPdfDocument, options);
      }
export type VisitSummaryReportPdfMutationHookResult = ReturnType<typeof useVisitSummaryReportPdfMutation>;
export type VisitSummaryReportPdfMutationResult = Apollo.MutationResult<VisitSummaryReportPdfMutation>;
export type VisitSummaryReportPdfMutationOptions = Apollo.BaseMutationOptions<VisitSummaryReportPdfMutation, VisitSummaryReportPdfMutationVariables>;
export const AppointmentVsrDocument = gql`
    query AppointmentVSR($id: ID!) {
  appointment(id: $id) {
    id
    host {
      id
      name
    }
    participants {
      id
      user {
        id
        name
      }
    }
    service {
      id
      name
    }
    vitals_media {
      id
      download_url
      created_at
      user {
        id
        name
      }
      device
      file_type
    }
    filtered_vitals {
      id
      name
      fdata
    }
    start_time
    planned_end_time
    report_content_json
    appointment_audios {
      id
      status
      audio_url
      transcript {
        descriptions {
          name
          summaries {
            inpSegments
            text
          }
        }
        texts {
          highlightedWords
          speaker
          text
          startTime
        }
        transcript_status
      }
    }
  }
}
    `;

/**
 * __useAppointmentVsrQuery__
 *
 * To run a query within a React component, call `useAppointmentVsrQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentVsrQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentVsrQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentVsrQuery(baseOptions: Apollo.QueryHookOptions<AppointmentVsrQuery, AppointmentVsrQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentVsrQuery, AppointmentVsrQueryVariables>(AppointmentVsrDocument, options);
      }
export function useAppointmentVsrLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentVsrQuery, AppointmentVsrQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentVsrQuery, AppointmentVsrQueryVariables>(AppointmentVsrDocument, options);
        }
export type AppointmentVsrQueryHookResult = ReturnType<typeof useAppointmentVsrQuery>;
export type AppointmentVsrLazyQueryHookResult = ReturnType<typeof useAppointmentVsrLazyQuery>;
export type AppointmentVsrQueryResult = Apollo.QueryResult<AppointmentVsrQuery, AppointmentVsrQueryVariables>;
export const AppointmentVsrViewDocument = gql`
    query AppointmentVSRView($id: ID!) {
  appointment(id: $id) {
    id
    host {
      id
      name
    }
    participants {
      id
      user {
        id
        name
      }
    }
    service {
      id
      name
    }
    start_time
    planned_end_time
    report_content_json
  }
}
    `;

/**
 * __useAppointmentVsrViewQuery__
 *
 * To run a query within a React component, call `useAppointmentVsrViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentVsrViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentVsrViewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentVsrViewQuery(baseOptions: Apollo.QueryHookOptions<AppointmentVsrViewQuery, AppointmentVsrViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentVsrViewQuery, AppointmentVsrViewQueryVariables>(AppointmentVsrViewDocument, options);
      }
export function useAppointmentVsrViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentVsrViewQuery, AppointmentVsrViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentVsrViewQuery, AppointmentVsrViewQueryVariables>(AppointmentVsrViewDocument, options);
        }
export type AppointmentVsrViewQueryHookResult = ReturnType<typeof useAppointmentVsrViewQuery>;
export type AppointmentVsrViewLazyQueryHookResult = ReturnType<typeof useAppointmentVsrViewLazyQuery>;
export type AppointmentVsrViewQueryResult = Apollo.QueryResult<AppointmentVsrViewQuery, AppointmentVsrViewQueryVariables>;
export const DocumentUsersDocument = gql`
    query DocumentUsers($first: Int!, $page: Int) {
  users(first: $first, page: $page) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useDocumentUsersQuery__
 *
 * To run a query within a React component, call `useDocumentUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentUsersQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useDocumentUsersQuery(baseOptions: Apollo.QueryHookOptions<DocumentUsersQuery, DocumentUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentUsersQuery, DocumentUsersQueryVariables>(DocumentUsersDocument, options);
      }
export function useDocumentUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentUsersQuery, DocumentUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentUsersQuery, DocumentUsersQueryVariables>(DocumentUsersDocument, options);
        }
export type DocumentUsersQueryHookResult = ReturnType<typeof useDocumentUsersQuery>;
export type DocumentUsersLazyQueryHookResult = ReturnType<typeof useDocumentUsersLazyQuery>;
export type DocumentUsersQueryResult = Apollo.QueryResult<DocumentUsersQuery, DocumentUsersQueryVariables>;
export const OrganizationDocumentSubmissionsDocument = gql`
    query OrganizationDocumentSubmissions($document_id: ID, $user_id: ID, $appointment_id: ID, $from: DateTimeFromTz!, $to: DateTimeFromTz!, $order_by: DocumentSubmissionOrgSort, $order_sc: OrderSc, $status: DocumentSubmissionStatusEnum, $first: Int!, $page: Int) {
  documentSubmissionsOrg(
    document_id: $document_id
    user_id: $user_id
    appointment_id: $appointment_id
    from: $from
    to: $to
    order_by: $order_by
    order_sc: $order_sc
    status: $status
    first: $first
    page: $page
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      document {
        id
        name
      }
      participant {
        id
        user {
          id
          name
        }
      }
      appointment {
        id
      }
      submitted_at
    }
  }
}
    `;

/**
 * __useOrganizationDocumentSubmissionsQuery__
 *
 * To run a query within a React component, call `useOrganizationDocumentSubmissionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDocumentSubmissionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDocumentSubmissionsQuery({
 *   variables: {
 *      document_id: // value for 'document_id'
 *      user_id: // value for 'user_id'
 *      appointment_id: // value for 'appointment_id'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      order_by: // value for 'order_by'
 *      order_sc: // value for 'order_sc'
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrganizationDocumentSubmissionsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationDocumentSubmissionsQuery, OrganizationDocumentSubmissionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationDocumentSubmissionsQuery, OrganizationDocumentSubmissionsQueryVariables>(OrganizationDocumentSubmissionsDocument, options);
      }
export function useOrganizationDocumentSubmissionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationDocumentSubmissionsQuery, OrganizationDocumentSubmissionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationDocumentSubmissionsQuery, OrganizationDocumentSubmissionsQueryVariables>(OrganizationDocumentSubmissionsDocument, options);
        }
export type OrganizationDocumentSubmissionsQueryHookResult = ReturnType<typeof useOrganizationDocumentSubmissionsQuery>;
export type OrganizationDocumentSubmissionsLazyQueryHookResult = ReturnType<typeof useOrganizationDocumentSubmissionsLazyQuery>;
export type OrganizationDocumentSubmissionsQueryResult = Apollo.QueryResult<OrganizationDocumentSubmissionsQuery, OrganizationDocumentSubmissionsQueryVariables>;
export const OrganizationDocumentsDocument = gql`
    query OrganizationDocuments($first: Int!, $page: Int) {
  documents(first: $first, page: $page) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useOrganizationDocumentsQuery__
 *
 * To run a query within a React component, call `useOrganizationDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useOrganizationDocumentsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationDocumentsQuery, OrganizationDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationDocumentsQuery, OrganizationDocumentsQueryVariables>(OrganizationDocumentsDocument, options);
      }
export function useOrganizationDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationDocumentsQuery, OrganizationDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationDocumentsQuery, OrganizationDocumentsQueryVariables>(OrganizationDocumentsDocument, options);
        }
export type OrganizationDocumentsQueryHookResult = ReturnType<typeof useOrganizationDocumentsQuery>;
export type OrganizationDocumentsLazyQueryHookResult = ReturnType<typeof useOrganizationDocumentsLazyQuery>;
export type OrganizationDocumentsQueryResult = Apollo.QueryResult<OrganizationDocumentsQuery, OrganizationDocumentsQueryVariables>;
export const CreateSessionNoteDocument = gql`
    mutation CreateSessionNote($input: NoteInput!) {
  createNote(input: $input) {
    id
    content
    users {
      id
      name
    }
  }
}
    `;
export type CreateSessionNoteMutationFn = Apollo.MutationFunction<CreateSessionNoteMutation, CreateSessionNoteMutationVariables>;

/**
 * __useCreateSessionNoteMutation__
 *
 * To run a mutation, you first call `useCreateSessionNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSessionNoteMutation, { data, loading, error }] = useCreateSessionNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSessionNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateSessionNoteMutation, CreateSessionNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSessionNoteMutation, CreateSessionNoteMutationVariables>(CreateSessionNoteDocument, options);
      }
export type CreateSessionNoteMutationHookResult = ReturnType<typeof useCreateSessionNoteMutation>;
export type CreateSessionNoteMutationResult = Apollo.MutationResult<CreateSessionNoteMutation>;
export type CreateSessionNoteMutationOptions = Apollo.BaseMutationOptions<CreateSessionNoteMutation, CreateSessionNoteMutationVariables>;
export const CreateSessionNoteUserListDocument = gql`
    query CreateSessionNoteUserList($first: Int!, $page: Int!) {
  users(first: $first, page: $page) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateSessionNoteUserListQuery__
 *
 * To run a query within a React component, call `useCreateSessionNoteUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionNoteUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateSessionNoteUserListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCreateSessionNoteUserListQuery(baseOptions: Apollo.QueryHookOptions<CreateSessionNoteUserListQuery, CreateSessionNoteUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateSessionNoteUserListQuery, CreateSessionNoteUserListQueryVariables>(CreateSessionNoteUserListDocument, options);
      }
export function useCreateSessionNoteUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateSessionNoteUserListQuery, CreateSessionNoteUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateSessionNoteUserListQuery, CreateSessionNoteUserListQueryVariables>(CreateSessionNoteUserListDocument, options);
        }
export type CreateSessionNoteUserListQueryHookResult = ReturnType<typeof useCreateSessionNoteUserListQuery>;
export type CreateSessionNoteUserListLazyQueryHookResult = ReturnType<typeof useCreateSessionNoteUserListLazyQuery>;
export type CreateSessionNoteUserListQueryResult = Apollo.QueryResult<CreateSessionNoteUserListQuery, CreateSessionNoteUserListQueryVariables>;
export const CreateSessionNoteTemplatesDocument = gql`
    query CreateSessionNoteTemplates {
  noteTemplates {
    id
    name
    content
  }
}
    `;

/**
 * __useCreateSessionNoteTemplatesQuery__
 *
 * To run a query within a React component, call `useCreateSessionNoteTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateSessionNoteTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateSessionNoteTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateSessionNoteTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<CreateSessionNoteTemplatesQuery, CreateSessionNoteTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateSessionNoteTemplatesQuery, CreateSessionNoteTemplatesQueryVariables>(CreateSessionNoteTemplatesDocument, options);
      }
export function useCreateSessionNoteTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateSessionNoteTemplatesQuery, CreateSessionNoteTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateSessionNoteTemplatesQuery, CreateSessionNoteTemplatesQueryVariables>(CreateSessionNoteTemplatesDocument, options);
        }
export type CreateSessionNoteTemplatesQueryHookResult = ReturnType<typeof useCreateSessionNoteTemplatesQuery>;
export type CreateSessionNoteTemplatesLazyQueryHookResult = ReturnType<typeof useCreateSessionNoteTemplatesLazyQuery>;
export type CreateSessionNoteTemplatesQueryResult = Apollo.QueryResult<CreateSessionNoteTemplatesQuery, CreateSessionNoteTemplatesQueryVariables>;
export const NotesExportDocument = gql`
    query notesExport($input: NotesExportInput!, $browser_identifier: String!) {
  notesExport(input: $input, browser_identifier: $browser_identifier)
}
    `;

/**
 * __useNotesExportQuery__
 *
 * To run a query within a React component, call `useNotesExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotesExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotesExportQuery({
 *   variables: {
 *      input: // value for 'input'
 *      browser_identifier: // value for 'browser_identifier'
 *   },
 * });
 */
export function useNotesExportQuery(baseOptions: Apollo.QueryHookOptions<NotesExportQuery, NotesExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NotesExportQuery, NotesExportQueryVariables>(NotesExportDocument, options);
      }
export function useNotesExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NotesExportQuery, NotesExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NotesExportQuery, NotesExportQueryVariables>(NotesExportDocument, options);
        }
export type NotesExportQueryHookResult = ReturnType<typeof useNotesExportQuery>;
export type NotesExportLazyQueryHookResult = ReturnType<typeof useNotesExportLazyQuery>;
export type NotesExportQueryResult = Apollo.QueryResult<NotesExportQuery, NotesExportQueryVariables>;
export const SessionNotesUserListDocument = gql`
    query SessionNotesUserList($first: Int!, $page: Int!, $hasRoles: QueryUsersHasRolesWhereHasConditions, $where: QueryUsersWhereWhereConditions, $orderBy: [QueryUsersOrderByRelationOrderByClause!]) {
  users(
    first: $first
    page: $page
    hasRoles: $hasRoles
    where: $where
    orderBy: $orderBy
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      name
      note_last_created
    }
  }
}
    `;

/**
 * __useSessionNotesUserListQuery__
 *
 * To run a query within a React component, call `useSessionNotesUserListQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionNotesUserListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionNotesUserListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      hasRoles: // value for 'hasRoles'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useSessionNotesUserListQuery(baseOptions: Apollo.QueryHookOptions<SessionNotesUserListQuery, SessionNotesUserListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionNotesUserListQuery, SessionNotesUserListQueryVariables>(SessionNotesUserListDocument, options);
      }
export function useSessionNotesUserListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionNotesUserListQuery, SessionNotesUserListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionNotesUserListQuery, SessionNotesUserListQueryVariables>(SessionNotesUserListDocument, options);
        }
export type SessionNotesUserListQueryHookResult = ReturnType<typeof useSessionNotesUserListQuery>;
export type SessionNotesUserListLazyQueryHookResult = ReturnType<typeof useSessionNotesUserListLazyQuery>;
export type SessionNotesUserListQueryResult = Apollo.QueryResult<SessionNotesUserListQuery, SessionNotesUserListQueryVariables>;
export const CancelAppointmentDocument = gql`
    mutation CancelAppointment($id: ID!) {
  cancelAppointment(id: $id) {
    id
  }
}
    `;
export type CancelAppointmentMutationFn = Apollo.MutationFunction<CancelAppointmentMutation, CancelAppointmentMutationVariables>;

/**
 * __useCancelAppointmentMutation__
 *
 * To run a mutation, you first call `useCancelAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelAppointmentMutation, { data, loading, error }] = useCancelAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelAppointmentMutation, CancelAppointmentMutationVariables>(CancelAppointmentDocument, options);
      }
export type CancelAppointmentMutationHookResult = ReturnType<typeof useCancelAppointmentMutation>;
export type CancelAppointmentMutationResult = Apollo.MutationResult<CancelAppointmentMutation>;
export type CancelAppointmentMutationOptions = Apollo.BaseMutationOptions<CancelAppointmentMutation, CancelAppointmentMutationVariables>;
export const CreateAppointmentDocument = gql`
    mutation CreateAppointment($input: CreateAppointmentInput!) {
  createAppointment(input: $input) {
    id
    start_time
    host {
      id
      device_user
    }
    service {
      id
      duration
    }
    participants {
      id
      user {
        id
        email
        sms
        default_notification_channel
      }
    }
  }
}
    `;
export type CreateAppointmentMutationFn = Apollo.MutationFunction<CreateAppointmentMutation, CreateAppointmentMutationVariables>;

/**
 * __useCreateAppointmentMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentMutation, { data, loading, error }] = useCreateAppointmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentMutation, CreateAppointmentMutationVariables>(CreateAppointmentDocument, options);
      }
export type CreateAppointmentMutationHookResult = ReturnType<typeof useCreateAppointmentMutation>;
export type CreateAppointmentMutationResult = Apollo.MutationResult<CreateAppointmentMutation>;
export type CreateAppointmentMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentMutation, CreateAppointmentMutationVariables>;
export const CreateNoteDocument = gql`
    mutation CreateNote($input: NoteInput!) {
  createNote(input: $input) {
    id
    title
    content
    users {
      id
    }
    created_at
  }
}
    `;
export type CreateNoteMutationFn = Apollo.MutationFunction<CreateNoteMutation, CreateNoteMutationVariables>;

/**
 * __useCreateNoteMutation__
 *
 * To run a mutation, you first call `useCreateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNoteMutation, { data, loading, error }] = useCreateNoteMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateNoteMutation, CreateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNoteMutation, CreateNoteMutationVariables>(CreateNoteDocument, options);
      }
export type CreateNoteMutationHookResult = ReturnType<typeof useCreateNoteMutation>;
export type CreateNoteMutationResult = Apollo.MutationResult<CreateNoteMutation>;
export type CreateNoteMutationOptions = Apollo.BaseMutationOptions<CreateNoteMutation, CreateNoteMutationVariables>;
export const DeleteNoteDocument = gql`
    mutation DeleteNote($id: ID!) {
  deleteNote(id: $id)
}
    `;
export type DeleteNoteMutationFn = Apollo.MutationFunction<DeleteNoteMutation, DeleteNoteMutationVariables>;

/**
 * __useDeleteNoteMutation__
 *
 * To run a mutation, you first call `useDeleteNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNoteMutation, { data, loading, error }] = useDeleteNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteNoteMutation, DeleteNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteNoteMutation, DeleteNoteMutationVariables>(DeleteNoteDocument, options);
      }
export type DeleteNoteMutationHookResult = ReturnType<typeof useDeleteNoteMutation>;
export type DeleteNoteMutationResult = Apollo.MutationResult<DeleteNoteMutation>;
export type DeleteNoteMutationOptions = Apollo.BaseMutationOptions<DeleteNoteMutation, DeleteNoteMutationVariables>;
export const UpdateAppointmentDocument = gql`
    mutation UpdateAppointment($id: ID!, $input: UpdateAppointmentInput!) {
  updateAppointment(id: $id, input: $input) {
    id
    agenda_title
    agenda_description
    start_time
    meeting_type
    service {
      id
      name
      booking_color
      duration
      price
    }
    price
    participants {
      id
      rsvp
      user {
        id
        name
        email
        sms
        default_notification_channel
      }
      is_in_meeting
      join_url
      document_submissions {
        id
        status
        document {
          id
          name
          requirement
          created_at
          can_be_viewed_by_everybody
        }
      }
    }
    host {
      id
    }
    report_content_json
  }
}
    `;
export type UpdateAppointmentMutationFn = Apollo.MutationFunction<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;

/**
 * __useUpdateAppointmentMutation__
 *
 * To run a mutation, you first call `useUpdateAppointmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAppointmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAppointmentMutation, { data, loading, error }] = useUpdateAppointmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAppointmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>(UpdateAppointmentDocument, options);
      }
export type UpdateAppointmentMutationHookResult = ReturnType<typeof useUpdateAppointmentMutation>;
export type UpdateAppointmentMutationResult = Apollo.MutationResult<UpdateAppointmentMutation>;
export type UpdateAppointmentMutationOptions = Apollo.BaseMutationOptions<UpdateAppointmentMutation, UpdateAppointmentMutationVariables>;
export const UpdateNoteDocument = gql`
    mutation UpdateNote($id: ID!, $input: NoteInput!) {
  updateNote(id: $id, input: $input) {
    id
    title
    content
    users {
      id
    }
    created_at
  }
}
    `;
export type UpdateNoteMutationFn = Apollo.MutationFunction<UpdateNoteMutation, UpdateNoteMutationVariables>;

/**
 * __useUpdateNoteMutation__
 *
 * To run a mutation, you first call `useUpdateNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNoteMutation, { data, loading, error }] = useUpdateNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateNoteMutation, UpdateNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateNoteMutation, UpdateNoteMutationVariables>(UpdateNoteDocument, options);
      }
export type UpdateNoteMutationHookResult = ReturnType<typeof useUpdateNoteMutation>;
export type UpdateNoteMutationResult = Apollo.MutationResult<UpdateNoteMutation>;
export type UpdateNoteMutationOptions = Apollo.BaseMutationOptions<UpdateNoteMutation, UpdateNoteMutationVariables>;
export const AppointmentRequestsCountDocument = gql`
    query AppointmentRequestsCount($hostId: ID) {
  appointmentRequestsCount(host: $hostId)
}
    `;

/**
 * __useAppointmentRequestsCountQuery__
 *
 * To run a query within a React component, call `useAppointmentRequestsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentRequestsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentRequestsCountQuery({
 *   variables: {
 *      hostId: // value for 'hostId'
 *   },
 * });
 */
export function useAppointmentRequestsCountQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentRequestsCountQuery, AppointmentRequestsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentRequestsCountQuery, AppointmentRequestsCountQueryVariables>(AppointmentRequestsCountDocument, options);
      }
export function useAppointmentRequestsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentRequestsCountQuery, AppointmentRequestsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentRequestsCountQuery, AppointmentRequestsCountQueryVariables>(AppointmentRequestsCountDocument, options);
        }
export type AppointmentRequestsCountQueryHookResult = ReturnType<typeof useAppointmentRequestsCountQuery>;
export type AppointmentRequestsCountLazyQueryHookResult = ReturnType<typeof useAppointmentRequestsCountLazyQuery>;
export type AppointmentRequestsCountQueryResult = Apollo.QueryResult<AppointmentRequestsCountQuery, AppointmentRequestsCountQueryVariables>;
export const AppointmentDocument = gql`
    query Appointment($id: ID!) {
  appointment(id: $id) {
    id
    start_time
    planned_end_time
    start_app_url
    start_url
    join_url
    join_app_url
    status
    created_at
    meeting_type
    message
    documents {
      id
      name
    }
    host {
      id
      name
      email
      phone
      avatar_url
    }
    host_participant {
      id
      rsvp
      user {
        id
        name
        email
      }
      is_in_meeting
      document_submissions {
        id
        status
        document {
          id
          name
          can_be_viewed_by_everybody
        }
        signatures {
          id
          created_at
          user {
            id
            name
          }
        }
        submitted_at
      }
    }
    notes {
      id
      title
      content
      users {
        id
        name
      }
      created_at
    }
    participants {
      id
      rsvp
      user {
        id
        name
        email
        sms
        default_notification_channel
        roles {
          id
          name
        }
      }
      is_in_meeting
      join_url
      document_submissions {
        id
        status
        document {
          id
          name
          requirement
          can_be_viewed_by_everybody
          signature_type
        }
        submitted_at
        signed_by_current_user
      }
      token_code {
        id
        short_link
      }
    }
    service {
      id
      name
      description
      booking_color
      duration
      price
      documents {
        id
        name
      }
    }
    price
    history {
      id
      log_name
      description
      created_at
      properties
      causer {
        ... on User {
          id
          name
        }
        ... on Participant {
          id
          user {
            id
            name
          }
        }
      }
    }
    filtered_vitals {
      id
      name
      fdata
    }
    video_type
    dial_in
    dial_in_meeting_id
    agenda_title
    agenda_description
    vitals_media {
      id
      url
      created_at
      download_url
      user {
        id
        name
      }
      device
      file_type
    }
    redox_sending_status
    report_content_json
    appointment_audios {
      id
      status
      audio_url
      transcript {
        descriptions {
          name
        }
        transcript_status
      }
    }
  }
}
    `;

/**
 * __useAppointmentQuery__
 *
 * To run a query within a React component, call `useAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAppointmentQuery(baseOptions: Apollo.QueryHookOptions<AppointmentQuery, AppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentQuery, AppointmentQueryVariables>(AppointmentDocument, options);
      }
export function useAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentQuery, AppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentQuery, AppointmentQueryVariables>(AppointmentDocument, options);
        }
export type AppointmentQueryHookResult = ReturnType<typeof useAppointmentQuery>;
export type AppointmentLazyQueryHookResult = ReturnType<typeof useAppointmentLazyQuery>;
export type AppointmentQueryResult = Apollo.QueryResult<AppointmentQuery, AppointmentQueryVariables>;
export const AppointmentsDocument = gql`
    query Appointments($from: DateTimeFromTz, $to: DateTimeFromTz, $host: ID = null) {
  appointments(from: $from, to: $to, host: $host) {
    id
    start_time
    planned_end_time
    start_url
    start_app_url
    join_url
    join_app_url
    status
    meeting_type
    video_type
    created_at
    host {
      id
      name
      device_user
    }
    participants {
      id
      rsvp
      is_in_meeting
      token_code {
        id
        short_link
      }
      user {
        id
        name
        email
        sms
        default_notification_channel
      }
      join_url
      document_submissions {
        id
        status
        document {
          id
          requirement
        }
      }
    }
    service {
      id
      name
      booking_color
      duration
      price
    }
    price
    documents {
      id
    }
  }
}
    `;

/**
 * __useAppointmentsQuery__
 *
 * To run a query within a React component, call `useAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      host: // value for 'host'
 *   },
 * });
 */
export function useAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
      }
export function useAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentsQuery, AppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentsQuery, AppointmentsQueryVariables>(AppointmentsDocument, options);
        }
export type AppointmentsQueryHookResult = ReturnType<typeof useAppointmentsQuery>;
export type AppointmentsLazyQueryHookResult = ReturnType<typeof useAppointmentsLazyQuery>;
export type AppointmentsQueryResult = Apollo.QueryResult<AppointmentsQuery, AppointmentsQueryVariables>;
export const DocumentsDocument = gql`
    query Documents($first: Int!, $page: Int!, $orderBy: [QueryDocumentsOrderByOrderByClause!]) {
  documents(first: $first, page: $page, order_by: $orderBy) {
    data {
      id
      name
      requirement
    }
  }
}
    `;

/**
 * __useDocumentsQuery__
 *
 * To run a query within a React component, call `useDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDocumentsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useDocumentsQuery(baseOptions: Apollo.QueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
      }
export function useDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DocumentsQuery, DocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DocumentsQuery, DocumentsQueryVariables>(DocumentsDocument, options);
        }
export type DocumentsQueryHookResult = ReturnType<typeof useDocumentsQuery>;
export type DocumentsLazyQueryHookResult = ReturnType<typeof useDocumentsLazyQuery>;
export type DocumentsQueryResult = Apollo.QueryResult<DocumentsQuery, DocumentsQueryVariables>;
export const OrganizationDocument = gql`
    query Organization {
  organization {
    id
    booking_page_proposed_timeslot_duration
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const PacketsDocument = gql`
    query Packets($first: Int!, $page: Int!) {
  documentPackets(first: $first, page: $page) {
    data {
      id
      name
      documents {
        id
        name
        requirement
      }
    }
  }
}
    `;

/**
 * __usePacketsQuery__
 *
 * To run a query within a React component, call `usePacketsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePacketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePacketsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function usePacketsQuery(baseOptions: Apollo.QueryHookOptions<PacketsQuery, PacketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PacketsQuery, PacketsQueryVariables>(PacketsDocument, options);
      }
export function usePacketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PacketsQuery, PacketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PacketsQuery, PacketsQueryVariables>(PacketsDocument, options);
        }
export type PacketsQueryHookResult = ReturnType<typeof usePacketsQuery>;
export type PacketsLazyQueryHookResult = ReturnType<typeof usePacketsLazyQuery>;
export type PacketsQueryResult = Apollo.QueryResult<PacketsQuery, PacketsQueryVariables>;
export const ParticipantsConnectionDocument = gql`
    query ParticipantsConnection($search: String, $dob: DateTime, $exclude: [ID!], $first: Int!, $after: String) {
  participants(
    after: $after
    first: $first
    exclude: $exclude
    search: $search
    dob: $dob
  ) {
    pageInfo {
      hasNextPage
      count
      endCursor
      startCursor
    }
    edges {
      cursor
      node {
        id
        phone
        name
        email
        sms
        default_notification_channel
        roles {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useParticipantsConnectionQuery__
 *
 * To run a query within a React component, call `useParticipantsConnectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantsConnectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantsConnectionQuery({
 *   variables: {
 *      search: // value for 'search'
 *      dob: // value for 'dob'
 *      exclude: // value for 'exclude'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useParticipantsConnectionQuery(baseOptions: Apollo.QueryHookOptions<ParticipantsConnectionQuery, ParticipantsConnectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantsConnectionQuery, ParticipantsConnectionQueryVariables>(ParticipantsConnectionDocument, options);
      }
export function useParticipantsConnectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantsConnectionQuery, ParticipantsConnectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantsConnectionQuery, ParticipantsConnectionQueryVariables>(ParticipantsConnectionDocument, options);
        }
export type ParticipantsConnectionQueryHookResult = ReturnType<typeof useParticipantsConnectionQuery>;
export type ParticipantsConnectionLazyQueryHookResult = ReturnType<typeof useParticipantsConnectionLazyQuery>;
export type ParticipantsConnectionQueryResult = Apollo.QueryResult<ParticipantsConnectionQuery, ParticipantsConnectionQueryVariables>;
export const CreateAppointmentServiceListDocument = gql`
    query CreateAppointmentServiceList($first: Int!, $page: Int!, $where: QueryServicesWhereWhereConditions, $practitioner: ID) {
  services(first: $first, page: $page, where: $where, practitioner: $practitioner) {
    data {
      id
      name
      price
      duration
      booking_color
      documents {
        id
      }
      practitioners {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useCreateAppointmentServiceListQuery__
 *
 * To run a query within a React component, call `useCreateAppointmentServiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentServiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateAppointmentServiceListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      where: // value for 'where'
 *      practitioner: // value for 'practitioner'
 *   },
 * });
 */
export function useCreateAppointmentServiceListQuery(baseOptions: Apollo.QueryHookOptions<CreateAppointmentServiceListQuery, CreateAppointmentServiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateAppointmentServiceListQuery, CreateAppointmentServiceListQueryVariables>(CreateAppointmentServiceListDocument, options);
      }
export function useCreateAppointmentServiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateAppointmentServiceListQuery, CreateAppointmentServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateAppointmentServiceListQuery, CreateAppointmentServiceListQueryVariables>(CreateAppointmentServiceListDocument, options);
        }
export type CreateAppointmentServiceListQueryHookResult = ReturnType<typeof useCreateAppointmentServiceListQuery>;
export type CreateAppointmentServiceListLazyQueryHookResult = ReturnType<typeof useCreateAppointmentServiceListLazyQuery>;
export type CreateAppointmentServiceListQueryResult = Apollo.QueryResult<CreateAppointmentServiceListQuery, CreateAppointmentServiceListQueryVariables>;
export const SlotsDocument = gql`
    query Slots($id: ID) {
  slots(user: $id) {
    id
    from
    to
    weekday
  }
}
    `;

/**
 * __useSlotsQuery__
 *
 * To run a query within a React component, call `useSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSlotsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSlotsQuery(baseOptions?: Apollo.QueryHookOptions<SlotsQuery, SlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SlotsQuery, SlotsQueryVariables>(SlotsDocument, options);
      }
export function useSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SlotsQuery, SlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SlotsQuery, SlotsQueryVariables>(SlotsDocument, options);
        }
export type SlotsQueryHookResult = ReturnType<typeof useSlotsQuery>;
export type SlotsLazyQueryHookResult = ReturnType<typeof useSlotsLazyQuery>;
export type SlotsQueryResult = Apollo.QueryResult<SlotsQuery, SlotsQueryVariables>;
export const TodayAppointmentsDocument = gql`
    query TodayAppointments($from: DateTimeFromTz, $to: DateTimeFromTz, $status: [AppointmentStatusEnum]) {
  appointments(from: $from, to: $to, status: $status) {
    id
  }
}
    `;

/**
 * __useTodayAppointmentsQuery__
 *
 * To run a query within a React component, call `useTodayAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTodayAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTodayAppointmentsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useTodayAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<TodayAppointmentsQuery, TodayAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TodayAppointmentsQuery, TodayAppointmentsQueryVariables>(TodayAppointmentsDocument, options);
      }
export function useTodayAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TodayAppointmentsQuery, TodayAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TodayAppointmentsQuery, TodayAppointmentsQueryVariables>(TodayAppointmentsDocument, options);
        }
export type TodayAppointmentsQueryHookResult = ReturnType<typeof useTodayAppointmentsQuery>;
export type TodayAppointmentsLazyQueryHookResult = ReturnType<typeof useTodayAppointmentsLazyQuery>;
export type TodayAppointmentsQueryResult = Apollo.QueryResult<TodayAppointmentsQuery, TodayAppointmentsQueryVariables>;
export const UserAvailabilityDocument = gql`
    query UserAvailability($host: ID, $service: ID!, $date: DateTime!, $location: String) {
  userAvailability(
    host: $host
    service: $service
    date: $date
    location: $location
  ) {
    available
    is_appointment
    time
    outside_working_hours
  }
}
    `;

/**
 * __useUserAvailabilityQuery__
 *
 * To run a query within a React component, call `useUserAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserAvailabilityQuery({
 *   variables: {
 *      host: // value for 'host'
 *      service: // value for 'service'
 *      date: // value for 'date'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUserAvailabilityQuery(baseOptions: Apollo.QueryHookOptions<UserAvailabilityQuery, UserAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserAvailabilityQuery, UserAvailabilityQueryVariables>(UserAvailabilityDocument, options);
      }
export function useUserAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserAvailabilityQuery, UserAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserAvailabilityQuery, UserAvailabilityQueryVariables>(UserAvailabilityDocument, options);
        }
export type UserAvailabilityQueryHookResult = ReturnType<typeof useUserAvailabilityQuery>;
export type UserAvailabilityLazyQueryHookResult = ReturnType<typeof useUserAvailabilityLazyQuery>;
export type UserAvailabilityQueryResult = Apollo.QueryResult<UserAvailabilityQuery, UserAvailabilityQueryVariables>;
export const AppointmentCancelledDocument = gql`
    subscription AppointmentCancelled($orgId: ID!, $host_id: ID, $appointmentId: ID) {
  appointmentCancelled(
    org_id: $orgId
    host_id: $host_id
    appointment_id: $appointmentId
  )
}
    `;

/**
 * __useAppointmentCancelledSubscription__
 *
 * To run a query within a React component, call `useAppointmentCancelledSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentCancelledSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentCancelledSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      host_id: // value for 'host_id'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentCancelledSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentCancelledSubscription, AppointmentCancelledSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentCancelledSubscription, AppointmentCancelledSubscriptionVariables>(AppointmentCancelledDocument, options);
      }
export type AppointmentCancelledSubscriptionHookResult = ReturnType<typeof useAppointmentCancelledSubscription>;
export type AppointmentCancelledSubscriptionResult = Apollo.SubscriptionResult<AppointmentCancelledSubscription>;
export const AppointmentCreatedDocument = gql`
    subscription AppointmentCreated($org_id: ID!, $host_id: ID) {
  appointmentCreated(org_id: $org_id, host_id: $host_id) {
    id
    start_time
    planned_end_time
    start_url
    join_url
    status
    start_app_url
    join_app_url
    created_at
    documents {
      id
      name
    }
    host {
      id
      name
      email
      avatar_url
    }
    notes {
      id
      created_at
    }
    participants {
      id
      rsvp
      is_in_meeting
      token_code {
        short_link
      }
      user {
        id
        name
        email
        sms
        default_notification_channel
      }
      join_url
      document_submissions {
        id
        status
        document {
          id
          requirement
        }
      }
    }
    history {
      id
      log_name
      description
      created_at
      properties
      causer {
        ... on User {
          id
          name
        }
        ... on Participant {
          id
          user {
            id
            name
          }
        }
      }
    }
    service {
      id
      name
      description
      booking_color
    }
  }
}
    `;

/**
 * __useAppointmentCreatedSubscription__
 *
 * To run a query within a React component, call `useAppointmentCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentCreatedSubscription({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      host_id: // value for 'host_id'
 *   },
 * });
 */
export function useAppointmentCreatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentCreatedSubscription, AppointmentCreatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentCreatedSubscription, AppointmentCreatedSubscriptionVariables>(AppointmentCreatedDocument, options);
      }
export type AppointmentCreatedSubscriptionHookResult = ReturnType<typeof useAppointmentCreatedSubscription>;
export type AppointmentCreatedSubscriptionResult = Apollo.SubscriptionResult<AppointmentCreatedSubscription>;
export const AppointmentUpdatedDocument = gql`
    subscription AppointmentUpdated($org_id: ID!, $host_id: ID, $appointmentId: ID) {
  appointmentUpdated(
    org_id: $org_id
    host_id: $host_id
    appointment_id: $appointmentId
  ) {
    id
    start_time
    planned_end_time
    status
    start_url
    join_url
    created_at
    start_app_url
    join_app_url
    documents {
      id
      name
    }
    participants {
      id
      rsvp
      token_code {
        short_link
      }
      user {
        id
        name
        email
        sms
        default_notification_channel
      }
      join_url
    }
    host {
      id
    }
    vitals_media {
      id
      url
      created_at
      user {
        id
        name
      }
      device
      file_type
    }
    redox_sending_status
    filtered_vitals {
      id
      name
      fdata
    }
  }
}
    `;

/**
 * __useAppointmentUpdatedSubscription__
 *
 * To run a query within a React component, call `useAppointmentUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentUpdatedSubscription({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      host_id: // value for 'host_id'
 *      appointmentId: // value for 'appointmentId'
 *   },
 * });
 */
export function useAppointmentUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<AppointmentUpdatedSubscription, AppointmentUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<AppointmentUpdatedSubscription, AppointmentUpdatedSubscriptionVariables>(AppointmentUpdatedDocument, options);
      }
export type AppointmentUpdatedSubscriptionHookResult = ReturnType<typeof useAppointmentUpdatedSubscription>;
export type AppointmentUpdatedSubscriptionResult = Apollo.SubscriptionResult<AppointmentUpdatedSubscription>;
export const ParticipantStatusUpdatedDocument = gql`
    subscription ParticipantStatusUpdated($orgId: ID!) {
  participantUpdated(org_id: $orgId) {
    id
    rsvp
    is_in_meeting
    token_code {
      short_link
    }
  }
}
    `;

/**
 * __useParticipantStatusUpdatedSubscription__
 *
 * To run a query within a React component, call `useParticipantStatusUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useParticipantStatusUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantStatusUpdatedSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useParticipantStatusUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<ParticipantStatusUpdatedSubscription, ParticipantStatusUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ParticipantStatusUpdatedSubscription, ParticipantStatusUpdatedSubscriptionVariables>(ParticipantStatusUpdatedDocument, options);
      }
export type ParticipantStatusUpdatedSubscriptionHookResult = ReturnType<typeof useParticipantStatusUpdatedSubscription>;
export type ParticipantStatusUpdatedSubscriptionResult = Apollo.SubscriptionResult<ParticipantStatusUpdatedSubscription>;
export const AuthByTokenDocument = gql`
    mutation AuthByToken($token: String!) {
  customAuth(token: $token) {
    IdToken
    RefreshToken
    AccessToken
    ExpiresIn
  }
}
    `;
export type AuthByTokenMutationFn = Apollo.MutationFunction<AuthByTokenMutation, AuthByTokenMutationVariables>;

/**
 * __useAuthByTokenMutation__
 *
 * To run a mutation, you first call `useAuthByTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthByTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authByTokenMutation, { data, loading, error }] = useAuthByTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useAuthByTokenMutation(baseOptions?: Apollo.MutationHookOptions<AuthByTokenMutation, AuthByTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AuthByTokenMutation, AuthByTokenMutationVariables>(AuthByTokenDocument, options);
      }
export type AuthByTokenMutationHookResult = ReturnType<typeof useAuthByTokenMutation>;
export type AuthByTokenMutationResult = Apollo.MutationResult<AuthByTokenMutation>;
export type AuthByTokenMutationOptions = Apollo.BaseMutationOptions<AuthByTokenMutation, AuthByTokenMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation ChangePassword($input: ChangePasswordInput!) {
  changePassword(input: $input)
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ChangeTemporaryPasswordDocument = gql`
    mutation ChangeTemporaryPassword($input: ChangeTemporaryPasswordInput!) {
  changeTemporaryPassword(input: $input) {
    AccessToken
    RefreshToken
    ExpiresIn
    IdToken
    TokenType
    Uid
  }
}
    `;
export type ChangeTemporaryPasswordMutationFn = Apollo.MutationFunction<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>;

/**
 * __useChangeTemporaryPasswordMutation__
 *
 * To run a mutation, you first call `useChangeTemporaryPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeTemporaryPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeTemporaryPasswordMutation, { data, loading, error }] = useChangeTemporaryPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeTemporaryPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>(ChangeTemporaryPasswordDocument, options);
      }
export type ChangeTemporaryPasswordMutationHookResult = ReturnType<typeof useChangeTemporaryPasswordMutation>;
export type ChangeTemporaryPasswordMutationResult = Apollo.MutationResult<ChangeTemporaryPasswordMutation>;
export type ChangeTemporaryPasswordMutationOptions = Apollo.BaseMutationOptions<ChangeTemporaryPasswordMutation, ChangeTemporaryPasswordMutationVariables>;
export const ExchangeCodeForTokenDocument = gql`
    mutation ExchangeCodeForToken($code: String!, $forMedcart: Boolean) {
  exchangeCodeForToken(code: $code, forMedcart: $forMedcart) {
    IdToken
    RefreshToken
    AccessToken
    ExpiresIn
    Uid
  }
}
    `;
export type ExchangeCodeForTokenMutationFn = Apollo.MutationFunction<ExchangeCodeForTokenMutation, ExchangeCodeForTokenMutationVariables>;

/**
 * __useExchangeCodeForTokenMutation__
 *
 * To run a mutation, you first call `useExchangeCodeForTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExchangeCodeForTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exchangeCodeForTokenMutation, { data, loading, error }] = useExchangeCodeForTokenMutation({
 *   variables: {
 *      code: // value for 'code'
 *      forMedcart: // value for 'forMedcart'
 *   },
 * });
 */
export function useExchangeCodeForTokenMutation(baseOptions?: Apollo.MutationHookOptions<ExchangeCodeForTokenMutation, ExchangeCodeForTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExchangeCodeForTokenMutation, ExchangeCodeForTokenMutationVariables>(ExchangeCodeForTokenDocument, options);
      }
export type ExchangeCodeForTokenMutationHookResult = ReturnType<typeof useExchangeCodeForTokenMutation>;
export type ExchangeCodeForTokenMutationResult = Apollo.MutationResult<ExchangeCodeForTokenMutation>;
export type ExchangeCodeForTokenMutationOptions = Apollo.BaseMutationOptions<ExchangeCodeForTokenMutation, ExchangeCodeForTokenMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($username: String!) {
  forgotPassword(username: $username)
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginDocument = gql`
    mutation Login($username: String!, $password: String!) {
  login(username: $username, password: $password) {
    ... on NewPasswordRequired {
      Session
    }
    ... on AuthResponse {
      AccessToken
      RefreshToken
      ExpiresIn
      IdToken
      TokenType
      Uid
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: ResetPasswordInput!) {
  reset(input: $input)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const IdentityProvidersDocument = gql`
    query IdentityProviders($forMedcart: Boolean) {
  identityProviders(forMedcart: $forMedcart) {
    name
    url
  }
}
    `;

/**
 * __useIdentityProvidersQuery__
 *
 * To run a query within a React component, call `useIdentityProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIdentityProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIdentityProvidersQuery({
 *   variables: {
 *      forMedcart: // value for 'forMedcart'
 *   },
 * });
 */
export function useIdentityProvidersQuery(baseOptions?: Apollo.QueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IdentityProvidersQuery, IdentityProvidersQueryVariables>(IdentityProvidersDocument, options);
      }
export function useIdentityProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IdentityProvidersQuery, IdentityProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IdentityProvidersQuery, IdentityProvidersQueryVariables>(IdentityProvidersDocument, options);
        }
export type IdentityProvidersQueryHookResult = ReturnType<typeof useIdentityProvidersQuery>;
export type IdentityProvidersLazyQueryHookResult = ReturnType<typeof useIdentityProvidersLazyQuery>;
export type IdentityProvidersQueryResult = Apollo.QueryResult<IdentityProvidersQuery, IdentityProvidersQueryVariables>;
export const ShortTokenDocument = gql`
    mutation ShortToken($uid: String!) {
  exchangeUid(uid: $uid)
}
    `;
export type ShortTokenMutationFn = Apollo.MutationFunction<ShortTokenMutation, ShortTokenMutationVariables>;

/**
 * __useShortTokenMutation__
 *
 * To run a mutation, you first call `useShortTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShortTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shortTokenMutation, { data, loading, error }] = useShortTokenMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useShortTokenMutation(baseOptions?: Apollo.MutationHookOptions<ShortTokenMutation, ShortTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShortTokenMutation, ShortTokenMutationVariables>(ShortTokenDocument, options);
      }
export type ShortTokenMutationHookResult = ReturnType<typeof useShortTokenMutation>;
export type ShortTokenMutationResult = Apollo.MutationResult<ShortTokenMutation>;
export type ShortTokenMutationOptions = Apollo.BaseMutationOptions<ShortTokenMutation, ShortTokenMutationVariables>;
export const CreateServiceGroupDocument = gql`
    mutation CreateServiceGroup($input: ServiceGroupInput!) {
  createServiceGroup(input: $input) {
    id
    name
    services {
      id
      name
    }
  }
}
    `;
export type CreateServiceGroupMutationFn = Apollo.MutationFunction<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>;

/**
 * __useCreateServiceGroupMutation__
 *
 * To run a mutation, you first call `useCreateServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceGroupMutation, { data, loading, error }] = useCreateServiceGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>(CreateServiceGroupDocument, options);
      }
export type CreateServiceGroupMutationHookResult = ReturnType<typeof useCreateServiceGroupMutation>;
export type CreateServiceGroupMutationResult = Apollo.MutationResult<CreateServiceGroupMutation>;
export type CreateServiceGroupMutationOptions = Apollo.BaseMutationOptions<CreateServiceGroupMutation, CreateServiceGroupMutationVariables>;
export const DeleteServiceGroupDocument = gql`
    mutation DeleteServiceGroup($id: ID!) {
  deleteServiceGroup(id: $id)
}
    `;
export type DeleteServiceGroupMutationFn = Apollo.MutationFunction<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>;

/**
 * __useDeleteServiceGroupMutation__
 *
 * To run a mutation, you first call `useDeleteServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceGroupMutation, { data, loading, error }] = useDeleteServiceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>(DeleteServiceGroupDocument, options);
      }
export type DeleteServiceGroupMutationHookResult = ReturnType<typeof useDeleteServiceGroupMutation>;
export type DeleteServiceGroupMutationResult = Apollo.MutationResult<DeleteServiceGroupMutation>;
export type DeleteServiceGroupMutationOptions = Apollo.BaseMutationOptions<DeleteServiceGroupMutation, DeleteServiceGroupMutationVariables>;
export const SaveBookingDocument = gql`
    mutation SaveBooking($input: OrganizationInput!) {
  updateOrganization(input: $input) {
    id
    booking_description
    booking_page_proposed_timeslot_duration
  }
}
    `;
export type SaveBookingMutationFn = Apollo.MutationFunction<SaveBookingMutation, SaveBookingMutationVariables>;

/**
 * __useSaveBookingMutation__
 *
 * To run a mutation, you first call `useSaveBookingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBookingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBookingMutation, { data, loading, error }] = useSaveBookingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveBookingMutation(baseOptions?: Apollo.MutationHookOptions<SaveBookingMutation, SaveBookingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveBookingMutation, SaveBookingMutationVariables>(SaveBookingDocument, options);
      }
export type SaveBookingMutationHookResult = ReturnType<typeof useSaveBookingMutation>;
export type SaveBookingMutationResult = Apollo.MutationResult<SaveBookingMutation>;
export type SaveBookingMutationOptions = Apollo.BaseMutationOptions<SaveBookingMutation, SaveBookingMutationVariables>;
export const UpdateServiceGroupDocument = gql`
    mutation UpdateServiceGroup($id: ID!, $input: ServiceGroupInput!) {
  updateServiceGroup(id: $id, input: $input) {
    id
    name
    services {
      id
      name
    }
  }
}
    `;
export type UpdateServiceGroupMutationFn = Apollo.MutationFunction<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>;

/**
 * __useUpdateServiceGroupMutation__
 *
 * To run a mutation, you first call `useUpdateServiceGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceGroupMutation, { data, loading, error }] = useUpdateServiceGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>(UpdateServiceGroupDocument, options);
      }
export type UpdateServiceGroupMutationHookResult = ReturnType<typeof useUpdateServiceGroupMutation>;
export type UpdateServiceGroupMutationResult = Apollo.MutationResult<UpdateServiceGroupMutation>;
export type UpdateServiceGroupMutationOptions = Apollo.BaseMutationOptions<UpdateServiceGroupMutation, UpdateServiceGroupMutationVariables>;
export const BookingOrganizationDocument = gql`
    query BookingOrganization {
  organization {
    id
    booking_description
    booking_page_proposed_timeslot_duration
  }
}
    `;

/**
 * __useBookingOrganizationQuery__
 *
 * To run a query within a React component, call `useBookingOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingOrganizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<BookingOrganizationQuery, BookingOrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingOrganizationQuery, BookingOrganizationQueryVariables>(BookingOrganizationDocument, options);
      }
export function useBookingOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingOrganizationQuery, BookingOrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingOrganizationQuery, BookingOrganizationQueryVariables>(BookingOrganizationDocument, options);
        }
export type BookingOrganizationQueryHookResult = ReturnType<typeof useBookingOrganizationQuery>;
export type BookingOrganizationLazyQueryHookResult = ReturnType<typeof useBookingOrganizationLazyQuery>;
export type BookingOrganizationQueryResult = Apollo.QueryResult<BookingOrganizationQuery, BookingOrganizationQueryVariables>;
export const ServiceGroupListDocument = gql`
    query ServiceGroupList {
  serviceGroups {
    id
    name
    services {
      id
      name
    }
  }
}
    `;

/**
 * __useServiceGroupListQuery__
 *
 * To run a query within a React component, call `useServiceGroupListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceGroupListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceGroupListQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceGroupListQuery(baseOptions?: Apollo.QueryHookOptions<ServiceGroupListQuery, ServiceGroupListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceGroupListQuery, ServiceGroupListQueryVariables>(ServiceGroupListDocument, options);
      }
export function useServiceGroupListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceGroupListQuery, ServiceGroupListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceGroupListQuery, ServiceGroupListQueryVariables>(ServiceGroupListDocument, options);
        }
export type ServiceGroupListQueryHookResult = ReturnType<typeof useServiceGroupListQuery>;
export type ServiceGroupListLazyQueryHookResult = ReturnType<typeof useServiceGroupListLazyQuery>;
export type ServiceGroupListQueryResult = Apollo.QueryResult<ServiceGroupListQuery, ServiceGroupListQueryVariables>;
export const GetServiceGroupDocument = gql`
    query GetServiceGroup($id: ID!) {
  serviceGroup(id: $id) {
    id
    name
    description
    services {
      id
      name
    }
  }
}
    `;

/**
 * __useGetServiceGroupQuery__
 *
 * To run a query within a React component, call `useGetServiceGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceGroupQuery(baseOptions: Apollo.QueryHookOptions<GetServiceGroupQuery, GetServiceGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceGroupQuery, GetServiceGroupQueryVariables>(GetServiceGroupDocument, options);
      }
export function useGetServiceGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceGroupQuery, GetServiceGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceGroupQuery, GetServiceGroupQueryVariables>(GetServiceGroupDocument, options);
        }
export type GetServiceGroupQueryHookResult = ReturnType<typeof useGetServiceGroupQuery>;
export type GetServiceGroupLazyQueryHookResult = ReturnType<typeof useGetServiceGroupLazyQuery>;
export type GetServiceGroupQueryResult = Apollo.QueryResult<GetServiceGroupQuery, GetServiceGroupQueryVariables>;
export const CreateServiceGroupServiceListDocument = gql`
    query CreateServiceGroupServiceList($first: Int!, $page: Int!) {
  services(first: $first, page: $page) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useCreateServiceGroupServiceListQuery__
 *
 * To run a query within a React component, call `useCreateServiceGroupServiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceGroupServiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateServiceGroupServiceListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCreateServiceGroupServiceListQuery(baseOptions: Apollo.QueryHookOptions<CreateServiceGroupServiceListQuery, CreateServiceGroupServiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateServiceGroupServiceListQuery, CreateServiceGroupServiceListQueryVariables>(CreateServiceGroupServiceListDocument, options);
      }
export function useCreateServiceGroupServiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateServiceGroupServiceListQuery, CreateServiceGroupServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateServiceGroupServiceListQuery, CreateServiceGroupServiceListQueryVariables>(CreateServiceGroupServiceListDocument, options);
        }
export type CreateServiceGroupServiceListQueryHookResult = ReturnType<typeof useCreateServiceGroupServiceListQuery>;
export type CreateServiceGroupServiceListLazyQueryHookResult = ReturnType<typeof useCreateServiceGroupServiceListLazyQuery>;
export type CreateServiceGroupServiceListQueryResult = Apollo.QueryResult<CreateServiceGroupServiceListQuery, CreateServiceGroupServiceListQueryVariables>;
export const ChangeParticipantStatusDocument = gql`
    mutation ChangeParticipantStatus($input: ParticipantStatusInput!) {
  changeParticipantStatus(input: $input)
}
    `;
export type ChangeParticipantStatusMutationFn = Apollo.MutationFunction<ChangeParticipantStatusMutation, ChangeParticipantStatusMutationVariables>;

/**
 * __useChangeParticipantStatusMutation__
 *
 * To run a mutation, you first call `useChangeParticipantStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeParticipantStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeParticipantStatusMutation, { data, loading, error }] = useChangeParticipantStatusMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeParticipantStatusMutation(baseOptions?: Apollo.MutationHookOptions<ChangeParticipantStatusMutation, ChangeParticipantStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeParticipantStatusMutation, ChangeParticipantStatusMutationVariables>(ChangeParticipantStatusDocument, options);
      }
export type ChangeParticipantStatusMutationHookResult = ReturnType<typeof useChangeParticipantStatusMutation>;
export type ChangeParticipantStatusMutationResult = Apollo.MutationResult<ChangeParticipantStatusMutation>;
export type ChangeParticipantStatusMutationOptions = Apollo.BaseMutationOptions<ChangeParticipantStatusMutation, ChangeParticipantStatusMutationVariables>;
export const GenerateTwilioTokenDocument = gql`
    mutation GenerateTwilioToken($appointment_id: ID!) {
  generateTwilioToken(appointment_id: $appointment_id) {
    room
    token
  }
}
    `;
export type GenerateTwilioTokenMutationFn = Apollo.MutationFunction<GenerateTwilioTokenMutation, GenerateTwilioTokenMutationVariables>;

/**
 * __useGenerateTwilioTokenMutation__
 *
 * To run a mutation, you first call `useGenerateTwilioTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateTwilioTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateTwilioTokenMutation, { data, loading, error }] = useGenerateTwilioTokenMutation({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *   },
 * });
 */
export function useGenerateTwilioTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateTwilioTokenMutation, GenerateTwilioTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateTwilioTokenMutation, GenerateTwilioTokenMutationVariables>(GenerateTwilioTokenDocument, options);
      }
export type GenerateTwilioTokenMutationHookResult = ReturnType<typeof useGenerateTwilioTokenMutation>;
export type GenerateTwilioTokenMutationResult = Apollo.MutationResult<GenerateTwilioTokenMutation>;
export type GenerateTwilioTokenMutationOptions = Apollo.BaseMutationOptions<GenerateTwilioTokenMutation, GenerateTwilioTokenMutationVariables>;
export const TwilioParticipantUpdatedDocument = gql`
    subscription TwilioParticipantUpdated($org_id: ID!, $id: ID!) {
  twilioParticipantUpdated(org_id: $org_id, appointment_id: $id) {
    enable_audio
    enable_video
  }
}
    `;

/**
 * __useTwilioParticipantUpdatedSubscription__
 *
 * To run a query within a React component, call `useTwilioParticipantUpdatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useTwilioParticipantUpdatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTwilioParticipantUpdatedSubscription({
 *   variables: {
 *      org_id: // value for 'org_id'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTwilioParticipantUpdatedSubscription(baseOptions: Apollo.SubscriptionHookOptions<TwilioParticipantUpdatedSubscription, TwilioParticipantUpdatedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<TwilioParticipantUpdatedSubscription, TwilioParticipantUpdatedSubscriptionVariables>(TwilioParticipantUpdatedDocument, options);
      }
export type TwilioParticipantUpdatedSubscriptionHookResult = ReturnType<typeof useTwilioParticipantUpdatedSubscription>;
export type TwilioParticipantUpdatedSubscriptionResult = Apollo.SubscriptionResult<TwilioParticipantUpdatedSubscription>;
export const FastRegistrationDocument = gql`
    mutation FastRegistration($input: CreatePatientWithoutContactInput!) {
  createPatientWithoutContact(input: $input) {
    ... on AuthResponse {
      AccessToken
      RefreshToken
      ExpiresIn
      IdToken
      TokenType
      Uid
    }
  }
}
    `;
export type FastRegistrationMutationFn = Apollo.MutationFunction<FastRegistrationMutation, FastRegistrationMutationVariables>;

/**
 * __useFastRegistrationMutation__
 *
 * To run a mutation, you first call `useFastRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFastRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fastRegistrationMutation, { data, loading, error }] = useFastRegistrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useFastRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<FastRegistrationMutation, FastRegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FastRegistrationMutation, FastRegistrationMutationVariables>(FastRegistrationDocument, options);
      }
export type FastRegistrationMutationHookResult = ReturnType<typeof useFastRegistrationMutation>;
export type FastRegistrationMutationResult = Apollo.MutationResult<FastRegistrationMutation>;
export type FastRegistrationMutationOptions = Apollo.BaseMutationOptions<FastRegistrationMutation, FastRegistrationMutationVariables>;
export const BookingInfoDocument = gql`
    query BookingInfo {
  organization {
    id
    booking_description
  }
}
    `;

/**
 * __useBookingInfoQuery__
 *
 * To run a query within a React component, call `useBookingInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookingInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookingInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useBookingInfoQuery(baseOptions?: Apollo.QueryHookOptions<BookingInfoQuery, BookingInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookingInfoQuery, BookingInfoQueryVariables>(BookingInfoDocument, options);
      }
export function useBookingInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookingInfoQuery, BookingInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookingInfoQuery, BookingInfoQueryVariables>(BookingInfoDocument, options);
        }
export type BookingInfoQueryHookResult = ReturnType<typeof useBookingInfoQuery>;
export type BookingInfoLazyQueryHookResult = ReturnType<typeof useBookingInfoLazyQuery>;
export type BookingInfoQueryResult = Apollo.QueryResult<BookingInfoQuery, BookingInfoQueryVariables>;
export const ServiceByIdDocument = gql`
    query ServiceById($id: ID!, $location: String) {
  service(id: $id) {
    id
    name
    description
    duration
    price
    booking_on_demand
    select_any_provider
    practitioners(location: $location) {
      id
      name
      avatar_url
    }
  }
}
    `;

/**
 * __useServiceByIdQuery__
 *
 * To run a query within a React component, call `useServiceByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useServiceByIdQuery(baseOptions: Apollo.QueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
      }
export function useServiceByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceByIdQuery, ServiceByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceByIdQuery, ServiceByIdQueryVariables>(ServiceByIdDocument, options);
        }
export type ServiceByIdQueryHookResult = ReturnType<typeof useServiceByIdQuery>;
export type ServiceByIdLazyQueryHookResult = ReturnType<typeof useServiceByIdLazyQuery>;
export type ServiceByIdQueryResult = Apollo.QueryResult<ServiceByIdQuery, ServiceByIdQueryVariables>;
export const OrganizationMessagesDocument = gql`
    query OrganizationMessages {
  organization_messages {
    id
    type
    title
    content
  }
}
    `;

/**
 * __useOrganizationMessagesQuery__
 *
 * To run a query within a React component, call `useOrganizationMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationMessagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationMessagesQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
      }
export function useOrganizationMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>(OrganizationMessagesDocument, options);
        }
export type OrganizationMessagesQueryHookResult = ReturnType<typeof useOrganizationMessagesQuery>;
export type OrganizationMessagesLazyQueryHookResult = ReturnType<typeof useOrganizationMessagesLazyQuery>;
export type OrganizationMessagesQueryResult = Apollo.QueryResult<OrganizationMessagesQuery, OrganizationMessagesQueryVariables>;
export const ServiceGroupsDocument = gql`
    query ServiceGroups {
  serviceGroups {
    id
    name
    description
    services {
      id
      name
      price
      duration
      description
      can_be_scheduled
      booking_on_demand
      select_any_provider
      ondemand_practitioners {
        id
      }
      practitioners {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useServiceGroupsQuery__
 *
 * To run a query within a React component, call `useServiceGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceGroupsQuery(baseOptions?: Apollo.QueryHookOptions<ServiceGroupsQuery, ServiceGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceGroupsQuery, ServiceGroupsQueryVariables>(ServiceGroupsDocument, options);
      }
export function useServiceGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceGroupsQuery, ServiceGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceGroupsQuery, ServiceGroupsQueryVariables>(ServiceGroupsDocument, options);
        }
export type ServiceGroupsQueryHookResult = ReturnType<typeof useServiceGroupsQuery>;
export type ServiceGroupsLazyQueryHookResult = ReturnType<typeof useServiceGroupsLazyQuery>;
export type ServiceGroupsQueryResult = Apollo.QueryResult<ServiceGroupsQuery, ServiceGroupsQueryVariables>;
export const ServiceWithProviderDocument = gql`
    query ServiceWithProvider($serviceId: ID!, $providerId: ID!) {
  service(id: $serviceId) {
    id
    name
    description
    duration
    price
    booking_on_demand
  }
  user(id: $providerId) {
    id
    name
  }
}
    `;

/**
 * __useServiceWithProviderQuery__
 *
 * To run a query within a React component, call `useServiceWithProviderQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceWithProviderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceWithProviderQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *      providerId: // value for 'providerId'
 *   },
 * });
 */
export function useServiceWithProviderQuery(baseOptions: Apollo.QueryHookOptions<ServiceWithProviderQuery, ServiceWithProviderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceWithProviderQuery, ServiceWithProviderQueryVariables>(ServiceWithProviderDocument, options);
      }
export function useServiceWithProviderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceWithProviderQuery, ServiceWithProviderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceWithProviderQuery, ServiceWithProviderQueryVariables>(ServiceWithProviderDocument, options);
        }
export type ServiceWithProviderQueryHookResult = ReturnType<typeof useServiceWithProviderQuery>;
export type ServiceWithProviderLazyQueryHookResult = ReturnType<typeof useServiceWithProviderLazyQuery>;
export type ServiceWithProviderQueryResult = Apollo.QueryResult<ServiceWithProviderQuery, ServiceWithProviderQueryVariables>;
export const ServiceDocument = gql`
    query Service($serviceId: ID!) {
  service(id: $serviceId) {
    id
    name
    description
    duration
    price
    booking_on_demand
    select_any_provider
  }
}
    `;

/**
 * __useServiceQuery__
 *
 * To run a query within a React component, call `useServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useServiceQuery(baseOptions: Apollo.QueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
      }
export function useServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
        }
export type ServiceQueryHookResult = ReturnType<typeof useServiceQuery>;
export type ServiceLazyQueryHookResult = ReturnType<typeof useServiceLazyQuery>;
export type ServiceQueryResult = Apollo.QueryResult<ServiceQuery, ServiceQueryVariables>;
export const CreateAppointmentRequestDocument = gql`
    mutation CreateAppointmentRequest($input: CreateAppointmentRequestInput!) {
  createAppointmentRequest(input: $input) {
    id
    start_time
    planned_end_time
  }
}
    `;
export type CreateAppointmentRequestMutationFn = Apollo.MutationFunction<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;

/**
 * __useCreateAppointmentRequestMutation__
 *
 * To run a mutation, you first call `useCreateAppointmentRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAppointmentRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAppointmentRequestMutation, { data, loading, error }] = useCreateAppointmentRequestMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAppointmentRequestMutation(baseOptions?: Apollo.MutationHookOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>(CreateAppointmentRequestDocument, options);
      }
export type CreateAppointmentRequestMutationHookResult = ReturnType<typeof useCreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationResult = Apollo.MutationResult<CreateAppointmentRequestMutation>;
export type CreateAppointmentRequestMutationOptions = Apollo.BaseMutationOptions<CreateAppointmentRequestMutation, CreateAppointmentRequestMutationVariables>;
export const ParticipantAppointmentDocument = gql`
    query ParticipantAppointment($id: ID!) {
  appointment(id: $id) {
    id
    start_time
    planned_end_time
    status
    message
    service {
      id
      name
      description
      price
    }
    host {
      id
      name
      phone
      avatar_url
    }
    participants {
      id
      rsvp
      is_in_meeting
      user {
        id
        name
        email
      }
      document_submissions {
        id
        status
        signed_by_current_user
        submitted_at
        document {
          id
          name
          requirement
          signature_type
        }
      }
      join_url
      join_app_url
    }
    invoices {
      id
      amount
      status
    }
  }
}
    `;

/**
 * __useParticipantAppointmentQuery__
 *
 * To run a query within a React component, call `useParticipantAppointmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantAppointmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantAppointmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useParticipantAppointmentQuery(baseOptions: Apollo.QueryHookOptions<ParticipantAppointmentQuery, ParticipantAppointmentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantAppointmentQuery, ParticipantAppointmentQueryVariables>(ParticipantAppointmentDocument, options);
      }
export function useParticipantAppointmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantAppointmentQuery, ParticipantAppointmentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantAppointmentQuery, ParticipantAppointmentQueryVariables>(ParticipantAppointmentDocument, options);
        }
export type ParticipantAppointmentQueryHookResult = ReturnType<typeof useParticipantAppointmentQuery>;
export type ParticipantAppointmentLazyQueryHookResult = ReturnType<typeof useParticipantAppointmentLazyQuery>;
export type ParticipantAppointmentQueryResult = Apollo.QueryResult<ParticipantAppointmentQuery, ParticipantAppointmentQueryVariables>;
export const ParticipantRsvpDocument = gql`
    mutation ParticipantRsvp($appointment_id: ID!, $rsvp: RsvpTypesEnum!) {
  participantRsvp(appointment_id: $appointment_id, rsvp: $rsvp) {
    id
    rsvp
  }
}
    `;
export type ParticipantRsvpMutationFn = Apollo.MutationFunction<ParticipantRsvpMutation, ParticipantRsvpMutationVariables>;

/**
 * __useParticipantRsvpMutation__
 *
 * To run a mutation, you first call `useParticipantRsvpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useParticipantRsvpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [participantRsvpMutation, { data, loading, error }] = useParticipantRsvpMutation({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *      rsvp: // value for 'rsvp'
 *   },
 * });
 */
export function useParticipantRsvpMutation(baseOptions?: Apollo.MutationHookOptions<ParticipantRsvpMutation, ParticipantRsvpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ParticipantRsvpMutation, ParticipantRsvpMutationVariables>(ParticipantRsvpDocument, options);
      }
export type ParticipantRsvpMutationHookResult = ReturnType<typeof useParticipantRsvpMutation>;
export type ParticipantRsvpMutationResult = Apollo.MutationResult<ParticipantRsvpMutation>;
export type ParticipantRsvpMutationOptions = Apollo.BaseMutationOptions<ParticipantRsvpMutation, ParticipantRsvpMutationVariables>;
export const ParticipantAppointmentsDocument = gql`
    query ParticipantAppointments($from: DateTimeFromTz, $status: [AppointmentStatusEnum]) {
  patientAppointmentRequests {
    id
    start_time
    planned_end_time
    created_at
    message
    service {
      id
      name
      price
      duration
    }
    host {
      id
      name
      avatar_url
    }
  }
  appointments(from: $from, status: $status) {
    id
    start_time
    status
    planned_end_time
    message
    service {
      id
      name
      price
      booking_color
      duration
    }
    host {
      id
      name
      avatar_url
    }
    participants {
      id
      rsvp
      is_in_meeting
      user {
        id
        name
        email
      }
      document_submissions {
        id
        fields
        status
        signed_by_current_user
        submitted_at
        document {
          id
          name
          requirement
          signature_type
        }
      }
      join_url
      join_app_url
    }
    invoices {
      id
      amount
      status
    }
  }
}
    `;

/**
 * __useParticipantAppointmentsQuery__
 *
 * To run a query within a React component, call `useParticipantAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantAppointmentsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useParticipantAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<ParticipantAppointmentsQuery, ParticipantAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantAppointmentsQuery, ParticipantAppointmentsQueryVariables>(ParticipantAppointmentsDocument, options);
      }
export function useParticipantAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantAppointmentsQuery, ParticipantAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantAppointmentsQuery, ParticipantAppointmentsQueryVariables>(ParticipantAppointmentsDocument, options);
        }
export type ParticipantAppointmentsQueryHookResult = ReturnType<typeof useParticipantAppointmentsQuery>;
export type ParticipantAppointmentsLazyQueryHookResult = ReturnType<typeof useParticipantAppointmentsLazyQuery>;
export type ParticipantAppointmentsQueryResult = Apollo.QueryResult<ParticipantAppointmentsQuery, ParticipantAppointmentsQueryVariables>;
export const HostDocumentSignedDocument = gql`
    subscription HostDocumentSigned($orgId: ID!) {
  hostDocumentSigned(org_id: $orgId)
}
    `;

/**
 * __useHostDocumentSignedSubscription__
 *
 * To run a query within a React component, call `useHostDocumentSignedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useHostDocumentSignedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHostDocumentSignedSubscription({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useHostDocumentSignedSubscription(baseOptions: Apollo.SubscriptionHookOptions<HostDocumentSignedSubscription, HostDocumentSignedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<HostDocumentSignedSubscription, HostDocumentSignedSubscriptionVariables>(HostDocumentSignedDocument, options);
      }
export type HostDocumentSignedSubscriptionHookResult = ReturnType<typeof useHostDocumentSignedSubscription>;
export type HostDocumentSignedSubscriptionResult = Apollo.SubscriptionResult<HostDocumentSignedSubscription>;
export const AppointmentsHistoryDocument = gql`
    query AppointmentsHistory($status: [AppointmentStatusEnum], $first: Int!, $after: String) {
  appointmentsConnection(status: $status, first: $first, after: $after) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        start_time
        planned_end_time
        started_at
        ended_at
        service {
          id
          name
          price
          booking_color
        }
        host {
          id
          name
          avatar_url
        }
        participants {
          id
          rsvp
          is_in_meeting
          user {
            id
            name
            email
          }
          document_submissions {
            id
            fields
            status
            signed_by_current_user
            document {
              id
              name
              requirement
            }
          }
          join_url
        }
      }
    }
  }
}
    `;

/**
 * __useAppointmentsHistoryQuery__
 *
 * To run a query within a React component, call `useAppointmentsHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useAppointmentsHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAppointmentsHistoryQuery({
 *   variables: {
 *      status: // value for 'status'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useAppointmentsHistoryQuery(baseOptions: Apollo.QueryHookOptions<AppointmentsHistoryQuery, AppointmentsHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AppointmentsHistoryQuery, AppointmentsHistoryQueryVariables>(AppointmentsHistoryDocument, options);
      }
export function useAppointmentsHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AppointmentsHistoryQuery, AppointmentsHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AppointmentsHistoryQuery, AppointmentsHistoryQueryVariables>(AppointmentsHistoryDocument, options);
        }
export type AppointmentsHistoryQueryHookResult = ReturnType<typeof useAppointmentsHistoryQuery>;
export type AppointmentsHistoryLazyQueryHookResult = ReturnType<typeof useAppointmentsHistoryLazyQuery>;
export type AppointmentsHistoryQueryResult = Apollo.QueryResult<AppointmentsHistoryQuery, AppointmentsHistoryQueryVariables>;
export const CreatePatientDocument = gql`
    mutation CreatePatient($input: CreatePatientInput!) {
  createPatient(input: $input) {
    id
    name
    email
    sms
    phone
    timezone
    roles {
      id
      name
    }
    default_notification_channel
  }
}
    `;
export type CreatePatientMutationFn = Apollo.MutationFunction<CreatePatientMutation, CreatePatientMutationVariables>;

/**
 * __useCreatePatientMutation__
 *
 * To run a mutation, you first call `useCreatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPatientMutation, { data, loading, error }] = useCreatePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePatientMutation(baseOptions?: Apollo.MutationHookOptions<CreatePatientMutation, CreatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePatientMutation, CreatePatientMutationVariables>(CreatePatientDocument, options);
      }
export type CreatePatientMutationHookResult = ReturnType<typeof useCreatePatientMutation>;
export type CreatePatientMutationResult = Apollo.MutationResult<CreatePatientMutation>;
export type CreatePatientMutationOptions = Apollo.BaseMutationOptions<CreatePatientMutation, CreatePatientMutationVariables>;
export const UpdatePatientDocument = gql`
    mutation UpdatePatient($input: UpdatePatientInput!) {
  updatePatient(input: $input) {
    id
    name
    email
    phone
    timezone
    default_notification_channel
  }
}
    `;
export type UpdatePatientMutationFn = Apollo.MutationFunction<UpdatePatientMutation, UpdatePatientMutationVariables>;

/**
 * __useUpdatePatientMutation__
 *
 * To run a mutation, you first call `useUpdatePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePatientMutation, { data, loading, error }] = useUpdatePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePatientMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePatientMutation, UpdatePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePatientMutation, UpdatePatientMutationVariables>(UpdatePatientDocument, options);
      }
export type UpdatePatientMutationHookResult = ReturnType<typeof useUpdatePatientMutation>;
export type UpdatePatientMutationResult = Apollo.MutationResult<UpdatePatientMutation>;
export type UpdatePatientMutationOptions = Apollo.BaseMutationOptions<UpdatePatientMutation, UpdatePatientMutationVariables>;
export const PatientListDocument = gql`
    query PatientList($first: Int!, $page: Int!, $where: QueryPatientsWhereWhereConditions, $orderBy: [QueryPatientsOrderByOrderByClause!]) {
  patients(first: $first, page: $page, where: $where, orderBy: $orderBy) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      name
      email
      timezone
      phone
    }
  }
}
    `;

/**
 * __usePatientListQuery__
 *
 * To run a query within a React component, call `usePatientListQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function usePatientListQuery(baseOptions: Apollo.QueryHookOptions<PatientListQuery, PatientListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientListQuery, PatientListQueryVariables>(PatientListDocument, options);
      }
export function usePatientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientListQuery, PatientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientListQuery, PatientListQueryVariables>(PatientListDocument, options);
        }
export type PatientListQueryHookResult = ReturnType<typeof usePatientListQuery>;
export type PatientListLazyQueryHookResult = ReturnType<typeof usePatientListLazyQuery>;
export type PatientListQueryResult = Apollo.QueryResult<PatientListQuery, PatientListQueryVariables>;
export const GetPatientDocument = gql`
    query GetPatient($id: ID!) {
  patient(id: $id) {
    id
    name
    email
    phone
    roles {
      id
      name
    }
    timezone
    is_global
    notes {
      id
      content
      created_at
      appointment {
        id
        start_time
      }
    }
  }
}
    `;

/**
 * __useGetPatientQuery__
 *
 * To run a query within a React component, call `useGetPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPatientQuery(baseOptions: Apollo.QueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
      }
export function useGetPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPatientQuery, GetPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPatientQuery, GetPatientQueryVariables>(GetPatientDocument, options);
        }
export type GetPatientQueryHookResult = ReturnType<typeof useGetPatientQuery>;
export type GetPatientLazyQueryHookResult = ReturnType<typeof useGetPatientLazyQuery>;
export type GetPatientQueryResult = Apollo.QueryResult<GetPatientQuery, GetPatientQueryVariables>;
export const RetrieveOrganizationInvoicesDocument = gql`
    query retrieveOrganizationInvoices($first: Int!, $page: Int!, $hasParticipant: QueryInvoicesHasParticipantWhereHasConditions, $where: QueryInvoicesWhereWhereConditions, $orderBy: [QueryInvoicesOrderByOrderByClause!]) {
  invoices(
    first: $first
    page: $page
    hasParticipant: $hasParticipant
    where: $where
    orderBy: $orderBy
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      amount
      status
      participant {
        appointment {
          id
        }
        user {
          id
          name
          email
          phone
          sms
        }
      }
      data
    }
  }
}
    `;

/**
 * __useRetrieveOrganizationInvoicesQuery__
 *
 * To run a query within a React component, call `useRetrieveOrganizationInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveOrganizationInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveOrganizationInvoicesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      hasParticipant: // value for 'hasParticipant'
 *      where: // value for 'where'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useRetrieveOrganizationInvoicesQuery(baseOptions: Apollo.QueryHookOptions<RetrieveOrganizationInvoicesQuery, RetrieveOrganizationInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveOrganizationInvoicesQuery, RetrieveOrganizationInvoicesQueryVariables>(RetrieveOrganizationInvoicesDocument, options);
      }
export function useRetrieveOrganizationInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveOrganizationInvoicesQuery, RetrieveOrganizationInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveOrganizationInvoicesQuery, RetrieveOrganizationInvoicesQueryVariables>(RetrieveOrganizationInvoicesDocument, options);
        }
export type RetrieveOrganizationInvoicesQueryHookResult = ReturnType<typeof useRetrieveOrganizationInvoicesQuery>;
export type RetrieveOrganizationInvoicesLazyQueryHookResult = ReturnType<typeof useRetrieveOrganizationInvoicesLazyQuery>;
export type RetrieveOrganizationInvoicesQueryResult = Apollo.QueryResult<RetrieveOrganizationInvoicesQuery, RetrieveOrganizationInvoicesQueryVariables>;
export const ProviderUserDocument = gql`
    query ProviderUser($id: ID!) {
  user(id: $id) {
    id
    name
    email
    phone
    timezone
    enable_ondemand
    avatar_url
  }
}
    `;

/**
 * __useProviderUserQuery__
 *
 * To run a query within a React component, call `useProviderUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProviderUserQuery(baseOptions: Apollo.QueryHookOptions<ProviderUserQuery, ProviderUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProviderUserQuery, ProviderUserQueryVariables>(ProviderUserDocument, options);
      }
export function useProviderUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProviderUserQuery, ProviderUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProviderUserQuery, ProviderUserQueryVariables>(ProviderUserDocument, options);
        }
export type ProviderUserQueryHookResult = ReturnType<typeof useProviderUserQuery>;
export type ProviderUserLazyQueryHookResult = ReturnType<typeof useProviderUserLazyQuery>;
export type ProviderUserQueryResult = Apollo.QueryResult<ProviderUserQuery, ProviderUserQueryVariables>;
export const GetLoginsDocument = gql`
    query getLogins($userId: ID, $searchTerm: String, $first: Int!, $page: Int, $orderBy: [QueryLoginReportsOrderByOrderByClause!]) {
  loginReports(
    userId: $userId
    searchTerm: $searchTerm
    first: $first
    page: $page
    orderBy: $orderBy
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      loginDateTime
      userName
      email
      action
      ip
    }
  }
}
    `;

/**
 * __useGetLoginsQuery__
 *
 * To run a query within a React component, call `useGetLoginsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLoginsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLoginsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      searchTerm: // value for 'searchTerm'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetLoginsQuery(baseOptions: Apollo.QueryHookOptions<GetLoginsQuery, GetLoginsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLoginsQuery, GetLoginsQueryVariables>(GetLoginsDocument, options);
      }
export function useGetLoginsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLoginsQuery, GetLoginsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLoginsQuery, GetLoginsQueryVariables>(GetLoginsDocument, options);
        }
export type GetLoginsQueryHookResult = ReturnType<typeof useGetLoginsQuery>;
export type GetLoginsLazyQueryHookResult = ReturnType<typeof useGetLoginsLazyQuery>;
export type GetLoginsQueryResult = Apollo.QueryResult<GetLoginsQuery, GetLoginsQueryVariables>;
export const ReportHostsDocument = gql`
    query ReportHosts($first: Int) {
  users(hasRoles: {value: "Patient", operator: NEQ, column: NAME}, first: $first) {
    data {
      id
      name
    }
  }
}
    `;

/**
 * __useReportHostsQuery__
 *
 * To run a query within a React component, call `useReportHostsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportHostsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportHostsQuery({
 *   variables: {
 *      first: // value for 'first'
 *   },
 * });
 */
export function useReportHostsQuery(baseOptions?: Apollo.QueryHookOptions<ReportHostsQuery, ReportHostsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportHostsQuery, ReportHostsQueryVariables>(ReportHostsDocument, options);
      }
export function useReportHostsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportHostsQuery, ReportHostsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportHostsQuery, ReportHostsQueryVariables>(ReportHostsDocument, options);
        }
export type ReportHostsQueryHookResult = ReturnType<typeof useReportHostsQuery>;
export type ReportHostsLazyQueryHookResult = ReturnType<typeof useReportHostsLazyQuery>;
export type ReportHostsQueryResult = Apollo.QueryResult<ReportHostsQuery, ReportHostsQueryVariables>;
export const ParticipantExportDocument = gql`
    query ParticipantExport($participantId: ID!, $extension: String, $browser_identifier: String!) {
  participantExport(
    participant_id: $participantId
    extension: $extension
    browser_identifier: $browser_identifier
  )
}
    `;

/**
 * __useParticipantExportQuery__
 *
 * To run a query within a React component, call `useParticipantExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useParticipantExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useParticipantExportQuery({
 *   variables: {
 *      participantId: // value for 'participantId'
 *      extension: // value for 'extension'
 *      browser_identifier: // value for 'browser_identifier'
 *   },
 * });
 */
export function useParticipantExportQuery(baseOptions: Apollo.QueryHookOptions<ParticipantExportQuery, ParticipantExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ParticipantExportQuery, ParticipantExportQueryVariables>(ParticipantExportDocument, options);
      }
export function useParticipantExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ParticipantExportQuery, ParticipantExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ParticipantExportQuery, ParticipantExportQueryVariables>(ParticipantExportDocument, options);
        }
export type ParticipantExportQueryHookResult = ReturnType<typeof useParticipantExportQuery>;
export type ParticipantExportLazyQueryHookResult = ReturnType<typeof useParticipantExportLazyQuery>;
export type ParticipantExportQueryResult = Apollo.QueryResult<ParticipantExportQuery, ParticipantExportQueryVariables>;
export const SessionsExportDocument = gql`
    query SessionsExport($first: Int, $page: Int, $sessionId: ID, $hostId: ID, $participantIds: [ID], $sessionType: SessionTypeEnum, $fromDate: DateTimeFromTz, $toDate: DateTimeFromTz, $orderBy: [QuerySessionsExportOrderByRelationOrderByClause!], $extension: String, $browser_identifier: String!) {
  sessionsExport(
    first: $first
    page: $page
    session_id: $sessionId
    host_id: $hostId
    participant_ids: $participantIds
    session_type: $sessionType
    from_date: $fromDate
    to_date: $toDate
    order_by: $orderBy
    extension: $extension
    browser_identifier: $browser_identifier
  )
}
    `;

/**
 * __useSessionsExportQuery__
 *
 * To run a query within a React component, call `useSessionsExportQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionsExportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionsExportQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      sessionId: // value for 'sessionId'
 *      hostId: // value for 'hostId'
 *      participantIds: // value for 'participantIds'
 *      sessionType: // value for 'sessionType'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      orderBy: // value for 'orderBy'
 *      extension: // value for 'extension'
 *      browser_identifier: // value for 'browser_identifier'
 *   },
 * });
 */
export function useSessionsExportQuery(baseOptions: Apollo.QueryHookOptions<SessionsExportQuery, SessionsExportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionsExportQuery, SessionsExportQueryVariables>(SessionsExportDocument, options);
      }
export function useSessionsExportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionsExportQuery, SessionsExportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionsExportQuery, SessionsExportQueryVariables>(SessionsExportDocument, options);
        }
export type SessionsExportQueryHookResult = ReturnType<typeof useSessionsExportQuery>;
export type SessionsExportLazyQueryHookResult = ReturnType<typeof useSessionsExportLazyQuery>;
export type SessionsExportQueryResult = Apollo.QueryResult<SessionsExportQuery, SessionsExportQueryVariables>;
export const GetSessionUsageDocument = gql`
    query getSessionUsage($hostId: Int, $sessionType: SessionTypeEnum!, $fromDate: DateTimeFromTz!, $toDate: DateTimeFromTz!, $first: Int!, $page: Int, $orderBy: [QuerySessionsOrderByRelationOrderByClause!], $search: String) {
  sessions(
    host_id: $hostId
    session_type: $sessionType
    from_date: $fromDate
    to_date: $toDate
    first: $first
    page: $page
    order_by: $orderBy
    search: $search
  ) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      started_at
      duration
      host {
        id
        name
      }
      participants {
        id
        user {
          id
          name
        }
      }
      service {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetSessionUsageQuery__
 *
 * To run a query within a React component, call `useGetSessionUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSessionUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSessionUsageQuery({
 *   variables: {
 *      hostId: // value for 'hostId'
 *      sessionType: // value for 'sessionType'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *      first: // value for 'first'
 *      page: // value for 'page'
 *      orderBy: // value for 'orderBy'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetSessionUsageQuery(baseOptions: Apollo.QueryHookOptions<GetSessionUsageQuery, GetSessionUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSessionUsageQuery, GetSessionUsageQueryVariables>(GetSessionUsageDocument, options);
      }
export function useGetSessionUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSessionUsageQuery, GetSessionUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSessionUsageQuery, GetSessionUsageQueryVariables>(GetSessionUsageDocument, options);
        }
export type GetSessionUsageQueryHookResult = ReturnType<typeof useGetSessionUsageQuery>;
export type GetSessionUsageLazyQueryHookResult = ReturnType<typeof useGetSessionUsageLazyQuery>;
export type GetSessionUsageQueryResult = Apollo.QueryResult<GetSessionUsageQuery, GetSessionUsageQueryVariables>;
export const CreateServiceDocument = gql`
    mutation CreateService($input: ServiceInput!) {
  createService(input: $input) {
    id
    name
    duration
    can_be_scheduled
    price
    booking_on_demand
    booking_color
  }
}
    `;
export type CreateServiceMutationFn = Apollo.MutationFunction<CreateServiceMutation, CreateServiceMutationVariables>;

/**
 * __useCreateServiceMutation__
 *
 * To run a mutation, you first call `useCreateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceMutation, { data, loading, error }] = useCreateServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateServiceMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceMutation, CreateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceMutation, CreateServiceMutationVariables>(CreateServiceDocument, options);
      }
export type CreateServiceMutationHookResult = ReturnType<typeof useCreateServiceMutation>;
export type CreateServiceMutationResult = Apollo.MutationResult<CreateServiceMutation>;
export type CreateServiceMutationOptions = Apollo.BaseMutationOptions<CreateServiceMutation, CreateServiceMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation DeleteService($id: ID!) {
  deleteService(id: $id)
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation UpdateService($id: ID!, $input: ServiceInput!) {
  updateService(id: $id, input: $input) {
    id
    name
    price
    duration
    description
    can_be_scheduled
    booking_on_demand
    practitioners {
      id
      name
    }
    booking_color
  }
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const GetServiceDocument = gql`
    query GetService($id: ID!) {
  service(id: $id) {
    id
    name
    price
    duration
    description
    can_be_scheduled
    booking_on_demand
    practitioners {
      id
      name
    }
    booking_color
  }
}
    `;

/**
 * __useGetServiceQuery__
 *
 * To run a query within a React component, call `useGetServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceQuery(baseOptions: Apollo.QueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
      }
export function useGetServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceQuery, GetServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceQuery, GetServiceQueryVariables>(GetServiceDocument, options);
        }
export type GetServiceQueryHookResult = ReturnType<typeof useGetServiceQuery>;
export type GetServiceLazyQueryHookResult = ReturnType<typeof useGetServiceLazyQuery>;
export type GetServiceQueryResult = Apollo.QueryResult<GetServiceQuery, GetServiceQueryVariables>;
export const CreateServicePractitionerListDocument = gql`
    query CreateServicePractitionerList($first: Int!, $page: Int!) {
  users(
    first: $first
    page: $page
    hasRoles: {column: NAME, value: "Practitioner"}
  ) {
    data {
      id
      name
      email
    }
  }
}
    `;

/**
 * __useCreateServicePractitionerListQuery__
 *
 * To run a query within a React component, call `useCreateServicePractitionerListQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateServicePractitionerListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateServicePractitionerListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useCreateServicePractitionerListQuery(baseOptions: Apollo.QueryHookOptions<CreateServicePractitionerListQuery, CreateServicePractitionerListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateServicePractitionerListQuery, CreateServicePractitionerListQueryVariables>(CreateServicePractitionerListDocument, options);
      }
export function useCreateServicePractitionerListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateServicePractitionerListQuery, CreateServicePractitionerListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateServicePractitionerListQuery, CreateServicePractitionerListQueryVariables>(CreateServicePractitionerListDocument, options);
        }
export type CreateServicePractitionerListQueryHookResult = ReturnType<typeof useCreateServicePractitionerListQuery>;
export type CreateServicePractitionerListLazyQueryHookResult = ReturnType<typeof useCreateServicePractitionerListLazyQuery>;
export type CreateServicePractitionerListQueryResult = Apollo.QueryResult<CreateServicePractitionerListQuery, CreateServicePractitionerListQueryVariables>;
export const ServiceListDocument = gql`
    query ServiceList($first: Int!, $page: Int!) {
  services(first: $first, page: $page) {
    paginatorInfo {
      currentPage
      total
    }
    data {
      id
      name
      price
      duration
    }
  }
}
    `;

/**
 * __useServiceListQuery__
 *
 * To run a query within a React component, call `useServiceListQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useServiceListQuery(baseOptions: Apollo.QueryHookOptions<ServiceListQuery, ServiceListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceListQuery, ServiceListQueryVariables>(ServiceListDocument, options);
      }
export function useServiceListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceListQuery, ServiceListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceListQuery, ServiceListQueryVariables>(ServiceListDocument, options);
        }
export type ServiceListQueryHookResult = ReturnType<typeof useServiceListQuery>;
export type ServiceListLazyQueryHookResult = ReturnType<typeof useServiceListLazyQuery>;
export type ServiceListQueryResult = Apollo.QueryResult<ServiceListQuery, ServiceListQueryVariables>;
export const GenerateOpentokTokenDocument = gql`
    mutation GenerateOpentokToken($appointment_id: ID!) {
  generateOpentokToken(appointment_id: $appointment_id) {
    sid
    token
  }
}
    `;
export type GenerateOpentokTokenMutationFn = Apollo.MutationFunction<GenerateOpentokTokenMutation, GenerateOpentokTokenMutationVariables>;

/**
 * __useGenerateOpentokTokenMutation__
 *
 * To run a mutation, you first call `useGenerateOpentokTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOpentokTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOpentokTokenMutation, { data, loading, error }] = useGenerateOpentokTokenMutation({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *   },
 * });
 */
export function useGenerateOpentokTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOpentokTokenMutation, GenerateOpentokTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOpentokTokenMutation, GenerateOpentokTokenMutationVariables>(GenerateOpentokTokenDocument, options);
      }
export type GenerateOpentokTokenMutationHookResult = ReturnType<typeof useGenerateOpentokTokenMutation>;
export type GenerateOpentokTokenMutationResult = Apollo.MutationResult<GenerateOpentokTokenMutation>;
export type GenerateOpentokTokenMutationOptions = Apollo.BaseMutationOptions<GenerateOpentokTokenMutation, GenerateOpentokTokenMutationVariables>;
export const GeneratePubnubKeysDocument = gql`
    mutation GeneratePubnubKeys($appointment_id: ID!) {
  generateOpentokToken(appointment_id: $appointment_id) {
    subscribe_key
    cipher_key
    channels
  }
}
    `;
export type GeneratePubnubKeysMutationFn = Apollo.MutationFunction<GeneratePubnubKeysMutation, GeneratePubnubKeysMutationVariables>;

/**
 * __useGeneratePubnubKeysMutation__
 *
 * To run a mutation, you first call `useGeneratePubnubKeysMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePubnubKeysMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePubnubKeysMutation, { data, loading, error }] = useGeneratePubnubKeysMutation({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *   },
 * });
 */
export function useGeneratePubnubKeysMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePubnubKeysMutation, GeneratePubnubKeysMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePubnubKeysMutation, GeneratePubnubKeysMutationVariables>(GeneratePubnubKeysDocument, options);
      }
export type GeneratePubnubKeysMutationHookResult = ReturnType<typeof useGeneratePubnubKeysMutation>;
export type GeneratePubnubKeysMutationResult = Apollo.MutationResult<GeneratePubnubKeysMutation>;
export type GeneratePubnubKeysMutationOptions = Apollo.BaseMutationOptions<GeneratePubnubKeysMutation, GeneratePubnubKeysMutationVariables>;
export const PullDocument = gql`
    query Pull($input: PullInput!) {
  pull(input: $input) {
    id
    data
  }
}
    `;

/**
 * __usePullQuery__
 *
 * To run a query within a React component, call `usePullQuery` and pass it any options that fit your needs.
 * When your component renders, `usePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePullQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePullQuery(baseOptions: Apollo.QueryHookOptions<PullQuery, PullQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PullQuery, PullQueryVariables>(PullDocument, options);
      }
export function usePullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PullQuery, PullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PullQuery, PullQueryVariables>(PullDocument, options);
        }
export type PullQueryHookResult = ReturnType<typeof usePullQuery>;
export type PullLazyQueryHookResult = ReturnType<typeof usePullLazyQuery>;
export type PullQueryResult = Apollo.QueryResult<PullQuery, PullQueryVariables>;
export const SharedDataDocument = gql`
    query sharedData {
  user: me {
    id
    timezone
    name
    email
    phone
    sms
    username
    is_admin
    avatar_url
    has_medcart
    address
    zip
    birth_date
    sex
    external_calendar_connected
    device_user
    permissions {
      id
      name
    }
    roles {
      id
      name
      permissions {
        id
        name
      }
    }
    settings {
      user_id
      notify_scheduler_sessions_sms
      notify_scheduler_sessions_mail
      notify_requests_sms
      notify_requests_mail
      notify_payments_mail
      notify_payments_sms
      notify_updates_sms
      notify_updates_mail
      notify_chat_sms
      notify_chat_mail
      notify_chat_new_chat
      notify_chat_messages
      notify_chat_documents
      notify_docs_sms
      notify_docs_mail
      notify_docs_required
      notify_docs_not_required
      notify_docs_resubmissions
      notify_docs_signed
    }
  }
}
    `;

/**
 * __useSharedDataQuery__
 *
 * To run a query within a React component, call `useSharedDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharedDataQuery(baseOptions?: Apollo.QueryHookOptions<SharedDataQuery, SharedDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SharedDataQuery, SharedDataQueryVariables>(SharedDataDocument, options);
      }
export function useSharedDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SharedDataQuery, SharedDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SharedDataQuery, SharedDataQueryVariables>(SharedDataDocument, options);
        }
export type SharedDataQueryHookResult = ReturnType<typeof useSharedDataQuery>;
export type SharedDataLazyQueryHookResult = ReturnType<typeof useSharedDataLazyQuery>;
export type SharedDataQueryResult = Apollo.QueryResult<SharedDataQuery, SharedDataQueryVariables>;
export const ProvidersForLocationDocument = gql`
    query ProvidersForLocation($id: ID!, $location: String!) {
  service(id: $id) {
    id
    practitioners(location: $location) {
      id
      name
      email
      enable_ondemand
      avatar_url
      is_working_hours
      locations {
        id
        name
        slug
        pivot {
          primary
        }
        group {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useProvidersForLocationQuery__
 *
 * To run a query within a React component, call `useProvidersForLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useProvidersForLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProvidersForLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useProvidersForLocationQuery(baseOptions: Apollo.QueryHookOptions<ProvidersForLocationQuery, ProvidersForLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProvidersForLocationQuery, ProvidersForLocationQueryVariables>(ProvidersForLocationDocument, options);
      }
export function useProvidersForLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProvidersForLocationQuery, ProvidersForLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProvidersForLocationQuery, ProvidersForLocationQueryVariables>(ProvidersForLocationDocument, options);
        }
export type ProvidersForLocationQueryHookResult = ReturnType<typeof useProvidersForLocationQuery>;
export type ProvidersForLocationLazyQueryHookResult = ReturnType<typeof useProvidersForLocationLazyQuery>;
export type ProvidersForLocationQueryResult = Apollo.QueryResult<ProvidersForLocationQuery, ProvidersForLocationQueryVariables>;
export const RegisterPatientDocument = gql`
    mutation RegisterPatient($input: CreatePatientInput!) {
  createPatient(input: $input) {
    id
    email
  }
}
    `;
export type RegisterPatientMutationFn = Apollo.MutationFunction<RegisterPatientMutation, RegisterPatientMutationVariables>;

/**
 * __useRegisterPatientMutation__
 *
 * To run a mutation, you first call `useRegisterPatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPatientMutation, { data, loading, error }] = useRegisterPatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRegisterPatientMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPatientMutation, RegisterPatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPatientMutation, RegisterPatientMutationVariables>(RegisterPatientDocument, options);
      }
export type RegisterPatientMutationHookResult = ReturnType<typeof useRegisterPatientMutation>;
export type RegisterPatientMutationResult = Apollo.MutationResult<RegisterPatientMutation>;
export type RegisterPatientMutationOptions = Apollo.BaseMutationOptions<RegisterPatientMutation, RegisterPatientMutationVariables>;
export const InvoiceDocument = gql`
    query Invoice($appointment_id: ID!) {
  invoice(appointment_id: $appointment_id) {
    id
    status
    data
  }
}
    `;

/**
 * __useInvoiceQuery__
 *
 * To run a query within a React component, call `useInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInvoiceQuery({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *   },
 * });
 */
export function useInvoiceQuery(baseOptions: Apollo.QueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
      }
export function useInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InvoiceQuery, InvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InvoiceQuery, InvoiceQueryVariables>(InvoiceDocument, options);
        }
export type InvoiceQueryHookResult = ReturnType<typeof useInvoiceQuery>;
export type InvoiceLazyQueryHookResult = ReturnType<typeof useInvoiceLazyQuery>;
export type InvoiceQueryResult = Apollo.QueryResult<InvoiceQuery, InvoiceQueryVariables>;
export const RetrieveInvoiceDocument = gql`
    query retrieveInvoice($appointment_id: ID!) {
  retrieveInvoice(appointment_id: $appointment_id) {
    client_secret
    amount
    currency
    status
  }
}
    `;

/**
 * __useRetrieveInvoiceQuery__
 *
 * To run a query within a React component, call `useRetrieveInvoiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveInvoiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveInvoiceQuery({
 *   variables: {
 *      appointment_id: // value for 'appointment_id'
 *   },
 * });
 */
export function useRetrieveInvoiceQuery(baseOptions: Apollo.QueryHookOptions<RetrieveInvoiceQuery, RetrieveInvoiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RetrieveInvoiceQuery, RetrieveInvoiceQueryVariables>(RetrieveInvoiceDocument, options);
      }
export function useRetrieveInvoiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RetrieveInvoiceQuery, RetrieveInvoiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RetrieveInvoiceQuery, RetrieveInvoiceQueryVariables>(RetrieveInvoiceDocument, options);
        }
export type RetrieveInvoiceQueryHookResult = ReturnType<typeof useRetrieveInvoiceQuery>;
export type RetrieveInvoiceLazyQueryHookResult = ReturnType<typeof useRetrieveInvoiceLazyQuery>;
export type RetrieveInvoiceQueryResult = Apollo.QueryResult<RetrieveInvoiceQuery, RetrieveInvoiceQueryVariables>;
export const SearchContactsDocument = gql`
    query SearchContacts($search: String, $exclude: [ID!], $first: Int!, $after: String) {
  contacts(first: $first, exclude: $exclude, search: $search, after: $after) {
    pageInfo {
      hasNextPage
      count
      endCursor
      startCursor
    }
    edges {
      cursor
      node {
        id
        name
        email
        username
        avatar_url
        enable_ondemand
        roles {
          id
          name
        }
      }
    }
  }
}
    `;

/**
 * __useSearchContactsQuery__
 *
 * To run a query within a React component, call `useSearchContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchContactsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      exclude: // value for 'exclude'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchContactsQuery(baseOptions: Apollo.QueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
      }
export function useSearchContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchContactsQuery, SearchContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchContactsQuery, SearchContactsQueryVariables>(SearchContactsDocument, options);
        }
export type SearchContactsQueryHookResult = ReturnType<typeof useSearchContactsQuery>;
export type SearchContactsLazyQueryHookResult = ReturnType<typeof useSearchContactsLazyQuery>;
export type SearchContactsQueryResult = Apollo.QueryResult<SearchContactsQuery, SearchContactsQueryVariables>;